/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Madlen API
 * This API exposes endpoints to manage madlen.
 * OpenAPI spec version: 1.27.11
 */
export type RemoveStudentsFromClassroomInTeacherController200 = {
  [key: string]: number[];
};

export type GetUserAiAssessmentScalesParams = {
  page?: number;
  size?: number;
};

export type GetRecentAiAssessmentScalesParams = {
  page?: number;
  size?: number;
};

export type GetTopAiAssessmentScalesParams = {
  page?: number;
  size?: number;
};

export type GetUserAiAssignmentsParams = {
  page?: number;
  size?: number;
};

export type GetRecentAiAssignmentsParams = {
  page?: number;
  size?: number;
};

export type GetTopAiAssignmentsParams = {
  page?: number;
  size?: number;
};

export type GetUserAiResistantHomeworkParams = {
  page?: number;
  size?: number;
};

export type GetRecentAiResistantHomeworkParams = {
  page?: number;
  size?: number;
};

export type GetTopAiResistantHomeworkParams = {
  page?: number;
  size?: number;
};

export type GetUserAiSupportedTasksParams = {
  page?: number;
  size?: number;
};

export type GetRecentAiSupportedTasksParams = {
  page?: number;
  size?: number;
};

export type GetTopAiSupportedTasksParams = {
  page?: number;
  size?: number;
};

export type GetUserArticleGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetRecentArticleGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetTopArticleGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetAnswerFeedback1200 =
  | FillTheBlankQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
  | MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
  | OpenEndedQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
  | TestQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
  | TrueFalseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto;

export type GetAuditsAdminDirection =
  (typeof GetAuditsAdminDirection)[keyof typeof GetAuditsAdminDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAuditsAdminDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetAuditsAdminParams = {
  page?: number;
  size?: number;
  direction?: GetAuditsAdminDirection;
  userId?: number;
  createdAtAfterThanMillis?: number;
  hideFields?: string[];
};

export type GetMostSeenBlogsParams = {
  startDate?: string;
  page?: number;
  size?: number;
};

export type GetUserBloomsTaxonomyActivitiesParams = {
  page?: number;
  size?: number;
};

export type GetRecentBloomsTaxonomyActivitiesParams = {
  page?: number;
  size?: number;
};

export type GetTopBloomsTaxonomyActivitiesParams = {
  page?: number;
  size?: number;
};

export type GetAllChatsWithFileSystemParams = {
  parentFolderId?: number;
};

export type GetAllChatsDirection =
  (typeof GetAllChatsDirection)[keyof typeof GetAllChatsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAllChatsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetAllChatsParams = {
  direction?: GetAllChatsDirection;
  page?: number;
  size?: number;
};

export type GetDidacticChatDirection =
  (typeof GetDidacticChatDirection)[keyof typeof GetDidacticChatDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDidacticChatDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetDidacticChatParams = {
  direction?: GetDidacticChatDirection;
  page?: number;
  size?: number;
};

export type GetDidacticChatsDirection =
  (typeof GetDidacticChatsDirection)[keyof typeof GetDidacticChatsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDidacticChatsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetDidacticChatsParams = {
  direction?: GetDidacticChatsDirection;
  page?: number;
  size?: number;
};

export type GetQuestionSolverChatsDirection =
  (typeof GetQuestionSolverChatsDirection)[keyof typeof GetQuestionSolverChatsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuestionSolverChatsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetQuestionSolverChatsParams = {
  direction?: GetQuestionSolverChatsDirection;
  page?: number;
  size?: number;
};

export type GetChatsDirection =
  (typeof GetChatsDirection)[keyof typeof GetChatsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChatsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetChatsParams = {
  direction?: GetChatsDirection;
  page?: number;
  size?: number;
};

export type GetUserChoiceBoardsParams = {
  page?: number;
  size?: number;
};

export type GetRecentChoiceBoardsParams = {
  page?: number;
  size?: number;
};

export type GetTopChoiceBoardsParams = {
  page?: number;
  size?: number;
};

export type GetUserClassroomManagementsParams = {
  page?: number;
  size?: number;
};

export type GetRecentClassroomManagementsParams = {
  page?: number;
  size?: number;
};

export type GetTopClassroomManagementsParams = {
  page?: number;
  size?: number;
};

export type GetUserCollaborativeGroupWorksParams = {
  page?: number;
  size?: number;
};

export type GetRecentCollaborativeGroupWorksParams = {
  page?: number;
  size?: number;
};

export type GetTopCollaborativeGroupWorksParams = {
  page?: number;
  size?: number;
};

export type GetUserCommonMisconceptionsParams = {
  page?: number;
  size?: number;
};

export type GetRecentCommonMisconceptionsParams = {
  page?: number;
  size?: number;
};

export type GetTopCommonMisconceptionsParams = {
  page?: number;
  size?: number;
};

export type GetUserConceptualUnderstandingsParams = {
  page?: number;
  size?: number;
};

export type GetRecentConceptualUnderstandingsParams = {
  page?: number;
  size?: number;
};

export type GetTopConceptualUnderstandingsParams = {
  page?: number;
  size?: number;
};

export type GetDailyAssignments1Params = {
  grade: number;
};

export type GetDidacticTopicsCourseType =
  (typeof GetDidacticTopicsCourseType)[keyof typeof GetDidacticTopicsCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDidacticTopicsCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetDidacticTopicsParams = {
  grade?: number;
  courseType?: GetDidacticTopicsCourseType;
  language?: string;
};

export type HandleCallbackParams = {
  code?: string;
  state?: string;
};

export type GetAvailableRubricsParams = {
  page?: number;
  size?: number;
};

export type GetSubmissionsForAssignmentParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetMySubmissionsParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetUserEssentialQuestionsParams = {
  page?: number;
  size?: number;
};

export type GetRecentEssentialQuestionsParams = {
  page?: number;
  size?: number;
};

export type GetTopEssentialQuestionsParams = {
  page?: number;
  size?: number;
};

export type GetUserExitTicketGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetRecentExitTicketGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetTopExitTicketGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetFavouriteChatsCourseTypeItem =
  (typeof GetFavouriteChatsCourseTypeItem)[keyof typeof GetFavouriteChatsCourseTypeItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFavouriteChatsCourseTypeItem = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetFavouriteChatsParams = {
  title?: string;
  courseType?: GetFavouriteChatsCourseTypeItem[];
  beginningDate?: string;
  endDate?: string;
  page?: number;
  size?: number;
};

export type GetFavouriteChatMessagesCourseTypeItem =
  (typeof GetFavouriteChatMessagesCourseTypeItem)[keyof typeof GetFavouriteChatMessagesCourseTypeItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFavouriteChatMessagesCourseTypeItem = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetFavouriteChatMessagesParams = {
  content?: string;
  courseType?: GetFavouriteChatMessagesCourseTypeItem[];
  beginningDate?: string;
  endDate?: string;
  page?: number;
  size?: number;
};

export type GetUserFormativeAssessmentsParams = {
  page?: number;
  size?: number;
};

export type GetRecentFormativeAssessmentsParams = {
  page?: number;
  size?: number;
};

export type GetTopFormativeAssessmentsParams = {
  page?: number;
  size?: number;
};

export type GetDriveFilesParams = {
  page?: number;
  size?: number;
  searchQuery?: string;
  maxBytesSize?: number;
};

export type GetVideosAndPdfFromGoogleDriveParams = {
  page?: number;
  size?: number;
  searchQuery?: string;
  maxBytesSize?: number;
};

export type GetVideosFromGoogleDriveParams = {
  page?: number;
  size?: number;
  searchQuery?: string;
  maxBytesSize?: number;
};

export type Oauth2callbackParams = {
  code: string;
  state: string;
  scope: string;
};

export type GetUserHomeworkIdeasParams = {
  page?: number;
  size?: number;
};

export type GetRecentHomeworkIdeasParams = {
  page?: number;
  size?: number;
};

export type GetTopHomeworkIdeasParams = {
  page?: number;
  size?: number;
};

export type GetUserImageGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetRecentImageGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetTopImageGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetLearningOutcomesCourseType =
  (typeof GetLearningOutcomesCourseType)[keyof typeof GetLearningOutcomesCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLearningOutcomesCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetLearningOutcomesParams = {
  grade?: number;
  courseType?: GetLearningOutcomesCourseType;
  language?: string;
  chapterName?: string;
};

export type GetUserLessonHooksParams = {
  page?: number;
  size?: number;
};

export type GetRecentLessonHooksParams = {
  page?: number;
  size?: number;
};

export type GetTopLessonHooksParams = {
  page?: number;
  size?: number;
};

export type GetMaarifLearningOutcomesCourseType =
  (typeof GetMaarifLearningOutcomesCourseType)[keyof typeof GetMaarifLearningOutcomesCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMaarifLearningOutcomesCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetMaarifLearningOutcomesParams = {
  grade?: number;
  courseType?: GetMaarifLearningOutcomesCourseType;
  title?: string;
};

export type GetTokenUsageAveragesOrder =
  (typeof GetTokenUsageAveragesOrder)[keyof typeof GetTokenUsageAveragesOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTokenUsageAveragesOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetTokenUsageAveragesParams = {
  jobType?: string;
  orderBy?: string;
  order?: GetTokenUsageAveragesOrder;
  from?: string;
  to?: string;
};

export type GetTokenUsagesPerUserOrder =
  (typeof GetTokenUsagesPerUserOrder)[keyof typeof GetTokenUsagesPerUserOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTokenUsagesPerUserOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetTokenUsagesPerUserParams = {
  orderBy?: string;
  order?: GetTokenUsagesPerUserOrder;
  createdAtAfterMillis?: number;
  createdBeforeMillis?: number;
  page?: number;
  size?: number;
};

export type GetTokenUsagesOrder =
  (typeof GetTokenUsagesOrder)[keyof typeof GetTokenUsagesOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTokenUsagesOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetTokenUsagesParams = {
  jobType?: string;
  userId?: number;
  orderBy?: string;
  order?: GetTokenUsagesOrder;
  from?: string;
  to?: string;
  page?: number;
  size?: number;
};

export type GetUserMindmapGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetRecentMindmapGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetTopMindmapGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetUnreadNotificationsDirection =
  (typeof GetUnreadNotificationsDirection)[keyof typeof GetUnreadNotificationsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUnreadNotificationsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetUnreadNotificationsParams = {
  page?: number;
  direction?: GetUnreadNotificationsDirection;
  orderBy?: string;
  size?: number;
};

export type GetNotificationsDirection =
  (typeof GetNotificationsDirection)[keyof typeof GetNotificationsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNotificationsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetNotificationsParams = {
  page?: number;
  direction?: GetNotificationsDirection;
  orderBy?: string;
  size?: number;
};

export type GetAssignmentsCourseType =
  (typeof GetAssignmentsCourseType)[keyof typeof GetAssignmentsCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetAssignmentsStatus =
  (typeof GetAssignmentsStatus)[keyof typeof GetAssignmentsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  ASSIGNED: "ASSIGNED",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
} as const;

export type GetAssignmentsDirection =
  (typeof GetAssignmentsDirection)[keyof typeof GetAssignmentsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetAssignmentsParams = {
  page?: number;
  direction?: GetAssignmentsDirection;
  orderBy?: string;
  size?: number;
  teacherId?: number;
  id?: number;
  createdAtAfterMillis?: number;
  status?: GetAssignmentsStatus;
  courseType?: GetAssignmentsCourseType;
  grade?: number;
  classroomId?: number;
  createdAtBeforeMillis?: number;
};

export type CountChatsWithMessagesGreaterThanNCourseType =
  (typeof CountChatsWithMessagesGreaterThanNCourseType)[keyof typeof CountChatsWithMessagesGreaterThanNCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CountChatsWithMessagesGreaterThanNCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type CountChatsWithMessagesGreaterThanNParams = {
  messageCount?: number;
  page?: number;
  size?: number;
  courseType?: CountChatsWithMessagesGreaterThanNCourseType;
  grade?: number;
  isDeleted?: boolean;
};

export type GetMessagesAdminSender =
  (typeof GetMessagesAdminSender)[keyof typeof GetMessagesAdminSender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMessagesAdminSender = {
  AI: "AI",
  USER: "USER",
} as const;

export type GetMessagesAdminMessageContentType =
  (typeof GetMessagesAdminMessageContentType)[keyof typeof GetMessagesAdminMessageContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMessagesAdminMessageContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export type GetMessagesAdminParams = {
  id?: number;
  chatId?: number;
  createdAtAfterThanMillis?: number;
  createdAtBeforeThanMillis?: number;
  page?: number;
  size?: number;
  content?: string;
  messageContentType?: GetMessagesAdminMessageContentType;
  isFavorite?: boolean;
  sender?: GetMessagesAdminSender;
  isFailure?: boolean;
};

export type GetChatsAdminCourseType =
  (typeof GetChatsAdminCourseType)[keyof typeof GetChatsAdminCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChatsAdminCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetChatsAdminDirection =
  (typeof GetChatsAdminDirection)[keyof typeof GetChatsAdminDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChatsAdminDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetChatsAdminParams = {
  direction?: GetChatsAdminDirection;
  page?: number;
  size?: number;
  messageCount?: number;
  id?: number;
  ownerId?: number;
  createdAtAfterThanMillis?: number;
  title?: string;
  isFavorite?: boolean;
  courseType?: GetChatsAdminCourseType;
  grade?: number;
  llmModelName?: string;
  isDeleted?: boolean;
};

export type GetClassroomsWithFiltersForAdminAppParams = {
  filters: FilterRequestDto;
};

export type GetClassroomsDetailedAdminCourseType =
  (typeof GetClassroomsDetailedAdminCourseType)[keyof typeof GetClassroomsDetailedAdminCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClassroomsDetailedAdminCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetClassroomsDetailedAdminParams = {
  page?: number;
  size?: number;
  grade?: number;
  classNameLike?: string;
  courseType?: GetClassroomsDetailedAdminCourseType;
};

export type GetDailyAssignmentsCourseType =
  (typeof GetDailyAssignmentsCourseType)[keyof typeof GetDailyAssignmentsCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDailyAssignmentsCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetDailyAssignmentsParams = {
  page?: number;
  size?: number;
  grade?: number;
  from?: string;
  to?: string;
  courseType?: GetDailyAssignmentsCourseType;
  studentId?: number;
};

export type GetDashboardDataParams = {
  filters: FilterRequestDto;
};

export type GetEssayGradersAdminParams = {
  page?: number;
  size?: number;
};

export type GetAdminAppFiltersParams = {
  filters: FilterRequestDto;
};

export type GetInteractiveMaterialsParams = {
  id?: number;
  teacherId?: number;
  createdAtAfter?: number;
  createdAtBefore?: number;
  updatedAtAfter?: number;
  updatedAtBefore?: number;
  s3Url?: string;
  youtubeUrl?: string;
  title?: string;
  prompt?: string;
  contentJsonS3Url?: string;
  youtubeTitle?: string;
  youtubeThumbnailUrl?: string;
  youtubeDescription?: string;
  youtubeLengthLongerThan?: number;
  youtubeLengthShorterThan?: number;
  summary?: string;
  page?: number;
  size?: number;
  includeDeleted?: boolean;
};

export type GetLessonPlannersAdminCourseType =
  (typeof GetLessonPlannersAdminCourseType)[keyof typeof GetLessonPlannersAdminCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLessonPlannersAdminCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetLessonPlannersAdminParams = {
  name?: string;
  teacherId?: number;
  grade?: number;
  courseType?: GetLessonPlannersAdminCourseType;
  page?: number;
  size?: number;
};

export type GetQuestionSolverResponsesV2CourseType =
  (typeof GetQuestionSolverResponsesV2CourseType)[keyof typeof GetQuestionSolverResponsesV2CourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuestionSolverResponsesV2CourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetQuestionSolverResponsesV2Params = {
  courseType?: GetQuestionSolverResponsesV2CourseType;
  createdAtAfterThanMillis?: number;
  page?: number;
  size?: number;
  userId?: number;
  id?: number;
  retryCountGreaterThan?: number;
  firstStepNull?: boolean;
};

export type GetAssignmentCountByCourseTypeAndGradeParams = {
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
};

export type GetCourseGradeDistributionOfChatsParams = {
  userId?: number;
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
};

export type GetMessageCountPerChatPerCourseSender =
  (typeof GetMessageCountPerChatPerCourseSender)[keyof typeof GetMessageCountPerChatPerCourseSender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMessageCountPerChatPerCourseSender = {
  AI: "AI",
  USER: "USER",
} as const;

export type GetMessageCountPerChatPerCourseParams = {
  userId?: number;
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
  sender?: GetMessageCountPerChatPerCourseSender;
};

export type GetMessageCountPerChatSender =
  (typeof GetMessageCountPerChatSender)[keyof typeof GetMessageCountPerChatSender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMessageCountPerChatSender = {
  AI: "AI",
  USER: "USER",
} as const;

export type GetMessageCountPerChatParams = {
  userId?: number;
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
  sender?: GetMessageCountPerChatSender;
};

export type GetMessagesAveragesParams = {
  userId?: number;
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
};

export type GetQuestionSolverCourseDistributionParams = {
  userId?: number;
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
};

export type GetTeacherActivityLogParams = {
  timeFrom?: string;
  timeTo?: string;
};

export type GetTeacherActivitySummaryParams = {
  timeFrom?: string;
  timeTo?: string;
};

export type GetDailyActiveTeachersParams = {
  timeFrom?: string;
  timeTo?: string;
};

export type GetUserTop4GradesParams = {
  userId: number;
  createdAtAfterThan?: string;
};

export type GetTeacherToolsStatisticsParams = {
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
  hideTestUser?: boolean;
};

export type GetToolCountPerGradeParams = {
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
  hideTestUser?: boolean;
};

export type GetToolCountPerTypeParams = {
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
  hideTestUser?: boolean;
};

export type GetToolUsageCountsForSpecificUsersParams = {
  timeFrom?: string;
  timeTo?: string;
  schoolName?: string;
};

export type GetToolCountPerUserCountParams = {
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
  hideTestUser?: boolean;
};

export type GetActiveUserMetricsParams = {
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
};

export type GetUserGradeDistributionParams = {
  createdAtAfterThan?: string;
  createdAtBeforeThan?: string;
};

export type GetStudentsFilteredForAdminAppParams = {
  filters: FilterRequestDto;
};

export type GetStudentsGenericFilteredAdminSortDirection =
  (typeof GetStudentsGenericFilteredAdminSortDirection)[keyof typeof GetStudentsGenericFilteredAdminSortDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStudentsGenericFilteredAdminSortDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetStudentsGenericFilteredAdminParams = {
  id?: number;
  grade?: number;
  createdAtAfterThanMillis?: number;
  emailLike?: string;
  hideDeleted?: boolean;
  sortBy?: string;
  sortDirection?: GetStudentsGenericFilteredAdminSortDirection;
  page?: number;
  size?: number;
};

export type GetAssignmentsOfStudentStatus =
  (typeof GetAssignmentsOfStudentStatus)[keyof typeof GetAssignmentsOfStudentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  DID_NOT_START: "DID_NOT_START",
} as const;

export type GetAssignmentsOfStudentCourseType =
  (typeof GetAssignmentsOfStudentCourseType)[keyof typeof GetAssignmentsOfStudentCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetAssignmentsOfStudentParams = {
  page?: number;
  size?: number;
  courseType?: GetAssignmentsOfStudentCourseType;
  status?: GetAssignmentsOfStudentStatus;
};

export type GetAssignmentsOfStudentFromOrganizationAdminStatus =
  (typeof GetAssignmentsOfStudentFromOrganizationAdminStatus)[keyof typeof GetAssignmentsOfStudentFromOrganizationAdminStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromOrganizationAdminStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  DID_NOT_START: "DID_NOT_START",
} as const;

export type GetAssignmentsOfStudentFromOrganizationAdminCourseType =
  (typeof GetAssignmentsOfStudentFromOrganizationAdminCourseType)[keyof typeof GetAssignmentsOfStudentFromOrganizationAdminCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromOrganizationAdminCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetAssignmentsOfStudentFromOrganizationAdminDirection =
  (typeof GetAssignmentsOfStudentFromOrganizationAdminDirection)[keyof typeof GetAssignmentsOfStudentFromOrganizationAdminDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromOrganizationAdminDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetAssignmentsOfStudentFromOrganizationAdminParams = {
  page?: number;
  size?: number;
  direction?: GetAssignmentsOfStudentFromOrganizationAdminDirection;
  orderBy?: string;
  courseType?: GetAssignmentsOfStudentFromOrganizationAdminCourseType;
  status?: GetAssignmentsOfStudentFromOrganizationAdminStatus;
};

export type GetTeachersWithFiltersForAdminAppParams = {
  filters: FilterRequestDto;
};

export type GetAssignmentsOfTeacherParams = {
  page?: number;
  size?: number;
};

export type GetTeacherDetailParams = {
  lastDays?: number;
};

export type GetStudentsDirection =
  (typeof GetStudentsDirection)[keyof typeof GetStudentsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStudentsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetStudentsParams = {
  page?: number;
  size?: number;
  sortBy?: string;
  direction?: GetStudentsDirection;
  search?: string;
};

export type GetTeachersDirection =
  (typeof GetTeachersDirection)[keyof typeof GetTeachersDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTeachersDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetTeachersParams = {
  page?: number;
  size?: number;
  sortBy?: string;
  direction?: GetTeachersDirection;
  search?: string;
};

export type GetStudentDetailParams = {
  lastDays?: number;
};

export type GetOrganizationAdminsParams = {
  page?: number;
  size?: number;
};

export type GetAssignmentAsJSONParams = {
  showAnswers?: boolean;
};

export type GetUserPerformanceTasksParams = {
  page?: number;
  size?: number;
};

export type GetRecentPerformanceTasksParams = {
  page?: number;
  size?: number;
};

export type GetTopPerformanceTasksParams = {
  page?: number;
  size?: number;
};

export type GetUserPodcastsParams = {
  page?: number;
  size?: number;
};

export type GetRecentPodcastsParams = {
  page?: number;
  size?: number;
};

export type GetTopPodcastsParams = {
  page?: number;
  size?: number;
};

export type GetUserProjectBasedLearningsParams = {
  page?: number;
  size?: number;
};

export type GetRecentProjectBasedLearningsParams = {
  page?: number;
  size?: number;
};

export type GetTopProjectBasedLearningsParams = {
  page?: number;
  size?: number;
};

export type GetQuestionsWithFileSystemV2Params = {
  parentFolderId?: number;
};

export type ExportQuestionSolverV2Level =
  (typeof ExportQuestionSolverV2Level)[keyof typeof ExportQuestionSolverV2Level];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportQuestionSolverV2Level = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export type ExportQuestionSolverV2Params = {
  level?: ExportQuestionSolverV2Level;
};

export type GetUserRealWorldConnectionsParams = {
  page?: number;
  size?: number;
};

export type GetRecentRealWorldConnectionsParams = {
  page?: number;
  size?: number;
};

export type GetTopRealWorldConnectionsParams = {
  page?: number;
  size?: number;
};

export type GetUserRubricGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetRecentRubricGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetTopRubricGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetSketchGeneratorsParams = {
  page?: number;
  size?: number;
};

export type GetSketchGenerator1Params = {
  page?: number;
  size?: number;
};

export type GetTopSketchGeneratorParams = {
  page?: number;
  size?: number;
};

export type HandleUserInfoRequest200 = {
  [key: string]: { [key: string]: unknown };
};

export type GetAvailableCourses200Item = {
  [key: string]: { [key: string]: unknown };
};

export type GetFilesCourse =
  (typeof GetFilesCourse)[keyof typeof GetFilesCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFilesCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetFilesParams = {
  course: GetFilesCourse;
  grade: number;
};

export type GetTeacherAssignedInteractiveMaterialsParams = {
  interactiveMaterialId?: number;
};

export type GetUnifiedTasksCourseType =
  (typeof GetUnifiedTasksCourseType)[keyof typeof GetUnifiedTasksCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUnifiedTasksCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetUnifiedTasksType =
  (typeof GetUnifiedTasksType)[keyof typeof GetUnifiedTasksType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUnifiedTasksType = {
  ASSIGNMENT: "ASSIGNMENT",
  INTERACTIVE_MATERIAL: "INTERACTIVE_MATERIAL",
  PODCAST: "PODCAST",
} as const;

export type GetUnifiedTasksParams = {
  /**
   * Filter by task type
   */
  type?: GetUnifiedTasksType;
  /**
   * Filter by task status
   */
  status?: string;
  /**
   * Filter by course type
   */
  courseType?: GetUnifiedTasksCourseType;
};

export type GetAnswerFeedback200 =
  | FillTheBlankQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
  | MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
  | OpenEndedQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
  | TestQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
  | TrueFalseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto;

export type GetAssignmentsOfStudentFromStudentStatus =
  (typeof GetAssignmentsOfStudentFromStudentStatus)[keyof typeof GetAssignmentsOfStudentFromStudentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromStudentStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  DID_NOT_START: "DID_NOT_START",
} as const;

export type GetAssignmentsOfStudentFromStudentCourseType =
  (typeof GetAssignmentsOfStudentFromStudentCourseType)[keyof typeof GetAssignmentsOfStudentFromStudentCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromStudentCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetAssignmentsOfStudentFromStudentDirection =
  (typeof GetAssignmentsOfStudentFromStudentDirection)[keyof typeof GetAssignmentsOfStudentFromStudentDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromStudentDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetAssignmentsOfStudentFromStudentParams = {
  page?: number;
  size?: number;
  direction?: GetAssignmentsOfStudentFromStudentDirection;
  orderBy?: string;
  courseType?: GetAssignmentsOfStudentFromStudentCourseType;
  status?: GetAssignmentsOfStudentFromStudentStatus;
};

export type GetUserSummarizersParams = {
  page?: number;
  size?: number;
};

export type GetRecentSummarizersParams = {
  page?: number;
  size?: number;
};

export type GetTopSummarizersParams = {
  page?: number;
  size?: number;
};

export type GetMyAssignmentsParams = {
  page?: number;
  size?: number;
};

export type GetAssignmentFromStudentsParams = {
  page?: number;
  size?: number;
};

export type GetAssignmentsFromTeacherStatus =
  (typeof GetAssignmentsFromTeacherStatus)[keyof typeof GetAssignmentsFromTeacherStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsFromTeacherStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  ASSIGNED: "ASSIGNED",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
} as const;

export type GetAssignmentsFromTeacherDirection =
  (typeof GetAssignmentsFromTeacherDirection)[keyof typeof GetAssignmentsFromTeacherDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsFromTeacherDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetAssignmentsFromTeacherParams = {
  page?: number;
  direction?: GetAssignmentsFromTeacherDirection;
  orderBy?: string;
  status?: GetAssignmentsFromTeacherStatus;
  size?: number;
};

export type GetClassroomsDetailedCourseType =
  (typeof GetClassroomsDetailedCourseType)[keyof typeof GetClassroomsDetailedCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClassroomsDetailedCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetClassroomsDetailedParams = {
  page?: number;
  size?: number;
  grade?: number;
  courseType?: GetClassroomsDetailedCourseType;
};

export type GetClassroomDashboard1Params = {
  lastDays?: number;
};

export type GeneratePresignedUrlOnlyParams = {
  fileName: string;
};

export type GeneratePresignedUrlParams = {
  fileName: string;
};

export type SaveYoutubeVimeoUrlAsTeacherDocumentParams = {
  url: string;
};

export type ListFilesParams = {
  fileName?: string;
  contentType?: string;
  uploadedAfter?: string;
  uploadedBefore?: string;
  minSize?: number;
  maxSize?: number;
  page?: number;
  size?: number;
  orderBy?: string;
};

export type GetTeacherProfileParams = {
  page?: number;
  size?: number;
};

export type GetAssignmentStatisticsParams = {
  /**
   * student id list
   */
  studentIds?: string;
};

export type GetStudentWeeklyAnalysisParams = {
  lastDays?: number;
};

export type GetClassroomAssignmentsStatisticsParams = {
  /**
   * start date of statistics
   */
  start?: string;
  /**
   * end date of statistics
   */
  end?: string;
};

export type GetClassroomDashboardParams = {
  lastDays?: number;
};

export type GetClassroomStudentsStatisticsParams = {
  /**
   * start date of statistics
   */
  start?: string;
  onlyClassroomStudents?: boolean;
  /**
   * end date of statistics
   */
  end?: string;
};

export type GetClassroomWeeklyAnalysisParams = {
  lastDays?: number;
};

export type GetStudentsWithIdsParams = {
  studentIds?: number[];
};

export type GetAssignmentsOfStudentFromTeacherStatus =
  (typeof GetAssignmentsOfStudentFromTeacherStatus)[keyof typeof GetAssignmentsOfStudentFromTeacherStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromTeacherStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  DID_NOT_START: "DID_NOT_START",
} as const;

export type GetAssignmentsOfStudentFromTeacherCourseType =
  (typeof GetAssignmentsOfStudentFromTeacherCourseType)[keyof typeof GetAssignmentsOfStudentFromTeacherCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromTeacherCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetAssignmentsOfStudentFromTeacherDirection =
  (typeof GetAssignmentsOfStudentFromTeacherDirection)[keyof typeof GetAssignmentsOfStudentFromTeacherDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAssignmentsOfStudentFromTeacherDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetAssignmentsOfStudentFromTeacherParams = {
  page?: number;
  size?: number;
  direction?: GetAssignmentsOfStudentFromTeacherDirection;
  orderBy?: string;
  courseType?: GetAssignmentsOfStudentFromTeacherCourseType;
  status?: GetAssignmentsOfStudentFromTeacherStatus;
};

export type GetStudentsGenericFilteredParams = {
  grade?: number;
  page?: number;
  size?: number;
};

export type GetTedLessonPlannersAdminCourseType =
  (typeof GetTedLessonPlannersAdminCourseType)[keyof typeof GetTedLessonPlannersAdminCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTedLessonPlannersAdminCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetTedLessonPlannersAdminParams = {
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by teacher ID
   */
  teacherId?: number;
  /**
   * Filter by grade
   */
  grade?: number;
  /**
   * Filter by course type
   */
  courseType?: GetTedLessonPlannersAdminCourseType;
};

export type GetTedYearlyLessonPlannersAdminCourseType =
  (typeof GetTedYearlyLessonPlannersAdminCourseType)[keyof typeof GetTedYearlyLessonPlannersAdminCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTedYearlyLessonPlannersAdminCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetTedYearlyLessonPlannersAdminParams = {
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by teacher ID
   */
  teacherId?: number;
  /**
   * Filter by grade
   */
  grade?: number;
  /**
   * Filter by course type
   */
  courseType?: GetTedYearlyLessonPlannersAdminCourseType;
};

export type GetUserTextLevelersParams = {
  page?: number;
  size?: number;
};

export type GetRecentTextLevelersParams = {
  page?: number;
  size?: number;
};

export type GetTopTextLevelersParams = {
  page?: number;
  size?: number;
};

export type GetTopicsCourseType =
  (typeof GetTopicsCourseType)[keyof typeof GetTopicsCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTopicsCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetTopicsParams = {
  grade?: number;
  courseType?: GetTopicsCourseType;
  language?: string;
  chapterName?: string;
};

export type GetUserTransferActivitiesParams = {
  page?: number;
  size?: number;
};

export type GetRecentTransferActivitiesParams = {
  page?: number;
  size?: number;
};

export type GetTopTransferActivitiesParams = {
  page?: number;
  size?: number;
};

export type GetUserUdlChoiceBoardsParams = {
  page?: number;
  size?: number;
};

export type GetRecentUdlChoiceBoardsParams = {
  page?: number;
  size?: number;
};

export type GetTopUdlChoiceBoardsParams = {
  page?: number;
  size?: number;
};

export type HandleFirebaseActionParams = {
  oobCode: string;
  mode: string;
  apiKey?: string;
  lang?: string;
};

export type CanDoAction = (typeof CanDoAction)[keyof typeof CanDoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CanDoAction = {
  VOICE_CHAT: "VOICE_CHAT",
  IMAGE_CHAT: "IMAGE_CHAT",
  CREATE_CHAT: "CREATE_CHAT",
  QUESTION_HELPER: "QUESTION_HELPER",
} as const;

export type CanDoParams = {
  action: CanDoAction;
};

export type CanDoEventAction =
  (typeof CanDoEventAction)[keyof typeof CanDoEventAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CanDoEventAction = {
  VOICE_CHAT: "VOICE_CHAT",
  IMAGE_CHAT: "IMAGE_CHAT",
  CREATE_CHAT: "CREATE_CHAT",
  QUESTION_HELPER: "QUESTION_HELPER",
} as const;

export type CanDoEventParams = {
  action: CanDoEventAction;
};

export type GetUserVideoAvatarsParams = {
  page?: number;
  size?: number;
};

export type GetRecentVideoAvatarsParams = {
  page?: number;
  size?: number;
};

export type GetTopVideoAvatarsParams = {
  page?: number;
  size?: number;
};

export type GetUserVocabularyListsParams = {
  page?: number;
  size?: number;
};

export type GetRecentVocabularyListsParams = {
  page?: number;
  size?: number;
};

export type GetTopVocabularyListsParams = {
  page?: number;
  size?: number;
};

export type GetTextEmbeddingParams = {
  input: string;
};

export type GetAuditsParams = {
  page?: number;
  size?: number;
};

export type GetBlogsDirection =
  (typeof GetBlogsDirection)[keyof typeof GetBlogsDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBlogsDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetBlogsParams = {
  title?: string;
  content?: string;
  direction?: GetBlogsDirection;
  orderBy?: string;
  page?: number;
  size?: number;
};

export type GetChatMessageSuggestionsCourseType =
  (typeof GetChatMessageSuggestionsCourseType)[keyof typeof GetChatMessageSuggestionsCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChatMessageSuggestionsCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetChatMessageSuggestionsParams = {
  grade: number;
  courseType?: GetChatMessageSuggestionsCourseType;
  page?: number;
  size?: number;
  random?: boolean;
};

export type GetMessagesOfDidacticParams = {
  page?: number;
  size?: number;
};

export type GetMessagesParams = {
  page?: number;
  size?: number;
};

export type HandleNewEmailBody = { [key: string]: { [key: string]: unknown } };

export type GetEssayAssignmentsParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
};

export type GetEssayGradersParams = {
  page?: number;
  size?: number;
};

export type SearchNodesType =
  (typeof SearchNodesType)[keyof typeof SearchNodesType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchNodesType = {
  QUESTION: "QUESTION",
  QUESTION_FOLDER: "QUESTION_FOLDER",
  CHAT: "CHAT",
  CHAT_FOLDER: "CHAT_FOLDER",
  ROOT_FOLDER: "ROOT_FOLDER",
} as const;

export type SearchNodesParams = {
  name?: string;
  type?: SearchNodesType;
};

export type GetAllInteractiveMaterialsParams = {
  page?: number;
  size?: number;
};

export type GetLessonPlannersV2PlanType =
  (typeof GetLessonPlannersV2PlanType)[keyof typeof GetLessonPlannersV2PlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLessonPlannersV2PlanType = {
  DAILY: "DAILY",
  MAARIF: "MAARIF",
  UBD_MAARIF: "UBD_MAARIF",
  TED: "TED",
  TED_YEARLY: "TED_YEARLY",
  UBD_EXPERT: "UBD_EXPERT",
} as const;

export type GetLessonPlannersV2Params = {
  planType?: GetLessonPlannersV2PlanType;
  page?: number;
  size?: number;
  orderBy?: string;
};

export type ListMadlenBoardUserBoardsParams = {
  /**
   * Page number (0-indexed)
   */
  page?: number;
  /**
   * Number of items per page
   */
  size?: number;
  /**
   * Sort by field (createdAt, updatedAt, title)
   */
  sortBy?: string;
  /**
   * Sort order (asc, desc)
   */
  order?: string;
};

export type GetApiKeysSupplier =
  (typeof GetApiKeysSupplier)[keyof typeof GetApiKeysSupplier];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiKeysSupplier = {
  OPENAI: "OPENAI",
  GEMINI: "GEMINI",
  VERTEX: "VERTEX",
  AZUREOPENAICURL: "AZUREOPENAICURL",
  AZUREOPENAI: "AZUREOPENAI",
  BEDROCK: "BEDROCK",
  AZUREOPENAICURL2025: "AZUREOPENAICURL2025",
} as const;

export type GetApiKeysJobType =
  (typeof GetApiKeysJobType)[keyof typeof GetApiKeysJobType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiKeysJobType = {
  STUDENT_CHAT: "STUDENT_CHAT",
  STUDENT_CHAT_AGENT: "STUDENT_CHAT_AGENT",
  TEACHER_CHAT: "TEACHER_CHAT",
  TEACHER_CHAT_AGENT: "TEACHER_CHAT_AGENT",
  DIDACTIC_CHAT: "DIDACTIC_CHAT",
  STUDENT_FEEDBACK_CHAT: "STUDENT_FEEDBACK_CHAT",
  QUESTION_GENERATION: "QUESTION_GENERATION",
  QUESTION_EXPLAIN: "QUESTION_EXPLAIN",
  QUESTION_EXPLAIN_AGENT: "QUESTION_EXPLAIN_AGENT",
  QUESTION_GRADING: "QUESTION_GRADING",
  QUESTION_GRADING_AGENT: "QUESTION_GRADING_AGENT",
  CHATLY_ANALYSIS: "CHATLY_ANALYSIS",
  TOPIC_MERGER: "TOPIC_MERGER",
  WEEKLY_ANALYSIS: "WEEKLY_ANALYSIS",
  ESSAY_GRADING: "ESSAY_GRADING",
  QUESTION_SOLVER: "QUESTION_SOLVER",
  QUESTION_HELPER: "QUESTION_HELPER",
  QUESTION_SOLVER_AGENT: "QUESTION_SOLVER_AGENT",
  LESSON_PLANNER: "LESSON_PLANNER",
  QUESTION_REGEN: "QUESTION_REGEN",
  STUDENT_CHAT_MATH: "STUDENT_CHAT_MATH",
  STUDENT_CHAT_MATH_AGENT: "STUDENT_CHAT_MATH_AGENT",
  CUSTOM_GPT_CHAT: "CUSTOM_GPT_CHAT",
  UBD_PLANNER: "UBD_PLANNER",
  UBD_MAARIF_PLANNER: "UBD_MAARIF_PLANNER",
  TED_LESSON_PLANNER: "TED_LESSON_PLANNER",
  TED_YEARLY_LESSON_PLANNER: "TED_YEARLY_LESSON_PLANNER",
  SLIDE_GENERATOR: "SLIDE_GENERATOR",
  INTERACTIVE_MATERIAL: "INTERACTIVE_MATERIAL",
  TOOL_AI_ASSIGNMENT: "TOOL_AI_ASSIGNMENT",
  TOOL_AI_RESISTANT_HOMEWORK: "TOOL_AI_RESISTANT_HOMEWORK",
  TOOL_AI_SUPPORTED_TASKS: "TOOL_AI_SUPPORTED_TASKS",
  TOOL_BLOOMS_TAXONOMY_ACTIVITIES: "TOOL_BLOOMS_TAXONOMY_ACTIVITIES",
  TOOL_CHOICE_BOARD: "TOOL_CHOICE_BOARD",
  TOOL_CLASSROOM_MANAGEMENT: "TOOL_CLASSROOM_MANAGEMENT",
  TOOL_COLLABORATIVE_GROUP_WORK: "TOOL_COLLABORATIVE_GROUP_WORK",
  TOOL_COMMON_MISCONCEPTION: "TOOL_COMMON_MISCONCEPTION",
  TOOL_CONCEPTUAL_UNDERSTANDING: "TOOL_CONCEPTUAL_UNDERSTANDING",
  TOOL_ESSENTIAL_QUESTIONS: "TOOL_ESSENTIAL_QUESTIONS",
  TOOL_EXIT_TICKETS: "TOOL_EXIT_TICKETS",
  TOOL_FORMATIVE_ASSESSMENT: "TOOL_FORMATIVE_ASSESSMENT",
  TOOL_HOMEWORK_IDEA: "TOOL_HOMEWORK_IDEA",
  TOOL_IMAGE_GENERATOR: "TOOL_IMAGE_GENERATOR",
  TOOL_LESSON_HOOK: "TOOL_LESSON_HOOK",
  TOOL_MINDMAP_GENERATOR: "TOOL_MINDMAP_GENERATOR",
  TOOL_PERFORMANCE_TASK: "TOOL_PERFORMANCE_TASK",
  TOOL_PODCAST: "TOOL_PODCAST",
  TOOL_PROJECT_BASED_LEARNING: "TOOL_PROJECT_BASED_LEARNING",
  TOOL_REAL_WORLD_CONNECTION: "TOOL_REAL_WORLD_CONNECTION",
  TOOL_RUBRIC_GENERATOR: "TOOL_RUBRIC_GENERATOR",
  TOOL_SUMMARIZER: "TOOL_SUMMARIZER",
  TOOL_TEXT_LEVELER: "TOOL_TEXT_LEVELER",
  TOOL_TRANSFER_ACTIVITY: "TOOL_TRANSFER_ACTIVITY",
  TOOL_UDL_CHOICE_BOARD: "TOOL_UDL_CHOICE_BOARD",
  TOOL_VOCABULARY_LIST: "TOOL_VOCABULARY_LIST",
  TOOL_AI_ASSESSMENT_SCALE: "TOOL_AI_ASSESSMENT_SCALE",
  PROMPT_ENHANCER: "PROMPT_ENHANCER",
  TEACHER_TOOL_CHAT: "TEACHER_TOOL_CHAT",
  TOOL_HEYGEN_AVATAR: "TOOL_HEYGEN_AVATAR",
  TOOL_ARTICLE_GENERATOR: "TOOL_ARTICLE_GENERATOR",
  TOOL_SKETCH_GENERATOR: "TOOL_SKETCH_GENERATOR",
  SWANN_VISUAL_MATCHING: "SWANN_VISUAL_MATCHING",
  SWANN_PODCAST_GENERATOR: "SWANN_PODCAST_GENERATOR",
  SWANN_PRONUNCIATION_ASSIGNMENT: "SWANN_PRONUNCIATION_ASSIGNMENT",
  SWANN_SPOKEN_DIALOGUE: "SWANN_SPOKEN_DIALOGUE",
} as const;

export type GetApiKeysParams = {
  environment?: string;
  jobType?: GetApiKeysJobType;
  supplier?: GetApiKeysSupplier;
};

export type RemoveStudentsFromClassroomInOrganizationAdminController200 = {
  [key: string]: number[];
};

export type AddStudentsToClassroomInOrganizationAdminController200 = {
  [key: string]: number[];
};

export type GetClassroomsCourseType =
  (typeof GetClassroomsCourseType)[keyof typeof GetClassroomsCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetClassroomsCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetClassroomsParams = {
  page?: number;
  size?: number;
  grade?: number;
  courseType?: GetClassroomsCourseType;
};

export type GetTeachers1Params = {
  id?: number;
  createdAtAfterThanMillis?: number;
  emailLike?: string;
  page?: number;
  size?: number;
};

export type GetAssignmentAsPdfParams = {
  showAnswers?: boolean;
};

export type GetQuestionHelpersStatus =
  (typeof GetQuestionHelpersStatus)[keyof typeof GetQuestionHelpersStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuestionHelpersStatus = {
  PROCESSING: "PROCESSING",
  REGENERATING: "REGENERATING",
  READY: "READY",
  FAILED: "FAILED",
} as const;

export type GetQuestionHelpersParams = {
  page?: number;
  size?: number;
  tags?: string[];
  title?: string;
  status?: GetQuestionHelpersStatus;
};

export type RegenQuestionSolverV2Level =
  (typeof RegenQuestionSolverV2Level)[keyof typeof RegenQuestionSolverV2Level];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegenQuestionSolverV2Level = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export type RegenQuestionSolverV2Params = {
  level?: RegenQuestionSolverV2Level;
};

export type HandleTokenRequest200 = {
  [key: string]: { [key: string]: unknown };
};

export type HandleTokenRequestParams = {
  grant_type: string;
  code: string;
  redirect_uri: string;
  client_id: string;
  client_secret: string;
};

export type ListParams = {
  page?: number;
  size?: number;
};

export type GetVisualMatchingListParams = {
  page?: number;
  size?: number;
};

export type GetTeacherChatsParams = {
  page?: number;
  size?: number;
};

export type GetTeacherToolChatsParams = {
  page?: number;
  size?: number;
};

export type GetAllSuperToolsParams = {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: string;
};

export type GetTedLessonPlannersParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
  /**
   * Order by field
   */
  orderBy?: string;
};

export type GetTedYearlyLessonPlannersParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Page size
   */
  size?: number;
  /**
   * Order by field
   */
  orderBy?: string;
};

export type SynthesizeTextOpenai1Params = {
  voice?: string;
  outputFormat?: string;
};

export type ListUbdExpertPlannerServicesParams = {
  page?: number;
  size?: number;
};

export type ActivateCodeParams = {
  code: string;
};

export type ActivateInternalCodeParams = {
  code: string;
};

export type UpdateDidacticChatConfigStudentDirection =
  (typeof UpdateDidacticChatConfigStudentDirection)[keyof typeof UpdateDidacticChatConfigStudentDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDidacticChatConfigStudentDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type UpdateDidacticChatConfigStudentParams = {
  direction?: UpdateDidacticChatConfigStudentDirection;
  page?: number;
  size?: number;
};

export type GetChatDirection =
  (typeof GetChatDirection)[keyof typeof GetChatDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChatDirection = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type GetChatParams = {
  direction?: GetChatDirection;
  page?: number;
  size?: number;
};

export type PartialAssignmentGenerationSingleBody =
  | FillTheBlankQuestion
  | MatchQuestion
  | OpenEndedQuestion
  | TestQuestion
  | TrueFalseQuestion;

export interface ListAiAssessmentScaleResponseDto {
  data?: AiAssessmentScaleResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListAiAssignmentResponseDto {
  data?: AiAssignmentResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListAiSupportedTasksResponseDto {
  data?: AiSupportedTasksResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface LambdaAlertEntity {
  createdAt?: string;
  entityId?: string;
  id?: number;
  lambdaName?: string;
  read?: boolean;
  readTime?: string;
  startTime?: string;
}

export interface ListArticleGeneratorResponseDto {
  data?: ArticleGeneratorResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListAuditResponseDto {
  data?: BaseAuditDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface BlogPostResponseDto {
  author: string;
  baseXp?: number;
  contentEn: string;
  contentTr: string;
  coverPhotoUrl?: string;
  createdAt: string;
  didUserLiked?: boolean;
  id: number;
  likeCount: number;
  questions?: JsonNode;
  seenCount: number;
  tags: string[];
  titleEn: string;
  titleTr: string;
  voiceEnUrl?: string;
  voiceTrUrl?: string;
  xpPerPoint?: number;
}

export interface ListBlogPostResponseDto {
  data?: BlogPostResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListBloomsTaxonomyActivitiesResponseDto {
  data?: BloomsTaxonomyActivitiesResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type BaseChatMessageSuggestionDtoCourseType =
  (typeof BaseChatMessageSuggestionDtoCourseType)[keyof typeof BaseChatMessageSuggestionDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatMessageSuggestionDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface BaseChatMessageSuggestionDto {
  courseType?: BaseChatMessageSuggestionDtoCourseType;
  grade?: number;
  id?: number;
  message?: string;
  title?: string;
  topic?: string;
}

export interface ListChatMessageSuggestionsResponseDto {
  data?: BaseChatMessageSuggestionDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type ChatFileNodeDtoType =
  (typeof ChatFileNodeDtoType)[keyof typeof ChatFileNodeDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatFileNodeDtoType = {
  QUESTION: "QUESTION",
  QUESTION_FOLDER: "QUESTION_FOLDER",
  CHAT: "CHAT",
  CHAT_FOLDER: "CHAT_FOLDER",
  ROOT_FOLDER: "ROOT_FOLDER",
} as const;

export type ChatFileNodeDtoChatType =
  (typeof ChatFileNodeDtoChatType)[keyof typeof ChatFileNodeDtoChatType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatFileNodeDtoChatType = {
  DIDACTIC: "DIDACTIC",
  CHAT: "CHAT",
} as const;

export interface ChatFileNodeDto {
  chatId?: number;
  chatTitle?: string;
  chatType?: ChatFileNodeDtoChatType;
  children: BaseFileNodeDto[];
  createdAt: string;
  id: number;
  name?: string;
  parentId?: number;
  type: ChatFileNodeDtoType;
  userId: number;
}

export type DidacticTopicResponseDtoCourseType =
  (typeof DidacticTopicResponseDtoCourseType)[keyof typeof DidacticTopicResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DidacticTopicResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface DidacticTopicResponseDto {
  courseType: DidacticTopicResponseDtoCourseType;
  grade: number;
  id: number;
  language: string;
  topic: string;
}

export interface EdlinkReference {
  enrollments?: number;
  meetings?: number;
  sections?: number;
}

export type EdlinkPersonRolesItem =
  (typeof EdlinkPersonRolesItem)[keyof typeof EdlinkPersonRolesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkPersonRolesItem = {
  student: "student",
  district_administrator: "district_administrator",
  administrator: "administrator",
  teacher: "teacher",
  staff: "staff",
  observer: "observer",
  parent: "parent",
  guardian: "guardian",
  ta: "ta",
  aide: "aide",
  designer: "designer",
  member: "member",
  unknown: "unknown",
} as const;

export type EdlinkPersonProperties = {
  [key: string]: { [key: string]: unknown };
};

export type EdlinkPersonGradeLevelsItem =
  (typeof EdlinkPersonGradeLevelsItem)[keyof typeof EdlinkPersonGradeLevelsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkPersonGradeLevelsItem = {
  Birth: "Birth",
  Prenatal: "Prenatal",
  IT: "IT",
  PR: "PR",
  PK: "PK",
  TK: "TK",
  KG: "KG",
  NUMBER_01: "01",
  NUMBER_02: "02",
  NUMBER_03: "03",
  NUMBER_04: "04",
  NUMBER_05: "05",
  NUMBER_06: "06",
  NUMBER_07: "07",
  NUMBER_08: "08",
  NUMBER_09: "09",
  NUMBER_10: "10",
  NUMBER_11: "11",
  NUMBER_12: "12",
  NUMBER_13: "13",
  PS: "PS",
  AL: "AL",
  CL: "CL",
  UG: "UG",
  Other: "Other",
  Unknown: "Unknown",
} as const;

export type EdlinkIdentifierType =
  (typeof EdlinkIdentifierType)[keyof typeof EdlinkIdentifierType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkIdentifierType = {
  sis_id: "sis_id",
  state_id: "state_id",
  state_testing_id: "state_testing_id",
  federal_id: "federal_id",
  school_id: "school_id",
  username: "username",
  email: "email",
  ldap: "ldap",
  nces_id: "nces_id",
  mdr_id: "mdr_id",
  ipeds_id: "ipeds_id",
  edlink_id: "edlink_id",
  aeries_id: "aeries_id",
  blackbaud_id: "blackbaud_id",
  blackboard_id: "blackboard_id",
  brightspace_id: "brightspace_id",
  bromcom_id: "bromcom_id",
  canvas_id: "canvas_id",
  canvas_lti_id: "canvas_lti_id",
  classlink_tenant_id: "classlink_tenant_id",
  clever_id: "clever_id",
  facts_id: "facts_id",
  google_id: "google_id",
  illuminate_id: "illuminate_id",
  lti_id: "lti_id",
  microsoft_id: "microsoft_id",
  moodle_id: "moodle_id",
  oneroster_id: "oneroster_id",
  powerschool_id: "powerschool_id",
  powerschool_dc_id: "powerschool_dc_id",
  schoology_id: "schoology_id",
  skyward_id: "skyward_id",
  skyward_other_id: "skyward_other_id",
  google_org_unit_id: "google_org_unit_id",
  unknown: "unknown",
  veracross_id: "veracross_id",
} as const;

export interface EdlinkIdentifier {
  type?: EdlinkIdentifierType;
  value?: string;
}

export type EdlinkDemographicsResidenceStatus =
  (typeof EdlinkDemographicsResidenceStatus)[keyof typeof EdlinkDemographicsResidenceStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkDemographicsResidenceStatus = {
  NUMBER_01652: "01652",
  NUMBER_01653: "01653",
  NUMBER_01654: "01654",
  NUMBER_01655: "01655",
  NUMBER_01656: "01656",
  unknown: "unknown",
} as const;

export type EdlinkDemographicsRacesItem =
  (typeof EdlinkDemographicsRacesItem)[keyof typeof EdlinkDemographicsRacesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkDemographicsRacesItem = {
  "american-indian-or-alaska-native": "american-indian-or-alaska-native",
  asian: "asian",
  "black-or-african-american": "black-or-african-american",
  "native-hawaiian-or-other-pacific-islander":
    "native-hawaiian-or-other-pacific-islander",
  white: "white",
  unknown: "unknown",
} as const;

export type EdlinkDemographicsMilitaryConnected =
  (typeof EdlinkDemographicsMilitaryConnected)[keyof typeof EdlinkDemographicsMilitaryConnected];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkDemographicsMilitaryConnected = {
  NotMilitaryConnected: "NotMilitaryConnected",
  ActiveDuty: "ActiveDuty",
  NationalGuardOrReserve: "NationalGuardOrReserve",
  unknown: "unknown",
} as const;

export type EdlinkDemographicsGender =
  (typeof EdlinkDemographicsGender)[keyof typeof EdlinkDemographicsGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkDemographicsGender = {
  male: "male",
  female: "female",
  other: "other",
  unknown: "unknown",
} as const;

export type EdlinkDemographicsFoodServiceProgramEligibility =
  (typeof EdlinkDemographicsFoodServiceProgramEligibility)[keyof typeof EdlinkDemographicsFoodServiceProgramEligibility];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkDemographicsFoodServiceProgramEligibility = {
  Free: "Free",
  FullPrice: "FullPrice",
  ReducedPrice: "ReducedPrice",
  Other: "Other",
  unknown: "unknown",
} as const;

export type EdlinkDemographicsEdlinkDisability =
  (typeof EdlinkDemographicsEdlinkDisability)[keyof typeof EdlinkDemographicsEdlinkDisability];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkDemographicsEdlinkDisability = {
  AUT: "AUT",
  DB: "DB",
  DD: "DD",
  EMN: "EMN",
  HI: "HI",
  ID: "ID",
  MD: "MD",
  OI: "OI",
  OHI: "OHI",
  SLD: "SLD",
  SLI: "SLI",
  TBI: "TBI",
  VI: "VI",
  unknown: "unknown",
} as const;

export interface EdlinkDemographics {
  birthday?: string;
  cityOfBirth?: string;
  countryOfBirth?: string;
  economicallyDisadvantaged?: boolean;
  edlinkDisability?: EdlinkDemographicsEdlinkDisability;
  englishLanguageLearner?: boolean;
  foodServiceProgramEligibility?: EdlinkDemographicsFoodServiceProgramEligibility;
  gender?: EdlinkDemographicsGender;
  giftedTalented?: boolean;
  hispanicOrLatinoEthnicity?: boolean;
  homeless?: boolean;
  individualizedEducationPlan?: boolean;
  migrant?: boolean;
  militaryConnected?: EdlinkDemographicsMilitaryConnected;
  primaryLanguage?: string;
  publicAssistance?: boolean;
  races?: EdlinkDemographicsRacesItem[];
  residenceStatus?: EdlinkDemographicsResidenceStatus;
  ruralResidency?: boolean;
  specialAccommodations?: boolean;
  stateOfBirth?: string;
}

export type EdlinkClassroomResponseDtoProperties = {
  [key: string]: { [key: string]: unknown };
};

export interface EdlinkClassroomResponseDto {
  course_id?: string;
  created_date?: string;
  department_id?: string;
  description?: string;
  id?: string;
  locale?: string;
  name?: string;
  period_ids?: string[];
  periods?: string[];
  picture_url?: string;
  properties?: EdlinkClassroomResponseDtoProperties;
  references?: EdlinkReference;
  room_ids?: string[];
  school_id?: string;
  session_ids?: string[];
  state?: string;
  students?: EdlinkPerson[];
  subject_id?: string;
  time_zone?: string;
  updated_date?: string;
}

export interface EdlinkAddress {
  city?: string;
  country?: string;
  latitude?: string;
  longitude?: string;
  phone?: string;
  postal_code?: string;
  state?: string;
  street?: string;
  unit?: string;
}

export interface EdlinkPerson {
  address?: EdlinkAddress;
  created_date?: string;
  demographics?: EdlinkDemographics;
  department_ids?: string[];
  display_name?: string;
  district_id?: string;
  email?: string;
  first_name?: string;
  gpa?: string;
  grade_levels?: EdlinkPersonGradeLevelsItem[];
  graduation_year?: number;
  id?: string;
  identifiers?: EdlinkIdentifier[];
  last_name?: string;
  letter_grade?: string;
  locale?: string;
  middle_name?: string;
  phone?: string;
  picture_url?: string;
  properties?: EdlinkPersonProperties;
  roles?: EdlinkPersonRolesItem[];
  route_ids?: string[];
  school_ids?: string[];
  time_zone?: string;
  updated_date?: string;
}

export type EssayAssignmentSummaryDtoStatus =
  (typeof EssayAssignmentSummaryDtoStatus)[keyof typeof EssayAssignmentSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssayAssignmentSummaryDtoStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  CLOSED: "CLOSED",
  GRADING_RELEASED: "GRADING_RELEASED",
} as const;

export interface EssayAssignmentSummaryDto {
  createdAt?: string;
  dueDate?: string;
  gradedCount?: number;
  id?: number;
  pendingCount?: number;
  status?: EssayAssignmentSummaryDtoStatus;
  submittedCount?: number;
  title?: string;
  totalStudents?: number;
}

export interface ListEssayAssignmentResponseDto {
  assignments?: EssayAssignmentSummaryDto[];
  pageNumber?: number;
  pageSize?: number;
  totalElements?: number;
  totalPages?: number;
}

export interface ListEssayGradingResultDto {
  data?: EssayGradingResultDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListStudentEssaySubmissionResponseDto {
  pageNumber?: number;
  pageSize?: number;
  submissions?: StudentEssaySubmissionResponseDto[];
  totalElements?: number;
  totalPages?: number;
}

export interface StudentDto {
  email?: string;
  id?: string;
  name?: string;
  photo?: string;
}

export interface GetStudentsResponseDto {
  students: StudentDto[];
}

export interface PaginatedDriveFilesResponseDto {
  data?: DriveFileDto[];
  hasNextPage?: boolean;
  nextPageToken?: string;
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface JsonFactory {
  [key: string]: unknown;
}

export type DriveFileDtoVideoMediaMetadataUnknownKeys = {
  [key: string]: { [key: string]: unknown };
};

export type DriveFileDtoVideoMediaMetadata = {
  classInfo?: ClassInfo;
  durationMillis?: number;
  empty?: boolean;
  factory?: JsonFactory;
  height?: number;
  unknownKeys?: DriveFileDtoVideoMediaMetadataUnknownKeys;
  width?: number;
  [key: string]: { [key: string]: unknown };
};

export interface DateTime {
  dateOnly?: boolean;
  timeZoneShift?: number;
  value?: number;
}

export interface DriveFileDto {
  alternateLink?: string;
  createdTime?: DateTime;
  description?: string;
  id?: string;
  size?: number;
  thumbnailUrl?: string;
  title?: string;
  videoMediaMetadata?: DriveFileDtoVideoMediaMetadata;
}

export interface TopicDto {
  courseId?: string;
  name?: string;
  topicId: string;
}

export interface GetTopicsResponseDto {
  topics: TopicDto[];
}

export interface FileMetadata {
  alternateLink?: string;
  id?: string;
  thumbnailUrl?: string;
  title?: string;
}

export interface PostFilesMetadataResponseDto {
  files?: FileMetadata[];
  topic?: TopicDto;
}

export interface GetGoogleScopesResponseDto {
  scopes: string[];
}

export type LearningOutcomesPerOutcomePerExplanationResponseDtoCourseType =
  (typeof LearningOutcomesPerOutcomePerExplanationResponseDtoCourseType)[keyof typeof LearningOutcomesPerOutcomePerExplanationResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LearningOutcomesPerOutcomePerExplanationResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface LearningOutcomesPerOutcomePerExplanationLevel2ResponseDto {
  id?: number;
  outcome?: string;
  outcomeExplanationList?: string[];
}

export interface LearningOutcomesPerOutcomePerExplanationLevel1ResponseDto {
  outcomes?: LearningOutcomesPerOutcomePerExplanationLevel2ResponseDto[];
  unit: string;
}

export interface LearningOutcomesPerOutcomePerExplanationResponseDto {
  courseType?: LearningOutcomesPerOutcomePerExplanationResponseDtoCourseType;
  grade?: number;
  units?: LearningOutcomesPerOutcomePerExplanationLevel1ResponseDto[];
}

export interface DailyStreak {
  dailyStreakValue?: number;
  didChat?: boolean;
  didFinishDailyAssignment?: boolean;
  didFinishDailyBlogQuiz?: boolean;
  lastDailyStreakDay?: string;
  userId?: number;
}

export interface MadlenAdminResponseDto {
  email: string;
  id: number;
  name: string;
  preferences?: UserPreferences;
  surname: string;
}

export interface TokenUsageAverage {
  inputTokenCountAvg?: number;
  inputTokenCountTotal?: number;
  jobType?: string;
  outputTokenCountAvg?: number;
  outputTokenCountTotal?: number;
}

export interface TokenUsagePerUserResponseDto {
  inputTokenCountTotal?: number;
  outputTokenCountTotal?: number;
  userEmail?: string;
  userId?: number;
  userName?: string;
  userSurname?: string;
}

export interface ListTokenUsagePerUserResponseDto {
  data?: TokenUsagePerUserResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface TokenUsageDetailed {
  createdAt?: string;
  executionTimes?: JsonNode;
  foreignId?: number;
  inputTokenCountDetailed?: JsonNode;
  inputTokenCountTotal?: number;
  jobType?: string;
  outputTokenCountDetailed?: JsonNode;
  outputTokenCountTotal?: number;
  userId?: number;
}

export interface ListTokenUsageDetailedResponseDto {
  data?: TokenUsageDetailed[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type ShortBoardResponseDtoLayoutType =
  (typeof ShortBoardResponseDtoLayoutType)[keyof typeof ShortBoardResponseDtoLayoutType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShortBoardResponseDtoLayoutType = {
  WALL: "WALL",
  COLUMNS: "COLUMNS",
} as const;

export type ShortBoardResponseDtoBackgroundType =
  (typeof ShortBoardResponseDtoBackgroundType)[keyof typeof ShortBoardResponseDtoBackgroundType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShortBoardResponseDtoBackgroundType = {
  UPLOAD: "UPLOAD",
  SYSTEM: "SYSTEM",
} as const;

export interface ShortBoardResponseDto {
  backgroundType?: ShortBoardResponseDtoBackgroundType;
  backgroundValue?: string;
  createdAt?: string;
  description?: string;
  id?: number;
  layoutType?: ShortBoardResponseDtoLayoutType;
  ownerId?: number;
  title?: string;
  updatedAt?: string;
}

export interface ListBoardsResponseDto {
  data?: ShortBoardResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListMindmapGeneratorResponseDto {
  data?: MindmapGeneratorResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface BaseNotificationDto {
  createdAt?: string;
  description?: string;
  extraDetails?: JsonNode;
  id?: number;
  readAt?: string;
  title?: string;
}

export interface ListNotificationsResponseDto {
  data?: BaseNotificationDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface BaseOrganizationDTO {
  createdAt?: string;
  createdBy?: number;
  id?: number;
  logo?: string;
  name?: string;
}

export type ApiKeyEntitySupplier =
  (typeof ApiKeyEntitySupplier)[keyof typeof ApiKeyEntitySupplier];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiKeyEntitySupplier = {
  OPENAI: "OPENAI",
  GEMINI: "GEMINI",
  VERTEX: "VERTEX",
  AZUREOPENAICURL: "AZUREOPENAICURL",
  AZUREOPENAI: "AZUREOPENAI",
  BEDROCK: "BEDROCK",
  AZUREOPENAICURL2025: "AZUREOPENAICURL2025",
} as const;

export type ApiKeyEntityJobType =
  (typeof ApiKeyEntityJobType)[keyof typeof ApiKeyEntityJobType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiKeyEntityJobType = {
  STUDENT_CHAT: "STUDENT_CHAT",
  STUDENT_CHAT_AGENT: "STUDENT_CHAT_AGENT",
  TEACHER_CHAT: "TEACHER_CHAT",
  TEACHER_CHAT_AGENT: "TEACHER_CHAT_AGENT",
  DIDACTIC_CHAT: "DIDACTIC_CHAT",
  STUDENT_FEEDBACK_CHAT: "STUDENT_FEEDBACK_CHAT",
  QUESTION_GENERATION: "QUESTION_GENERATION",
  QUESTION_EXPLAIN: "QUESTION_EXPLAIN",
  QUESTION_EXPLAIN_AGENT: "QUESTION_EXPLAIN_AGENT",
  QUESTION_GRADING: "QUESTION_GRADING",
  QUESTION_GRADING_AGENT: "QUESTION_GRADING_AGENT",
  CHATLY_ANALYSIS: "CHATLY_ANALYSIS",
  TOPIC_MERGER: "TOPIC_MERGER",
  WEEKLY_ANALYSIS: "WEEKLY_ANALYSIS",
  ESSAY_GRADING: "ESSAY_GRADING",
  QUESTION_SOLVER: "QUESTION_SOLVER",
  QUESTION_HELPER: "QUESTION_HELPER",
  QUESTION_SOLVER_AGENT: "QUESTION_SOLVER_AGENT",
  LESSON_PLANNER: "LESSON_PLANNER",
  QUESTION_REGEN: "QUESTION_REGEN",
  STUDENT_CHAT_MATH: "STUDENT_CHAT_MATH",
  STUDENT_CHAT_MATH_AGENT: "STUDENT_CHAT_MATH_AGENT",
  CUSTOM_GPT_CHAT: "CUSTOM_GPT_CHAT",
  UBD_PLANNER: "UBD_PLANNER",
  UBD_MAARIF_PLANNER: "UBD_MAARIF_PLANNER",
  TED_LESSON_PLANNER: "TED_LESSON_PLANNER",
  TED_YEARLY_LESSON_PLANNER: "TED_YEARLY_LESSON_PLANNER",
  SLIDE_GENERATOR: "SLIDE_GENERATOR",
  INTERACTIVE_MATERIAL: "INTERACTIVE_MATERIAL",
  TOOL_AI_ASSIGNMENT: "TOOL_AI_ASSIGNMENT",
  TOOL_AI_RESISTANT_HOMEWORK: "TOOL_AI_RESISTANT_HOMEWORK",
  TOOL_AI_SUPPORTED_TASKS: "TOOL_AI_SUPPORTED_TASKS",
  TOOL_BLOOMS_TAXONOMY_ACTIVITIES: "TOOL_BLOOMS_TAXONOMY_ACTIVITIES",
  TOOL_CHOICE_BOARD: "TOOL_CHOICE_BOARD",
  TOOL_CLASSROOM_MANAGEMENT: "TOOL_CLASSROOM_MANAGEMENT",
  TOOL_COLLABORATIVE_GROUP_WORK: "TOOL_COLLABORATIVE_GROUP_WORK",
  TOOL_COMMON_MISCONCEPTION: "TOOL_COMMON_MISCONCEPTION",
  TOOL_CONCEPTUAL_UNDERSTANDING: "TOOL_CONCEPTUAL_UNDERSTANDING",
  TOOL_ESSENTIAL_QUESTIONS: "TOOL_ESSENTIAL_QUESTIONS",
  TOOL_EXIT_TICKETS: "TOOL_EXIT_TICKETS",
  TOOL_FORMATIVE_ASSESSMENT: "TOOL_FORMATIVE_ASSESSMENT",
  TOOL_HOMEWORK_IDEA: "TOOL_HOMEWORK_IDEA",
  TOOL_IMAGE_GENERATOR: "TOOL_IMAGE_GENERATOR",
  TOOL_LESSON_HOOK: "TOOL_LESSON_HOOK",
  TOOL_MINDMAP_GENERATOR: "TOOL_MINDMAP_GENERATOR",
  TOOL_PERFORMANCE_TASK: "TOOL_PERFORMANCE_TASK",
  TOOL_PODCAST: "TOOL_PODCAST",
  TOOL_PROJECT_BASED_LEARNING: "TOOL_PROJECT_BASED_LEARNING",
  TOOL_REAL_WORLD_CONNECTION: "TOOL_REAL_WORLD_CONNECTION",
  TOOL_RUBRIC_GENERATOR: "TOOL_RUBRIC_GENERATOR",
  TOOL_SUMMARIZER: "TOOL_SUMMARIZER",
  TOOL_TEXT_LEVELER: "TOOL_TEXT_LEVELER",
  TOOL_TRANSFER_ACTIVITY: "TOOL_TRANSFER_ACTIVITY",
  TOOL_UDL_CHOICE_BOARD: "TOOL_UDL_CHOICE_BOARD",
  TOOL_VOCABULARY_LIST: "TOOL_VOCABULARY_LIST",
  TOOL_AI_ASSESSMENT_SCALE: "TOOL_AI_ASSESSMENT_SCALE",
  PROMPT_ENHANCER: "PROMPT_ENHANCER",
  TEACHER_TOOL_CHAT: "TEACHER_TOOL_CHAT",
  TOOL_HEYGEN_AVATAR: "TOOL_HEYGEN_AVATAR",
  TOOL_ARTICLE_GENERATOR: "TOOL_ARTICLE_GENERATOR",
  TOOL_SKETCH_GENERATOR: "TOOL_SKETCH_GENERATOR",
  SWANN_VISUAL_MATCHING: "SWANN_VISUAL_MATCHING",
  SWANN_PODCAST_GENERATOR: "SWANN_PODCAST_GENERATOR",
  SWANN_PRONUNCIATION_ASSIGNMENT: "SWANN_PRONUNCIATION_ASSIGNMENT",
  SWANN_SPOKEN_DIALOGUE: "SWANN_SPOKEN_DIALOGUE",
} as const;

export interface ApiKeyEntity {
  coefficient?: number;
  content?: string;
  deletedOn?: string;
  environment?: string;
  id?: number;
  jobType?: ApiKeyEntityJobType;
  modelName?: string;
  organizationId?: number;
  supplier?: ApiKeyEntitySupplier;
  updatedAt?: string;
  useCount?: number;
}

export type BaseChatDtoTopics = { [key: string]: number };

export type BaseChatDtoCourse =
  (typeof BaseChatDtoCourse)[keyof typeof BaseChatDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type BaseChatDtoChatType =
  (typeof BaseChatDtoChatType)[keyof typeof BaseChatDtoChatType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatDtoChatType = {
  DIDACTIC: "DIDACTIC",
  CHAT: "CHAT",
} as const;

export interface BaseChatDto {
  chatType?: BaseChatDtoChatType;
  config?: JsonNode;
  course?: BaseChatDtoCourse;
  createdAt?: string;
  description?: string;
  grade?: number;
  id?: number;
  images?: ImagesPart[];
  isFavourite?: boolean;
  isTitleGenerated?: boolean;
  questionSolverId?: number;
  title?: string;
  topics?: BaseChatDtoTopics;
  userId?: number;
}

export interface ListChatMessagesResponseDto {
  data?: BaseChatMessageDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type ShortChatResponseDtoCourse =
  (typeof ShortChatResponseDtoCourse)[keyof typeof ShortChatResponseDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShortChatResponseDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ShortChatResponseDtoChatType =
  (typeof ShortChatResponseDtoChatType)[keyof typeof ShortChatResponseDtoChatType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShortChatResponseDtoChatType = {
  DIDACTIC: "DIDACTIC",
  CHAT: "CHAT",
} as const;

export interface ShortChatResponseDto {
  chatType?: ShortChatResponseDtoChatType;
  course?: ShortChatResponseDtoCourse;
  createdAt?: string;
  grade?: number;
  id?: number;
  isFavourite?: boolean;
  title?: string;
}

export interface ListChatResponseDto {
  data?: ShortChatResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface PaginatedClassroomResponseDto {
  data?: BaseClassroomResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type DailyAssignmentsResponseDtoCourse =
  (typeof DailyAssignmentsResponseDtoCourse)[keyof typeof DailyAssignmentsResponseDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DailyAssignmentsResponseDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface DailyAssignmentsResponseDto {
  baseXp?: number;
  course?: DailyAssignmentsResponseDtoCourse;
  createdAt?: string;
  description?: string;
  endDate?: string;
  grade?: number;
  id?: number;
  imageUrl?: string;
  language?: string;
  name?: string;
  questions?: JsonNode;
  startDate?: string;
  xpPerPoint?: number;
}

export interface TopTeacherDto {
  assignmentCount?: number;
  avatar?: string;
  contentCount?: number;
  id?: string;
  name?: string;
  school?: string;
}

export interface DeltaDto {
  assignments?: number;
  score?: number;
  students?: number;
  teachers?: number;
}

export interface KpiDto {
  activeStudents?: number;
  activeTeachers?: number;
  avgScore?: number;
  delta?: DeltaDto;
  totalAssignments?: number;
}

export interface DailyUsageDto {
  date?: string;
  exams?: number;
  interactive?: number;
  podcasts?: number;
}

export interface AlertDto {
  dropPercent?: number;
  schoolId?: string;
  schoolName?: string;
  type?: string;
}

export interface DashboardDto {
  alerts?: AlertDto[];
  dailyUsage?: DailyUsageDto[];
  kpi?: KpiDto;
  topTeachers?: TopTeacherDto[];
}

export interface ListEssayGradingSubSingleResultDto {
  data?: EssayGradingSubSingleResultDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type SubPersonDtoUserRole =
  (typeof SubPersonDtoUserRole)[keyof typeof SubPersonDtoUserRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubPersonDtoUserRole = {
  ANONYMOUS: "ANONYMOUS",
  STUDENT: "STUDENT",
  ADMIN: "ADMIN",
  TEACHER: "TEACHER",
  PARENT: "PARENT",
  MADLEN_ADMIN: "MADLEN_ADMIN",
} as const;

export interface SubPersonDto {
  email?: string;
  id?: number;
  name?: string;
  userRole?: SubPersonDtoUserRole;
}

export type FilterResponseDtoCoursesItem =
  (typeof FilterResponseDtoCoursesItem)[keyof typeof FilterResponseDtoCoursesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterResponseDtoCoursesItem = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface FilterResponseDto {
  classrooms?: ClassroomResponseDto[];
  courses?: FilterResponseDtoCoursesItem[];
  grades?: number[];
  schools?: string[];
  students?: SubPersonDto[];
  teachers?: SubPersonDto[];
}

export interface ListInteractiveMaterialResponseDto {
  data?: BaseInteractiveMaterialResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type BaseInteractiveMaterialResponseDtoStatus =
  (typeof BaseInteractiveMaterialResponseDtoStatus)[keyof typeof BaseInteractiveMaterialResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInteractiveMaterialResponseDtoStatus = {
  INITIALIZING: "INITIALIZING",
  FAILED: "FAILED",
  READY: "READY",
  EDITING: "EDITING",
} as const;

export type BaseInteractiveMaterialResponseDtoGeneratorMode =
  (typeof BaseInteractiveMaterialResponseDtoGeneratorMode)[keyof typeof BaseInteractiveMaterialResponseDtoGeneratorMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInteractiveMaterialResponseDtoGeneratorMode = {
  YOUTUBE: "YOUTUBE",
  PDF: "PDF",
  TEXT: "TEXT",
} as const;

export type BaseInteractiveMaterialResponseDtoContentLanguage =
  (typeof BaseInteractiveMaterialResponseDtoContentLanguage)[keyof typeof BaseInteractiveMaterialResponseDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInteractiveMaterialResponseDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface BaseInteractiveMaterialResponseDto {
  contentJsonS3Url?: string;
  contentLanguage?: BaseInteractiveMaterialResponseDtoContentLanguage;
  createdAt: string;
  description?: string;
  generatorMode?: BaseInteractiveMaterialResponseDtoGeneratorMode;
  id: number;
  pdfUrl?: string;
  status: BaseInteractiveMaterialResponseDtoStatus;
  text?: string;
  title?: string;
  updatedAt: string;
  youtubeDescription?: string;
  youtubeLength?: number;
  youtubeThumbnailUrl?: string;
  youtubeTitle?: string;
  youtubeUrl?: string;
}

export interface ListLessonPlannerV2ResponseDto {
  data?: LessonPlannerV2ResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListQuestionSolverV2ResponseDto {
  data?: GetQuestionSolverResponseDtoV2[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type AssignmentCountByCourseTypeAndGradeCourse =
  (typeof AssignmentCountByCourseTypeAndGradeCourse)[keyof typeof AssignmentCountByCourseTypeAndGradeCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignmentCountByCourseTypeAndGradeCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface AssignmentCountByCourseTypeAndGrade {
  assignmentCount: number;
  course: AssignmentCountByCourseTypeAndGradeCourse;
  fbCount: number;
  generator: string;
  grade: number;
  matchCount: number;
  oeCount: number;
  testCount: number;
  tfCount: number;
  totalQCount: number;
}

export type ChatsCourseGradeDistributionDtoCourse =
  (typeof ChatsCourseGradeDistributionDtoCourse)[keyof typeof ChatsCourseGradeDistributionDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatsCourseGradeDistributionDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface ChatsCourseGradeDistributionDto {
  chatCount: number;
  course: ChatsCourseGradeDistributionDtoCourse;
  grade?: number;
}

export interface MessageCountDistributionOfChatsPerCourse {
  chatCount: number;
  course: string;
  messageCount: number;
}

export interface MessageCountDistributionOfChats {
  chatCount: number;
  messageCount: number;
}

export interface AverageMessageCountPerChat {
  isPredefined?: boolean;
  messageContentType: string;
  sender: string;
  sumMsgCount: number;
}

export interface QuestionSolverCourseDistributionDto {
  course: string;
  qcount?: number;
}

export interface TeacherActivityLogDto {
  activityDate: string;
  activityTime: string;
  activityType: string;
  userEmail: string;
  userId: number;
  userName: string;
  userSurname: string;
}

export interface TeacherActivitySummaryDto {
  lastActivity: string;
  totalActivities: number;
  userEmail: string;
  userId: number;
  userName: string;
  userSurname: string;
}

export interface DailyActiveTeacherDto {
  metricValue: number;
  timeBucket: string;
}

export interface UserTopGradeDto {
  grade: string;
  totalToolsUsed: number;
}

export interface TeacherToolPerGradeMetrics {
  grade: string;
  numberOfTeacherTools: number;
}

export type TeacherToolPerToolTypeMetricsToolType =
  (typeof TeacherToolPerToolTypeMetricsToolType)[keyof typeof TeacherToolPerToolTypeMetricsToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherToolPerToolTypeMetricsToolType = {
  AI_ASSESSMENT_SCALE: "AI_ASSESSMENT_SCALE",
  AI_ASSIGNMENT: "AI_ASSIGNMENT",
  AI_RESISTANT_HOMEWORK: "AI_RESISTANT_HOMEWORK",
  AI_SUPPORTED_TASKS: "AI_SUPPORTED_TASKS",
  BLOOMS_TAXONOMY_ACTIVITIES: "BLOOMS_TAXONOMY_ACTIVITIES",
  CHOICE_BOARD: "CHOICE_BOARD",
  CLASSROOM_MANAGEMENT: "CLASSROOM_MANAGEMENT",
  COLLABORATIVE_GROUP_WORK: "COLLABORATIVE_GROUP_WORK",
  COMMON_MISCONCEPTION: "COMMON_MISCONCEPTION",
  CONCEPTUAL_UNDERSTANDING: "CONCEPTUAL_UNDERSTANDING",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  EXIT_TICKET_GENERATOR: "EXIT_TICKET_GENERATOR",
  FORMATIVE_ASSESSMENT: "FORMATIVE_ASSESSMENT",
  HOMEWORK_IDEA: "HOMEWORK_IDEA",
  IMAGE_GENERATOR: "IMAGE_GENERATOR",
  LESSON_HOOK: "LESSON_HOOK",
  MINDMAP_GENERATOR: "MINDMAP_GENERATOR",
  PERFORMANCE_TASK: "PERFORMANCE_TASK",
  PODCAST: "PODCAST",
  PROJECT_BASED_LEARNING: "PROJECT_BASED_LEARNING",
  REAL_WORLD_CONNECTION: "REAL_WORLD_CONNECTION",
  RUBRIC_GENERATOR: "RUBRIC_GENERATOR",
  SUMMARIZER: "SUMMARIZER",
  TEXT_LEVELER: "TEXT_LEVELER",
  TRANSFER_ACTIVITY: "TRANSFER_ACTIVITY",
  UDL_CHOICE_BOARD: "UDL_CHOICE_BOARD",
  VOCABULARY_LIST: "VOCABULARY_LIST",
  HEYGEN_AVATAR: "HEYGEN_AVATAR",
  ARTICLE_GENERATOR: "ARTICLE_GENERATOR",
  SKETCH_GENERATOR: "SKETCH_GENERATOR",
} as const;

export interface TeacherToolPerToolTypeMetrics {
  toolType: TeacherToolPerToolTypeMetricsToolType;
  totalToolCount: number;
}

export interface ToolUsageMetric {
  metricDescription: string;
  metricValue: number;
}

export interface UserTeacherToolUsageMetrics {
  numberOfTeacherTools: number;
  userCount: number;
}

export interface TeacherToolsStatisticsResponseDto {
  toolPerGradeMetrics?: TeacherToolPerGradeMetrics[];
  toolPerToolTypeMetrics?: TeacherToolPerToolTypeMetrics[];
  userToolUsageMetrics?: UserTeacherToolUsageMetrics[];
}

export interface ActiveStudentMetrics {
  activeChatPercentage?: number;
  anyChatPercentage?: number;
  fullEngagementPercentage?: number;
  questionSolvingPercentage?: number;
  totalRegisteredUsers?: number;
  usersWithActiveChats?: number;
  usersWithActiveChatsAndSolving?: number;
  usersWithAnyChats?: number;
  usersWithBothActivities?: number;
  usersWithSolvedQuestions?: number;
}

export interface UserGradeDistributionDto {
  code?: string;
  grade?: number;
  userCount: number;
  userStatus: string;
}

export interface PageStudentResponseDto {
  content?: StudentResponseDto[];
  empty?: boolean;
  first?: boolean;
  last?: boolean;
  number?: number;
  numberOfElements?: number;
  pageable?: PageableObject;
  size?: number;
  sort?: SortObject;
  totalElements?: number;
  totalPages?: number;
}

export type FilterRequestDtoCoursesItem =
  (typeof FilterRequestDtoCoursesItem)[keyof typeof FilterRequestDtoCoursesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FilterRequestDtoCoursesItem = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface FilterRequestDto {
  assignmentTypes?: string[];
  classroomIds?: number[];
  courses?: FilterRequestDtoCoursesItem[];
  endDate?: string;
  grades?: number[];
  /** @minimum 1 */
  page?: number;
  schools?: string[];
  searchTerm?: string;
  /** @minimum 1 */
  size?: number;
  startDate?: string;
  status?: string[];
  studentIds?: number[];
  teacherIds?: number[];
}

export type TeacherDetailResponseDtoTeacherToolsItem =
  | AiAssessmentScaleResponseDto
  | AiAssignmentResponseDto
  | AiResistantHomeworkResponseDto
  | AiSupportedTasksResponseDto
  | ArticleGeneratorResponseDto
  | BloomsTaxonomyActivitiesResponseDto
  | ChoiceBoardResponseDto
  | ClassroomManagementResponseDto
  | CollaborativeGroupWorkResponseDto
  | CommonMisconceptionResponseDto
  | ConceptualUnderstandingResponseDto
  | EssentialQuestionsResponseDto
  | ExitTicketGeneratorResponseDto
  | FormativeAssessmentResponseDto
  | HomeworkIdeaResponseDto
  | ImageGeneratorResponseDto
  | LessonHookResponseDto
  | MindmapGeneratorResponseDto
  | PerformanceTaskResponseDto
  | PodcastResponseDto
  | ProjectBasedLearningResponseDto
  | RealWorldConnectionResponseDto
  | RubricGeneratorResponseDto
  | SketchGeneratorResponseDto
  | SummarizerResponseDto
  | TextLevelerResponseDto
  | TransferActivityResponseDto
  | UdlChoiceBoardResponseDto
  | VideoAvatarResponseDto
  | VocabularyListResponseDto;

export type TeacherDetailResponseDtoMemory = { [key: string]: string };

export interface TeacherDetailResponseDto {
  assignments?: BaseAssignmentResponseDto[];
  audits?: BaseAuditDto[];
  city?: string;
  classes?: ClassroomResponseDto[];
  createdAt?: string;
  edlinkPersonId?: string;
  email: string;
  essayGraders?: EssayGradingRubricResultDto[];
  grade?: string[];
  hasActiveEdlinkToken?: boolean;
  hasJoinedAcademy?: boolean;
  id: number;
  lessonPlanners?: LessonPlannerV2ResponseDto[];
  memory: TeacherDetailResponseDtoMemory;
  name: string;
  preferences?: UserPreferences;
  role?: string;
  school?: string;
  surname: string;
  teacherProDate?: string;
  teacherTools?: TeacherDetailResponseDtoTeacherToolsItem[];
}

export interface MiniEssayGradingSubSingleResultDto {
  createdAt?: string;
  id?: number;
  result?: NewEssayEvaluationResult;
}

export interface EssayGradingRubricResultDto {
  createdAt?: string;
  essayResults?: MiniEssayGradingSubSingleResultDto[];
  id?: number;
  rubricFile?: TeacherDocumentResponseDto;
}

export interface PaginatedTeacherResponseDto {
  data?: TeacherResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface GenericDataDto {
  totalClasses?: number;
  totalStudents?: number;
  totalTeachers?: number;
  totalTimeSavedMinutes?: number;
  totalToolUsage?: number;
}

export interface QuestionTypeBarItem {
  questionType?: string;
  successRate?: number;
}

export interface StudentDetailsDto {
  email?: string;
  id?: number;
  lastTenAssignments?: AssignmentLineItem[];
  name?: string;
  questionTypeDistribution?: QuestionTypeBarItem[];
  surname?: string;
  table?: AssignmentsAndMaterialsTable;
}

export type AssignmentRowCourse =
  (typeof AssignmentRowCourse)[keyof typeof AssignmentRowCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignmentRowCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface AssignmentRow {
  completedAt?: string;
  course?: AssignmentRowCourse;
  difficulty?: string;
  dueDate?: string;
  interactiveMaterial?: boolean;
  maxScore?: number;
  name?: string;
  score?: number;
  status?: string;
}

export interface AssignmentsAndMaterialsTable {
  rows?: AssignmentRow[];
}

export interface AssignmentLineItem {
  assignmentId?: number;
  assignmentName?: string;
  averageScore?: number;
  date?: string;
  finishDate?: string;
  studentScore?: number;
}

export interface PageStudentTableRowDto {
  content?: StudentTableRowDto[];
  empty?: boolean;
  first?: boolean;
  last?: boolean;
  number?: number;
  numberOfElements?: number;
  pageable?: PageableObject;
  size?: number;
  sort?: SortObject;
  totalElements?: number;
  totalPages?: number;
}

export type ClassInfoCourse =
  (typeof ClassInfoCourse)[keyof typeof ClassInfoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassInfoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface ClassInfo {
  course?: ClassInfoCourse;
  grade?: number;
  name?: string;
}

export interface StudentTableRowDto {
  classes?: ClassInfo[];
  completionRate?: number;
  email?: string;
  id?: number;
  lastActivityAt?: string;
  name?: string;
  surname?: string;
  totalAssignmentCount?: number;
  totalAveragePoint?: number;
}

export interface ToolUsageAgg {
  count?: number;
  lastUsedAt?: string;
}

export type TeacherDetailsDtoToolUsage = { [key: string]: ToolUsageAgg };

export interface TeacherDetailsDto {
  email?: string;
  id?: number;
  name?: string;
  surname?: string;
  toolUsage?: TeacherDetailsDtoToolUsage;
}

export interface TeacherTableRowDto {
  email?: string;
  id?: number;
  name?: string;
  surname?: string;
  totalAssignmentsAssignedCount?: number;
  totalStudentCount?: number;
  totalToolGenerationCount?: number;
  uniqueToolTypeUsedCount?: number;
}

export interface SortObject {
  empty?: boolean;
  sorted?: boolean;
  unsorted?: boolean;
}

export interface PageableObject {
  offset?: number;
  paged?: boolean;
  pageNumber?: number;
  pageSize?: number;
  sort?: SortObject;
  unpaged?: boolean;
}

export interface PageTeacherTableRowDto {
  content?: TeacherTableRowDto[];
  empty?: boolean;
  first?: boolean;
  last?: boolean;
  number?: number;
  numberOfElements?: number;
  pageable?: PageableObject;
  size?: number;
  sort?: SortObject;
  totalElements?: number;
  totalPages?: number;
}

export type ToolUsageByCourseDtoPerToolTypeCounts = { [key: string]: number };

export type ToolUsageByCourseDtoCourse =
  (typeof ToolUsageByCourseDtoCourse)[keyof typeof ToolUsageByCourseDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ToolUsageByCourseDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface ToolUsageByCourseDto {
  course?: ToolUsageByCourseDtoCourse;
  perToolTypeCounts?: ToolUsageByCourseDtoPerToolTypeCounts;
  totalTools?: number;
}

export type StudentAnswerSimpleDtoAnswer = { [key: string]: unknown };

export interface StudentAnswerSimpleDto {
  answer?: StudentAnswerSimpleDtoAnswer;
  score?: number;
}

export type GetStudentAssignmentDetailResponseDtoStudentAssignmentStatus =
  (typeof GetStudentAssignmentDetailResponseDtoStudentAssignmentStatus)[keyof typeof GetStudentAssignmentDetailResponseDtoStudentAssignmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStudentAssignmentDetailResponseDtoStudentAssignmentStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  DID_NOT_START: "DID_NOT_START",
} as const;

export type GetStudentAssignmentDetailResponseDtoGradingStatus =
  (typeof GetStudentAssignmentDetailResponseDtoGradingStatus)[keyof typeof GetStudentAssignmentDetailResponseDtoGradingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStudentAssignmentDetailResponseDtoGradingStatus = {
  AI_GRADING_IN_PROGRESS: "AI_GRADING_IN_PROGRESS",
  AI_GRADING_COMPLETE: "AI_GRADING_COMPLETE",
  TEACHER_GRADED: "TEACHER_GRADED",
} as const;

export type GetStudentAssignmentDetailResponseDtoCourseType =
  (typeof GetStudentAssignmentDetailResponseDtoCourseType)[keyof typeof GetStudentAssignmentDetailResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStudentAssignmentDetailResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetStudentAssignmentDetailResponseDtoAssignmentType =
  (typeof GetStudentAssignmentDetailResponseDtoAssignmentType)[keyof typeof GetStudentAssignmentDetailResponseDtoAssignmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStudentAssignmentDetailResponseDtoAssignmentType = {
  CHAT: "CHAT",
  QUIZ: "QUIZ",
  HOMEWORK: "HOMEWORK",
} as const;

export type GetStudentAssignmentDetailResponseDtoAssignmentStatus =
  (typeof GetStudentAssignmentDetailResponseDtoAssignmentStatus)[keyof typeof GetStudentAssignmentDetailResponseDtoAssignmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStudentAssignmentDetailResponseDtoAssignmentStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  ASSIGNED: "ASSIGNED",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
} as const;

export type GetStudentAssignmentDetailResponseDtoAssignmentDifficulty =
  (typeof GetStudentAssignmentDetailResponseDtoAssignmentDifficulty)[keyof typeof GetStudentAssignmentDetailResponseDtoAssignmentDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStudentAssignmentDetailResponseDtoAssignmentDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface GetStudentAssignmentDetailResponseDto {
  assignedStudentsWithClassrooms?: AssignAssignmentRequestBodyNewItem[];
  assignment?: AssignmentWithDetailDto;
  assignmentCanStudentsGoBackBetweenQuestions?: boolean;
  assignmentCreatedAt: string;
  assignmentCreatedBy: number;
  assignmentDescription?: string;
  assignmentDifficulty?: GetStudentAssignmentDetailResponseDtoAssignmentDifficulty;
  assignmentDuration?: number;
  assignmentEndDate: string;
  assignmentGrade?: number;
  assignmentId: number;
  assignmentImageUrl?: string;
  assignmentIsAssignmentStopped?: boolean;
  assignmentLastStopTime?: string;
  assignmentName?: string;
  assignmentShouldStudentsSeeAnswersAutomaticallyAfterFinish?: boolean;
  assignmentShouldStudentsSeeAnswersBeforeEndDateAfterFinish?: boolean;
  assignmentStartDate: string;
  assignmentStatus: GetStudentAssignmentDetailResponseDtoAssignmentStatus;
  assignmentType: GetStudentAssignmentDetailResponseDtoAssignmentType;
  chatIds?: number[];
  courseType: GetStudentAssignmentDetailResponseDtoCourseType;
  gradingStatus?: GetStudentAssignmentDetailResponseDtoGradingStatus;
  studentAssignmentStatus: GetStudentAssignmentDetailResponseDtoStudentAssignmentStatus;
  studentEndDate: string;
  studentProgressInTheAssignment: number;
  studentStartDate: string;
  studentTotalPoints: number;
  totalPointsOfAssignment: number;
  totalQuestionCount: number;
}

export type AssignmentWithDetailDtoQuestionsItem =
  | BaseQuestionDto
  | BaseFillTheBlankQuestionDto
  | BaseMatchQuestionDto
  | BaseOpenEndedQuestionDto
  | BaseTestQuestionDto
  | BaseTrueFalseQuestionDto;

export type AssignmentWithDetailDtoDifficulty =
  (typeof AssignmentWithDetailDtoDifficulty)[keyof typeof AssignmentWithDetailDtoDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignmentWithDetailDtoDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export type AssignmentWithDetailDtoAnswers = {
  [key: string]: StudentAnswerSimpleDto;
};

export interface AssignmentWithDetailDto {
  answers?: AssignmentWithDetailDtoAnswers;
  chatIds?: number[];
  difficulty: AssignmentWithDetailDtoDifficulty;
  endDate?: string;
  id?: number;
  name?: string;
  questions?: AssignmentWithDetailDtoQuestionsItem[];
  startDate?: string;
}

export interface StudentDetailResponseDto {
  appVersion?: string;
  audits: BaseAuditDto[];
  avatarName?: string;
  blogQuizProgress: BaseStudentBlogPostProgressResponseDto[];
  chats: ChatWithMessages[];
  createdAt?: string;
  dailyAssignmentProgress: BaseStudentDailyAssignmentProgressResponseDto[];
  deletedAt?: string;
  email: string;
  grade?: number;
  id: number;
  name: string;
  questionSolvers: QuestionSolvers[];
  surname: string;
  xp?: number;
}

export type QuestionSolversSteps = { [key: string]: JsonNode };

export type QuestionSolversFinalAnswer = { [key: string]: string };

export type QuestionSolversCourse =
  (typeof QuestionSolversCourse)[keyof typeof QuestionSolversCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSolversCourse = {
  UNKNOWN: "UNKNOWN",
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  PHILOSOPHY: "PHILOSOPHY",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface QuestionSolvers {
  course?: QuestionSolversCourse;
  createdAt?: string;
  finalAnswer?: QuestionSolversFinalAnswer;
  id?: number;
  name?: string;
  steps?: QuestionSolversSteps;
  uri?: string;
}

export type ChatWithMessagesCourseType =
  (typeof ChatWithMessagesCourseType)[keyof typeof ChatWithMessagesCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatWithMessagesCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ChatMessagesSender =
  (typeof ChatMessagesSender)[keyof typeof ChatMessagesSender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessagesSender = {
  AI: "AI",
  USER: "USER",
} as const;

export type ChatMessagesMessageContentType =
  (typeof ChatMessagesMessageContentType)[keyof typeof ChatMessagesMessageContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessagesMessageContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export interface ChatMessages {
  createdAt?: string;
  id?: number;
  isFavourite?: boolean;
  isPredefined?: boolean;
  mediaPublicUrl?: string;
  message?: string;
  messageContentType?: ChatMessagesMessageContentType;
  processedMessage?: string;
  sender?: ChatMessagesSender;
}

export interface ChatWithMessages {
  courseType?: ChatWithMessagesCourseType;
  createdAt?: string;
  grade?: number;
  id?: number;
  isFavourite?: boolean;
  mainLlm?: string;
  messages?: ChatMessages[];
  name?: string;
}

export interface BaseAuditDto {
  actionName?: string;
  extraDetails?: JsonNode;
  handledAt?: string;
  id?: number;
}

export interface PaginatedOrganizationAdminResponseDto {
  data?: OrganizationAdminResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type HomeworkAssignmentPdfCreateRequestItemQuestionsItem =
  | FillTheBlanksQuestionCreateRequestDto
  | MatchQuestionCreateRequestDto
  | OpenEndedQuestionCreateRequestDto
  | TestQuestionCreateRequestDto
  | TrueFalseQuestionCreateRequestDto;

export interface HomeworkAssignmentPdfCreateRequestItem {
  questions?: HomeworkAssignmentPdfCreateRequestItemQuestionsItem[];
  showAnswers?: boolean;
}

export interface PdfStatusResponseItem {
  isReady?: boolean;
}

export interface QuestionHelperTagsResponseDto {
  tags?: string[];
}

export interface QuestionHelperListResponseDto {
  data?: QuestionHelperResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type QuestionFileNodeDtoV2Type =
  (typeof QuestionFileNodeDtoV2Type)[keyof typeof QuestionFileNodeDtoV2Type];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionFileNodeDtoV2Type = {
  QUESTION: "QUESTION",
  QUESTION_FOLDER: "QUESTION_FOLDER",
  CHAT: "CHAT",
  CHAT_FOLDER: "CHAT_FOLDER",
  ROOT_FOLDER: "ROOT_FOLDER",
} as const;

export type QuestionFileNodeDtoV2QuestionSteps = { [key: string]: JsonNode };

export type QuestionFileNodeDtoV2QuestionFinalAnswer = {
  [key: string]: string;
};

export type QuestionFileNodeDtoV2ExportUrl = { [key: string]: string };

export type QuestionFileNodeDtoV2Course =
  (typeof QuestionFileNodeDtoV2Course)[keyof typeof QuestionFileNodeDtoV2Course];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionFileNodeDtoV2Course = {
  UNKNOWN: "UNKNOWN",
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  PHILOSOPHY: "PHILOSOPHY",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type QuestionFileNodeDtoV2AudioUrl = { [key: string]: string };

export interface QuestionFileNodeDtoV2 {
  audioUrl?: QuestionFileNodeDtoV2AudioUrl;
  chatId?: number;
  children?: BaseFileNodeDto[];
  course?: QuestionFileNodeDtoV2Course;
  createdAt: string;
  exportUrl?: QuestionFileNodeDtoV2ExportUrl;
  flashcards?: FlashcardItem[];
  id: number;
  name?: string;
  parentId?: number;
  questionFinalAnswer?: QuestionFileNodeDtoV2QuestionFinalAnswer;
  questionId?: number;
  questionSteps?: QuestionFileNodeDtoV2QuestionSteps;
  questionUri?: string;
  type: QuestionFileNodeDtoV2Type;
  userId: number;
}

export interface ListSketchGeneratorResponseDto {
  data?: SketchGeneratorResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface BaseStaticQuestionAnswerResponseDto {
  answer?: string;
  question?: string;
}

export interface StudentInteractiveMaterialDetailResponseDto {
  interactiveMaterial: InteractiveMaterialResponseDto;
  studentInteractiveMaterial: StudentInteractiveMaterialResponseDto;
}

export type StudentUnifiedTaskResponseDtoType =
  (typeof StudentUnifiedTaskResponseDtoType)[keyof typeof StudentUnifiedTaskResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentUnifiedTaskResponseDtoType = {
  ASSIGNMENT: "ASSIGNMENT",
  INTERACTIVE_MATERIAL: "INTERACTIVE_MATERIAL",
  PODCAST: "PODCAST",
} as const;

export type StudentUnifiedTaskResponseDtoCourseType =
  (typeof StudentUnifiedTaskResponseDtoCourseType)[keyof typeof StudentUnifiedTaskResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentUnifiedTaskResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type StudentUnifiedTaskResponseDtoAssignmentType =
  (typeof StudentUnifiedTaskResponseDtoAssignmentType)[keyof typeof StudentUnifiedTaskResponseDtoAssignmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentUnifiedTaskResponseDtoAssignmentType = {
  CHAT: "CHAT",
  QUIZ: "QUIZ",
  HOMEWORK: "HOMEWORK",
} as const;

export interface StudentUnifiedTaskResponseDto {
  assignmentType?: StudentUnifiedTaskResponseDtoAssignmentType;
  courseType?: StudentUnifiedTaskResponseDtoCourseType;
  createdAt?: string;
  endDate?: string;
  id?: number;
  status?: string;
  thumbnailUrl?: string;
  title?: string;
  type?: StudentUnifiedTaskResponseDtoType;
}

export interface GroupedUnifiedTaskResponseDto {
  finished?: StudentUnifiedTaskResponseDto[];
  overdue?: StudentUnifiedTaskResponseDto[];
  started?: StudentUnifiedTaskResponseDto[];
  waiting?: StudentUnifiedTaskResponseDto[];
}

export type StudentAssignmentDetailStudentPerspectiveResponseDtoStudentAssignmentStatus =
  (typeof StudentAssignmentDetailStudentPerspectiveResponseDtoStudentAssignmentStatus)[keyof typeof StudentAssignmentDetailStudentPerspectiveResponseDtoStudentAssignmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailStudentPerspectiveResponseDtoStudentAssignmentStatus =
  {
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    FINISHED: "FINISHED",
    DID_NOT_START: "DID_NOT_START",
  } as const;

export type StudentAssignmentDetailStudentPerspectiveResponseDtoQuestionsAndOptionalAnswersOptionalCorrectAnswersItem =

    | FillTheBlankQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
    | MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
    | OpenEndedQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
    | TestQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto
    | TrueFalseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto;

export type StudentAssignmentDetailStudentPerspectiveResponseDtoGradingStatus =
  (typeof StudentAssignmentDetailStudentPerspectiveResponseDtoGradingStatus)[keyof typeof StudentAssignmentDetailStudentPerspectiveResponseDtoGradingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailStudentPerspectiveResponseDtoGradingStatus =
  {
    AI_GRADING_IN_PROGRESS: "AI_GRADING_IN_PROGRESS",
    AI_GRADING_COMPLETE: "AI_GRADING_COMPLETE",
    TEACHER_GRADED: "TEACHER_GRADED",
  } as const;

export type StudentAssignmentDetailStudentPerspectiveResponseDtoCourseType =
  (typeof StudentAssignmentDetailStudentPerspectiveResponseDtoCourseType)[keyof typeof StudentAssignmentDetailStudentPerspectiveResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailStudentPerspectiveResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentType =
  (typeof StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentType)[keyof typeof StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentType =
  {
    CHAT: "CHAT",
    QUIZ: "QUIZ",
    HOMEWORK: "HOMEWORK",
  } as const;

export type StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentStatus =
  (typeof StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentStatus)[keyof typeof StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentStatus =
  {
    DRAFT: "DRAFT",
    PENDING: "PENDING",
    ASSIGNED: "ASSIGNED",
    FAILED: "FAILED",
    IN_PROGRESS: "IN_PROGRESS",
    FINISHED: "FINISHED",
  } as const;

export type StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentDifficulty =
  (typeof StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentDifficulty)[keyof typeof StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentDifficulty =
  {
    EASY: "EASY",
    MEDIUM: "MEDIUM",
    HARD: "HARD",
  } as const;

export interface StudentAssignmentDetailStudentPerspectiveResponseDto {
  assignedStudentsWithClassrooms?: AssignAssignmentRequestBodyNewItem[];
  assignmentCanStudentsGoBackBetweenQuestions?: boolean;
  assignmentCreatedAt: string;
  assignmentCreatedBy: number;
  assignmentDescription?: string;
  assignmentDifficulty?: StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentDifficulty;
  assignmentDuration?: number;
  assignmentEndDate: string;
  assignmentGrade?: number;
  assignmentId: number;
  assignmentImageUrl?: string;
  assignmentIsAssignmentStopped?: boolean;
  assignmentLastStopTime?: string;
  assignmentName?: string;
  assignmentShouldStudentsSeeAnswersAutomaticallyAfterFinish?: boolean;
  assignmentShouldStudentsSeeAnswersBeforeEndDateAfterFinish?: boolean;
  assignmentStartDate: string;
  assignmentStatus: StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentStatus;
  assignmentType: StudentAssignmentDetailStudentPerspectiveResponseDtoAssignmentType;
  chatIds?: number[];
  courseType: StudentAssignmentDetailStudentPerspectiveResponseDtoCourseType;
  gradingStatus?: StudentAssignmentDetailStudentPerspectiveResponseDtoGradingStatus;
  questionsAndOptionalAnswersOptionalCorrectAnswers?: StudentAssignmentDetailStudentPerspectiveResponseDtoQuestionsAndOptionalAnswersOptionalCorrectAnswersItem[];
  studentAssignmentStatus: StudentAssignmentDetailStudentPerspectiveResponseDtoStudentAssignmentStatus;
  studentEndDate: string;
  studentProgressInTheAssignment: number;
  studentStartDate: string;
  studentTotalPoints: number;
  totalPointsOfAssignment: number;
  totalQuestionCount: number;
}

export interface AssignmentDuringQuizStudentPerspectiveResponseDto {
  endDate?: string;
  id?: number;
  isAssignmentStopped?: boolean;
  lastStopTime?: string;
}

export type TrueFalseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf =
  {
    questionCorrectAnswer?: boolean;
    studentAnswer?: boolean;
  };

export type TrueFalseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto =
  BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto &
    TrueFalseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf;

export type TestQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfOptions =
  { [key: string]: string };

export type TestQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf =
  {
    options?: TestQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfOptions;
    questionCorrectAnswer?: string;
    studentAnswer?: string;
  };

export type TestQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto =
  BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto &
    TestQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf;

export type OpenEndedQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf =
  {
    questionCorrectAnswer?: string;
    studentAnswer?: string;
  };

export type OpenEndedQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto =
  BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto &
    OpenEndedQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf;

export type MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto =
  BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto &
    MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf;

export type MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfStudentAnswer =
  { [key: string]: string };

export type MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfRightPart =
  { [key: string]: string };

export type MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfQuestionCorrectAnswer =
  { [key: string]: string };

export type MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfLeftPart =
  { [key: string]: string };

export type MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf =
  {
    leftPart?: MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfLeftPart;
    questionCorrectAnswer?: MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfQuestionCorrectAnswer;
    rightPart?: MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfRightPart;
    studentAnswer?: MatchQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOfStudentAnswer;
  };

export type FillTheBlankQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf =
  {
    questionCorrectAnswer?: string[];
    questionPossibleAnswers?: string[];
    studentAnswer?: string[];
  };

export type FillTheBlankQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto =
  BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto &
    FillTheBlankQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoAllOf;

export type BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoStudentAnswer =
  { [key: string]: unknown };

export type BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionType =
  (typeof BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionType)[keyof typeof BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionType =
  {
    TF: "TF",
    TEST: "TEST",
    OE: "OE",
    FB: "FB",
    MATCH: "MATCH",
  } as const;

export type BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionDifficulty =
  (typeof BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionDifficulty)[keyof typeof BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionDifficulty =
  {
    EASY: "EASY",
    MEDIUM: "MEDIUM",
    HARD: "HARD",
  } as const;

export type BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionCorrectAnswer =
  { [key: string]: unknown };

export interface BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDto {
  chatId?: number;
  didTeacherGrade: boolean;
  questionBody: string;
  questionCorrectAnswer?: BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionCorrectAnswer;
  questionDifficulty: BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionDifficulty;
  questionExplanation?: string;
  questionId: number;
  questionMediaUrl?: string;
  questionPoint: number;
  questionType: BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoQuestionType;
  studentAnswer?: BaseQuestionWithOptionalStudentAnswerAndOptionalCorrectAnswerDtoStudentAnswer;
  studentAnswerCreatedAt?: string;
  studentAnswerExplanation?: string;
  studentAnswerFeedback?: string;
  studentScore?: number;
}

export interface LeaderboardUserDTO {
  id?: number;
  name?: string;
  userRank?: number;
  xp?: number;
}

export interface LeaderboardDTO {
  topUsers?: LeaderboardUserDTO[];
  user?: LeaderboardUserDTO;
}

export interface LeaderboardV2DTO {
  globalLogin?: LeaderboardDTO;
  globalXp?: LeaderboardDTO;
  gradeLogin?: LeaderboardDTO;
  gradeXp?: LeaderboardDTO;
}

export interface ServerSentEventString {
  [key: string]: unknown;
}

export type PronunciationAssignmentSummaryDtoGenerationType =
  (typeof PronunciationAssignmentSummaryDtoGenerationType)[keyof typeof PronunciationAssignmentSummaryDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PronunciationAssignmentSummaryDtoGenerationType = {
  WORD: "WORD",
  SENTENCE: "SENTENCE",
} as const;

export type PronunciationAssignmentSummaryDtoContentLanguage =
  (typeof PronunciationAssignmentSummaryDtoContentLanguage)[keyof typeof PronunciationAssignmentSummaryDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PronunciationAssignmentSummaryDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type PronunciationAssignmentSummaryDtoCefrLevel =
  (typeof PronunciationAssignmentSummaryDtoCefrLevel)[keyof typeof PronunciationAssignmentSummaryDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PronunciationAssignmentSummaryDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type PronunciationAssignmentSummaryDtoAccent =
  (typeof PronunciationAssignmentSummaryDtoAccent)[keyof typeof PronunciationAssignmentSummaryDtoAccent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PronunciationAssignmentSummaryDtoAccent = {
  BRITISH: "BRITISH",
  AMERICAN: "AMERICAN",
} as const;

export interface PronunciationAssignmentSummaryDto {
  accent?: PronunciationAssignmentSummaryDtoAccent;
  cefrLevel?: PronunciationAssignmentSummaryDtoCefrLevel;
  contentLanguage?: PronunciationAssignmentSummaryDtoContentLanguage;
  createdAt?: string;
  generationType?: PronunciationAssignmentSummaryDtoGenerationType;
  id?: number;
  itemsCount?: number;
  publicCode?: string;
  title?: string;
}

export interface ListPronunciationAssignmentResponseDto {
  assignments?: PronunciationAssignmentSummaryDto[];
  pageNumber?: number;
  pageSize?: number;
  totalElements?: number;
  totalPages?: number;
}

export type PublicAssignmentViewDtoGenerationType =
  (typeof PublicAssignmentViewDtoGenerationType)[keyof typeof PublicAssignmentViewDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicAssignmentViewDtoGenerationType = {
  WORD: "WORD",
  SENTENCE: "SENTENCE",
} as const;

export type PublicAssignmentViewDtoContentLanguage =
  (typeof PublicAssignmentViewDtoContentLanguage)[keyof typeof PublicAssignmentViewDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicAssignmentViewDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type PublicAssignmentViewDtoCefrLevel =
  (typeof PublicAssignmentViewDtoCefrLevel)[keyof typeof PublicAssignmentViewDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicAssignmentViewDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type PublicAssignmentViewDtoAccent =
  (typeof PublicAssignmentViewDtoAccent)[keyof typeof PublicAssignmentViewDtoAccent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicAssignmentViewDtoAccent = {
  BRITISH: "BRITISH",
  AMERICAN: "AMERICAN",
} as const;

export interface PublicAssignmentViewDto {
  accent?: PublicAssignmentViewDtoAccent;
  cefrLevel?: PublicAssignmentViewDtoCefrLevel;
  contentLanguage?: PublicAssignmentViewDtoContentLanguage;
  description?: string;
  generationType?: PublicAssignmentViewDtoGenerationType;
  id?: number;
  items?: PronunciationItem[];
  publicCode?: string;
  title?: string;
}

export type StudentAssignmentViewDtoGenerationType =
  (typeof StudentAssignmentViewDtoGenerationType)[keyof typeof StudentAssignmentViewDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentViewDtoGenerationType = {
  WORD: "WORD",
  SENTENCE: "SENTENCE",
} as const;

export type StudentAssignmentViewDtoContentLanguage =
  (typeof StudentAssignmentViewDtoContentLanguage)[keyof typeof StudentAssignmentViewDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentViewDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type StudentAssignmentViewDtoCefrLevel =
  (typeof StudentAssignmentViewDtoCefrLevel)[keyof typeof StudentAssignmentViewDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentViewDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type StudentAssignmentViewDtoAccent =
  (typeof StudentAssignmentViewDtoAccent)[keyof typeof StudentAssignmentViewDtoAccent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentViewDtoAccent = {
  BRITISH: "BRITISH",
  AMERICAN: "AMERICAN",
} as const;

export interface StudentAssignmentViewDto {
  accent?: StudentAssignmentViewDtoAccent;
  cefrLevel?: StudentAssignmentViewDtoCefrLevel;
  contentLanguage?: StudentAssignmentViewDtoContentLanguage;
  description?: string;
  generationType?: StudentAssignmentViewDtoGenerationType;
  id?: number;
  items?: PronunciationItem[];
  publicCode?: string;
  submission?: SubmissionResponseDto;
  title?: string;
}

export interface ListStudentAssignmentViewDto {
  assignments?: StudentAssignmentViewDto[];
  pageNumber?: number;
  pageSize?: number;
  totalElements?: number;
  totalPages?: number;
}

export interface ListSpokenDialogueResponseDto {
  data?: SpokenDialogueResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListVisualMatchingResponseDto {
  data?: VisualMatchingResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface BaseTeacherChatResponseDto {
  createdAt?: string;
  description?: string;
  id?: number;
  llmModel?: string;
  title?: string;
}

export interface ListTeacherChatResponseDto {
  data?: BaseTeacherChatResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListTeacherToolChatResponseDto {
  data?: TeacherToolChatResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListSuperToolResponseDto {
  data?: SuperToolResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type StudentAssignmentSummaryDtoStatus =
  (typeof StudentAssignmentSummaryDtoStatus)[keyof typeof StudentAssignmentSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentSummaryDtoStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  DID_NOT_START: "DID_NOT_START",
} as const;

export interface StudentAssignmentSummaryDto {
  earnedPoints?: number;
  endDate?: string;
  startDate?: string;
  status?: StudentAssignmentSummaryDtoStatus;
  studentId?: number;
  studentName?: string;
  studentSurname?: string;
  totalPoints?: number;
}

export type TeacherReviewPageSingleItemDtoStatus =
  (typeof TeacherReviewPageSingleItemDtoStatus)[keyof typeof TeacherReviewPageSingleItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherReviewPageSingleItemDtoStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  DID_NOT_START: "DID_NOT_START",
} as const;

export type TeacherReviewPageSingleItemDtoQuestionsWithStudentAnswersItem =
  | AnswerWithQuestionDto
  | AnswerWithQuestionWithoutCorrectAnswerDto
  | FillTheBlankAnswerWithQuestionDto
  | MatchAnswerWithQuestionDto
  | OpenEndedAnswerWithQuestionDto
  | TestAnswerWithQuestionDto
  | TrueFalseAnswerWithQuestionDto;

export interface TeacherReviewPageSingleItemDto {
  earnedPoints?: number;
  endDate?: string;
  questionsWithStudentAnswers?: TeacherReviewPageSingleItemDtoQuestionsWithStudentAnswersItem[];
  startDate?: string;
  status?: TeacherReviewPageSingleItemDtoStatus;
  studentId?: number;
  studentName?: string;
  studentSurname?: string;
  totalPoints?: number;
}

export interface TeacherReviewPageDto {
  assignmentId?: number;
  assignmentName?: string;
  studentAssignments?: TeacherReviewPageSingleItemDto[];
}

export interface PaginatedBaseAssignmentsResponseDto {
  data?: BaseAssignmentResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type ClassroomForAssignViewResponseDtoCourseType =
  (typeof ClassroomForAssignViewResponseDtoCourseType)[keyof typeof ClassroomForAssignViewResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassroomForAssignViewResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface BaseStudentResponseDto {
  appVersion?: string;
  avatarName?: string;
  createdAt?: string;
  deletedAt?: string;
  email: string;
  grade?: number;
  id: number;
  name: string;
  surname: string;
  xp?: number;
}

export interface ClassroomForAssignViewResponseDto {
  courseType: ClassroomForAssignViewResponseDtoCourseType;
  edlinkClassId?: string;
  googleClassroom?: boolean;
  grade: number;
  id: number;
  name: string;
  organizationId: number;
  section: string;
  studentCount: number;
  students: BaseStudentResponseDto[];
  teacherId?: number;
  uuid?: string;
  visibleCourseType?: string;
}

export interface StudentWithAssignmentsResponseDto {
  assignmentIds?: number[];
  avatarName?: string;
  createdAt?: string;
  edlinkPersonId?: string;
  email: string;
  grade?: number;
  hobbies?: string[];
  id: number;
  isPremium: boolean;
  name: string;
  preferences?: UserPreferences;
  premiumExpireDate?: string;
  rootFolderId?: number;
  studentAssignments?: StudentAssignmentResponseDto[];
  surname: string;
  xp: number;
}

export type ClassroomWithStudentDetailResponseDtoCourseType =
  (typeof ClassroomWithStudentDetailResponseDtoCourseType)[keyof typeof ClassroomWithStudentDetailResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassroomWithStudentDetailResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface ClassroomWithStudentDetailResponseDto {
  courseType: ClassroomWithStudentDetailResponseDtoCourseType;
  edlinkClassId?: string;
  googleClassroom?: boolean;
  grade: number;
  id: number;
  name: string;
  organizationId: number;
  section: string;
  studentCount: number;
  students: StudentWithAssignmentsResponseDto[];
  teacherId?: number;
  uuid?: string;
  visibleCourseType?: string;
}

export interface MinimalStudentResponseDto {
  assignmentIds?: number[];
  avatarName?: string;
  createdAt?: string;
  edlinkPersonId?: string;
  email: string;
  grade?: number;
  hobbies?: string[];
  id: number;
  isPremium: boolean;
  name: string;
  preferences?: UserPreferences;
  premiumExpireDate?: string;
  rootFolderId?: number;
  surname: string;
  xp: number;
}

export type ClassroomWithoutStudentDetailResponseDtoCourseType =
  (typeof ClassroomWithoutStudentDetailResponseDtoCourseType)[keyof typeof ClassroomWithoutStudentDetailResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassroomWithoutStudentDetailResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface BaseTeacherResponseDto {
  city?: string;
  createdAt?: string;
  edlinkPersonId?: string;
  email: string;
  grade?: string[];
  hasActiveEdlinkToken?: boolean;
  hasJoinedAcademy?: boolean;
  id: number;
  name: string;
  preferences?: UserPreferences;
  role?: string;
  school?: string;
  surname: string;
  teacherProDate?: string;
}

export interface ClassroomWithoutStudentDetailResponseDto {
  courseType: ClassroomWithoutStudentDetailResponseDtoCourseType;
  edlinkClassId?: string;
  googleClassroom?: boolean;
  grade: number;
  id: number;
  name: string;
  organizationId: number;
  section: string;
  studentCount: number;
  students: MinimalStudentResponseDto[];
  teacher?: BaseTeacherResponseDto;
  teacherId?: number;
  uuid?: string;
  visibleCourseType?: string;
}

export interface PresignedUrlResponseDto {
  cdnUrl?: string;
  fileName?: string;
  presignedUrl?: string;
  s3Url?: string;
}

export type CreateTeacherDocumentResponseDtoStatus =
  (typeof CreateTeacherDocumentResponseDtoStatus)[keyof typeof CreateTeacherDocumentResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTeacherDocumentResponseDtoStatus = {
  PROCESSING: "PROCESSING",
  READY: "READY",
  FAILED: "FAILED",
} as const;

export interface CreateTeacherDocumentResponseDto {
  bucketPath?: string;
  contentType?: string;
  downloadUrl?: string;
  fileName?: string;
  id?: number;
  presignedUrl?: string;
  size?: number;
  status?: CreateTeacherDocumentResponseDtoStatus;
  uploadedAt?: string;
  uploadedBy?: number;
  url?: string;
}

export interface ListTeacherDocumentResponseDto {
  data?: TeacherDocumentResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListSummarizerResponseDto {
  data?: SummarizerResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListRubricGeneratorResponseDto {
  data?: RubricGeneratorResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListRealWorldConnectionResponseDto {
  data?: RealWorldConnectionResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListProjectBasedLearningResponseDto {
  data?: ProjectBasedLearningResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListPodcastResponseDto {
  data?: PodcastResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListPerformanceTaskResponseDto {
  data?: PerformanceTaskResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListLessonHookResponseDto {
  data?: LessonHookResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListImageGeneratorResponseDto {
  data?: ImageGeneratorResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListHomeworkIdeaResponseDto {
  data?: HomeworkIdeaResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListFormativeAssessmentResponseDto {
  data?: FormativeAssessmentResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListExitTicketGeneratorResponseDto {
  data?: ExitTicketGeneratorResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListEssentialQuestionsResponseDto {
  data?: EssentialQuestionsResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListConceptualUnderstandingResponseDto {
  data?: ConceptualUnderstandingResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListCommonMisconceptionResponseDto {
  data?: CommonMisconceptionResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListCollaborativeGroupWorkResponseDto {
  data?: CollaborativeGroupWorkResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListClassroomManagementResponseDto {
  data?: ClassroomManagementResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListChoiceBoardResponseDto {
  data?: ChoiceBoardResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListAiResistantHomeworkResponseDto {
  data?: AiResistantHomeworkResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface TeacherProfileResponseDto {
  aiResistantHomeworks?: ListAiResistantHomeworkResponseDto;
  choiceBoards?: ListChoiceBoardResponseDto;
  classroomManagements?: ListClassroomManagementResponseDto;
  collaborativeGroupWorks?: ListCollaborativeGroupWorkResponseDto;
  commonMisconceptions?: ListCommonMisconceptionResponseDto;
  conceptualUnderstanding?: ListConceptualUnderstandingResponseDto;
  essentialQuestions?: ListEssentialQuestionsResponseDto;
  exitTickets?: ListExitTicketGeneratorResponseDto;
  formativeAssessments?: ListFormativeAssessmentResponseDto;
  homeworkIdeas?: ListHomeworkIdeaResponseDto;
  imageGenerators?: ListImageGeneratorResponseDto;
  lessonHooks?: ListLessonHookResponseDto;
  performanceTasks?: ListPerformanceTaskResponseDto;
  podcasts?: ListPodcastResponseDto;
  projectBasedLearnings?: ListProjectBasedLearningResponseDto;
  realWorldConnections?: ListRealWorldConnectionResponseDto;
  rubricGenerators?: ListRubricGeneratorResponseDto;
  summarizers?: ListSummarizerResponseDto;
  teacher?: TeacherResponseDto;
  textLevelers?: ListTextLevelerResponseDto;
  transferActivities?: ListTransferActivityResponseDto;
  udlChoiceBoards?: ListUdlChoiceBoardResponseDto;
  vocabularyLists?: ListVocabularyListResponseDto;
}

export type TypePerformanceType =
  (typeof TypePerformanceType)[keyof typeof TypePerformanceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TypePerformanceType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export interface TypePerformance {
  avgCorrectRate?: number;
  count?: number;
  type?: TypePerformanceType;
}

export interface TimeRange {
  count?: number;
  percentage?: number;
  range?: string;
}

export interface TimeDistribution {
  averageCompletionTime?: number;
  ranges?: TimeRange[];
}

export type QuestionPerformanceType =
  (typeof QuestionPerformanceType)[keyof typeof QuestionPerformanceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionPerformanceType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export interface QuestionPerformance {
  correctRate?: number;
  questionId?: number;
  type?: QuestionPerformanceType;
}

export interface AssignmentAnalyticsResponseDto {
  questionPerformance?: QuestionPerformance[];
  quickStats?: QuickStats;
  studentDistribution?: StudentDistribution[];
  timeDistribution?: TimeDistribution;
  typePerformance?: TypePerformance[];
}

export interface StudentWithPointDto {
  averagePoint?: number;
  id?: number;
  name?: string;
  point?: number;
  surname?: string;
}

export interface StudentWithDurationDto {
  avgDuration?: number;
  duration?: number;
  id?: number;
  name?: string;
  surname?: string;
}

export interface QuestionWithTrueFalseCountsDto {
  avgPercent?: number;
  body?: string;
  emptyCount?: number;
  falseCount?: number;
  id?: number;
  point?: number;
  trueCount?: number;
}

export interface ClassroomWithAveragePointDto {
  averagePoint?: number;
  grade?: number;
  id?: number;
  section?: string;
}

export interface AssignmentStatisticsResponseDto {
  classrooms?: ClassroomWithAveragePointDto[];
  durations?: StudentWithDurationDto[];
  points?: StudentWithPointDto[];
  questions?: QuestionWithTrueFalseCountsDto[];
  sortedTopics?: string[];
}

export interface StudentDistribution {
  color?: string;
  level?: string;
  percentage?: number;
  threshold?: number;
  value?: number;
}

export interface QuickStats {
  averageScore?: number;
  completionRate?: number;
  totalAssignments?: number;
  totalStudents?: number;
}

export interface PerformanceTrend {
  averageScore?: number;
  completionRate?: number;
  month?: string;
  participationRate?: number;
}

export interface LastAssignment {
  score?: number;
  subjectKey?: string;
  submissionDate?: string;
}

export interface ClassAnalytics {
  lastAssignments?: LastAssignment[];
  performanceTrends?: PerformanceTrend[];
  quickStats?: QuickStats;
  studentDistribution?: StudentDistribution[];
}

export interface ClassroomAnalyticsResponseDto {
  classAnalytics?: ClassAnalytics;
}

export interface AssignmentWithStandardDeviationDto {
  endDate?: string;
  id?: number;
  name?: string;
  standardDeviation?: number;
  startDate?: string;
}

export interface AssignmentWithAveragePointDto {
  averagePoint?: number;
  endDate?: string;
  id?: number;
  name?: string;
  startDate?: string;
}

export interface ClassroomAssignmentStatisticsResponseDto {
  averagePoints?: AssignmentWithAveragePointDto[];
  examDurations?: AssignmentWithDurationDto[];
  examStandardDeviations?: AssignmentWithStandardDeviationDto[];
}

export type MessageCountByCourseTypeCourseType =
  (typeof MessageCountByCourseTypeCourseType)[keyof typeof MessageCountByCourseTypeCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageCountByCourseTypeCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface MessageCountByCourseType {
  courseType?: MessageCountByCourseTypeCourseType;
  messageCount?: number;
}

export interface ClassroomDashboardStudentAvgAssignmentCompletionDto {
  completionTime?: number;
  score?: number;
  studentId?: number;
  studentName?: string;
}

export interface ClassroomDashboardStudentAssignmentCompletionDto {
  assignmentId?: number;
  completionTime?: number;
  score?: number;
  studentId?: number;
  studentName?: string;
}

export type ClassroomDashboardResponseDtoTopicCountOfEachStudent = {
  [key: string]: ClassroomDashboardDiscussedTopicsDto[];
};

export type ClassroomDashboardResponseDtoStudentAvgAssignmentCompletion = {
  [key: string]: ClassroomDashboardStudentAvgAssignmentCompletionDto;
};

export type ClassroomDashboardResponseDtoStudentAssignmentCompletion = {
  [key: string]: ClassroomDashboardStudentAssignmentCompletionDto[];
};

export type ClassroomDashboardResponseDtoChatTotalCount = {
  [key: string]: ClassroomDashboardChatTotalCountDto;
};

export type ClassroomDashboardResponseDtoAssignmentNames = {
  [key: string]: string;
};

export type ClassroomDashboardResponseDtoAssignmentCompletionByStudent = {
  [key: string]: ClassroomDashboardAssignmentCompletionByStudentDto[];
};

export type ClassroomDashboardResponseDtoAssignmentAvgCompletion = {
  [key: string]: ClassroomDashboardAssignmentAvgCompletionDto;
};

export interface ClassroomDashboardDiscussedTopicsDto {
  count?: number;
  topic?: string;
}

export interface ClassroomDashboardChatTotalCountDto {
  chatCount?: number;
  messageCount?: number;
  messageCountByCourseType?: MessageCountByCourseType;
  studentName?: string;
}

export interface ClassroomDashboardChatAvgCountDto {
  chatCount?: number;
  messageCount?: number;
}

export interface ClassroomDashboardResponseDto {
  assignmentAvgCompletion?: ClassroomDashboardResponseDtoAssignmentAvgCompletion;
  assignmentCompletionByStudent?: ClassroomDashboardResponseDtoAssignmentCompletionByStudent;
  assignmentNames?: ClassroomDashboardResponseDtoAssignmentNames;
  chatAvgCount?: ClassroomDashboardChatAvgCountDto;
  chatTotalCount?: ClassroomDashboardResponseDtoChatTotalCount;
  discussedTopics?: ClassroomDashboardDiscussedTopicsDto[];
  randomMessages?: string[];
  studentAssignmentCompletion?: ClassroomDashboardResponseDtoStudentAssignmentCompletion;
  studentAvgAssignmentCompletion?: ClassroomDashboardResponseDtoStudentAvgAssignmentCompletion;
  topicCountOfEachStudent?: ClassroomDashboardResponseDtoTopicCountOfEachStudent;
}

export interface ClassroomDashboardAssignmentCompletionByStudentDto {
  assignmentName?: string;
  completionTime?: number;
  score?: number;
  studentId?: number;
  studentName?: string;
}

export interface ClassroomDashboardAssignmentAvgCompletionDto {
  assignmentName?: string;
  avgCompletionTime?: number;
  avgScore?: number;
}

export interface StudentWithStandardDeviationDto {
  id?: number;
  name?: string;
  standardDeviation?: number;
  surname?: string;
}

export interface StudentWithAverageAndLastPointDto {
  averagePoint?: number;
  id?: number;
  lastPoint?: number;
  name?: string;
  surname?: string;
}

export interface ClassroomStudentStatisticsResponseDto {
  studentAverages?: StudentWithAverageAndLastPointDto[];
  studentStandardDeviations?: StudentWithStandardDeviationDto[];
}

export interface WeeklyAnalysisResponseDto {
  areasForImprovement?: string;
  createdAt?: string;
  creativeInsights?: string;
  cumulativeProgress?: string;
  frequentlyMisunderstoodConcepts?: FrequentlyMisunderstoodConcepts[];
  mostEngagedTopics?: string[];
  notableImprovements?: string;
  persistentStruggles?: string;
  studentId?: number;
  studentName?: string;
  studentSurname?: string;
  topicsRequiringFurtherReview?: string[];
  weeklyFeedbackFromEngagedTopics?: string;
}

export type QuestionTypeSuccessCountsQuestionType =
  (typeof QuestionTypeSuccessCountsQuestionType)[keyof typeof QuestionTypeSuccessCountsQuestionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionTypeSuccessCountsQuestionType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export interface QuestionTypeSuccessCounts {
  fullMark?: number;
  questionType?: QuestionTypeSuccessCountsQuestionType;
  successCount?: number;
}

export interface AssignmentWithScoresDto {
  avgScore?: number;
  endDate?: string;
  id?: number;
  name?: string;
  score?: number;
  startDate?: string;
}

export interface AssignmentWithDurationDto {
  assignmentDuration?: number;
  duration?: number;
  endDate?: string;
  id?: number;
  name?: string;
  startDate?: string;
}

export interface StudentAssignmentStatisticsResponseDto {
  assignmentDurations?: AssignmentWithDurationDto[];
  assignments?: AssignmentWithScoresDto[];
  generalAveragePoint?: number;
  questionTypeSuccessCounts?: QuestionTypeSuccessCounts[];
}

export type TrueFalseAnswerWithQuestionDtoAllOf = {
  studentAnswer?: boolean;
};

export type TrueFalseAnswerWithQuestionDto = AnswerWithQuestionDto &
  TrueFalseAnswerWithQuestionDtoAllOf;

export type TestAnswerWithQuestionDtoAllOf = {
  studentAnswer?: string;
};

export type TestAnswerWithQuestionDto = AnswerWithQuestionDto &
  TestAnswerWithQuestionDtoAllOf;

export type StudentAssignmentDetailTeacherPerspectiveResponseDtoStudentAssignmentStatus =
  (typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoStudentAssignmentStatus)[keyof typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoStudentAssignmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailTeacherPerspectiveResponseDtoStudentAssignmentStatus =
  {
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    FINISHED: "FINISHED",
    DID_NOT_START: "DID_NOT_START",
  } as const;

export type StudentAssignmentDetailTeacherPerspectiveResponseDtoGradingStatus =
  (typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoGradingStatus)[keyof typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoGradingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailTeacherPerspectiveResponseDtoGradingStatus =
  {
    AI_GRADING_IN_PROGRESS: "AI_GRADING_IN_PROGRESS",
    AI_GRADING_COMPLETE: "AI_GRADING_COMPLETE",
    TEACHER_GRADED: "TEACHER_GRADED",
  } as const;

export type StudentAssignmentDetailTeacherPerspectiveResponseDtoCourseType =
  (typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoCourseType)[keyof typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailTeacherPerspectiveResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentType =
  (typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentType)[keyof typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentType =
  {
    CHAT: "CHAT",
    QUIZ: "QUIZ",
    HOMEWORK: "HOMEWORK",
  } as const;

export type StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentStatus =
  (typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentStatus)[keyof typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentStatus =
  {
    DRAFT: "DRAFT",
    PENDING: "PENDING",
    ASSIGNED: "ASSIGNED",
    FAILED: "FAILED",
    IN_PROGRESS: "IN_PROGRESS",
    FINISHED: "FINISHED",
  } as const;

export type StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentDifficulty =
  (typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentDifficulty)[keyof typeof StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentDifficulty =
  {
    EASY: "EASY",
    MEDIUM: "MEDIUM",
    HARD: "HARD",
  } as const;

export interface StudentAssignmentDetailTeacherPerspectiveResponseDto {
  assignedStudentsWithClassrooms?: AssignAssignmentRequestBodyNewItem[];
  assignmentCanStudentsGoBackBetweenQuestions?: boolean;
  assignmentCreatedAt: string;
  assignmentCreatedBy: number;
  assignmentDescription?: string;
  assignmentDifficulty?: StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentDifficulty;
  assignmentDuration?: number;
  assignmentEndDate: string;
  assignmentGrade?: number;
  assignmentId: number;
  assignmentImageUrl?: string;
  assignmentIsAssignmentStopped?: boolean;
  assignmentLastStopTime?: string;
  assignmentName?: string;
  assignmentShouldStudentsSeeAnswersAutomaticallyAfterFinish?: boolean;
  assignmentShouldStudentsSeeAnswersBeforeEndDateAfterFinish?: boolean;
  assignmentStartDate: string;
  assignmentStatus: StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentStatus;
  assignmentType: StudentAssignmentDetailTeacherPerspectiveResponseDtoAssignmentType;
  chatIds?: number[];
  courseType: StudentAssignmentDetailTeacherPerspectiveResponseDtoCourseType;
  gradingStatus?: StudentAssignmentDetailTeacherPerspectiveResponseDtoGradingStatus;
  questionsWithStudentAnswers?: StudentAssignmentDetailTeacherPerspectiveResponseDtoQuestionsWithStudentAnswersItem[];
  studentAssignmentStatus: StudentAssignmentDetailTeacherPerspectiveResponseDtoStudentAssignmentStatus;
  studentEndDate: string;
  studentProgressInTheAssignment: number;
  studentStartDate: string;
  studentTotalPoints: number;
  totalPointsOfAssignment: number;
  totalQuestionCount: number;
}

export type OpenEndedAnswerWithQuestionDtoAllOf = {
  studentAnswer?: string;
};

export type MatchAnswerWithQuestionDtoAllOfStudentAnswer = {
  [key: string]: string;
};

export type MatchAnswerWithQuestionDtoAllOf = {
  studentAnswer?: MatchAnswerWithQuestionDtoAllOfStudentAnswer;
};

export type MatchAnswerWithQuestionDto = AnswerWithQuestionDto &
  MatchAnswerWithQuestionDtoAllOf;

export type FillTheBlankAnswerWithQuestionDtoAllOf = {
  studentAnswer?: string[];
};

export type AnswerWithQuestionDtoType =
  (typeof AnswerWithQuestionDtoType)[keyof typeof AnswerWithQuestionDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnswerWithQuestionDtoType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export type AnswerWithQuestionDtoQuestion =
  | BaseQuestionDto
  | BaseFillTheBlankQuestionDto
  | BaseMatchQuestionDto
  | BaseOpenEndedQuestionDto
  | BaseTestQuestionDto
  | BaseTrueFalseQuestionDto;

export interface AnswerWithQuestionDto {
  didTeacherGrade?: boolean;
  explanation?: string;
  feedback?: string;
  question: AnswerWithQuestionDtoQuestion;
  questionId: number;
  score?: number;
  studentId: number;
  type: AnswerWithQuestionDtoType;
}

export type OpenEndedAnswerWithQuestionDto = AnswerWithQuestionDto &
  OpenEndedAnswerWithQuestionDtoAllOf;

export type FillTheBlankAnswerWithQuestionDto = AnswerWithQuestionDto &
  FillTheBlankAnswerWithQuestionDtoAllOf;

export type AnswerWithQuestionWithoutCorrectAnswerDto = AnswerWithQuestionDto;

export type StudentAssignmentDetailTeacherPerspectiveResponseDtoQuestionsWithStudentAnswersItem =

    | AnswerWithQuestionDto
    | AnswerWithQuestionWithoutCorrectAnswerDto
    | FillTheBlankAnswerWithQuestionDto
    | MatchAnswerWithQuestionDto
    | OpenEndedAnswerWithQuestionDto
    | TestAnswerWithQuestionDto
    | TrueFalseAnswerWithQuestionDto;

export type StudentAssignmentResponseDtoStudentAssignmentStatus =
  (typeof StudentAssignmentResponseDtoStudentAssignmentStatus)[keyof typeof StudentAssignmentResponseDtoStudentAssignmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentResponseDtoStudentAssignmentStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
  DID_NOT_START: "DID_NOT_START",
} as const;

export type StudentAssignmentResponseDtoGradingStatus =
  (typeof StudentAssignmentResponseDtoGradingStatus)[keyof typeof StudentAssignmentResponseDtoGradingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentResponseDtoGradingStatus = {
  AI_GRADING_IN_PROGRESS: "AI_GRADING_IN_PROGRESS",
  AI_GRADING_COMPLETE: "AI_GRADING_COMPLETE",
  TEACHER_GRADED: "TEACHER_GRADED",
} as const;

export type StudentAssignmentResponseDtoCourseType =
  (typeof StudentAssignmentResponseDtoCourseType)[keyof typeof StudentAssignmentResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type StudentAssignmentResponseDtoAssignmentType =
  (typeof StudentAssignmentResponseDtoAssignmentType)[keyof typeof StudentAssignmentResponseDtoAssignmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentResponseDtoAssignmentType = {
  CHAT: "CHAT",
  QUIZ: "QUIZ",
  HOMEWORK: "HOMEWORK",
} as const;

export type StudentAssignmentResponseDtoAssignmentStatus =
  (typeof StudentAssignmentResponseDtoAssignmentStatus)[keyof typeof StudentAssignmentResponseDtoAssignmentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentResponseDtoAssignmentStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  ASSIGNED: "ASSIGNED",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
} as const;

export type StudentAssignmentResponseDtoAssignmentDifficulty =
  (typeof StudentAssignmentResponseDtoAssignmentDifficulty)[keyof typeof StudentAssignmentResponseDtoAssignmentDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentAssignmentResponseDtoAssignmentDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface StudentAssignmentResponseDto {
  assignedStudentsWithClassrooms?: AssignAssignmentRequestBodyNewItem[];
  assignmentCanStudentsGoBackBetweenQuestions?: boolean;
  assignmentCreatedAt: string;
  assignmentCreatedBy: number;
  assignmentDescription?: string;
  assignmentDifficulty?: StudentAssignmentResponseDtoAssignmentDifficulty;
  assignmentDuration?: number;
  assignmentEndDate: string;
  assignmentGrade?: number;
  assignmentId: number;
  assignmentImageUrl?: string;
  assignmentIsAssignmentStopped?: boolean;
  assignmentLastStopTime?: string;
  assignmentName?: string;
  assignmentShouldStudentsSeeAnswersAutomaticallyAfterFinish?: boolean;
  assignmentShouldStudentsSeeAnswersBeforeEndDateAfterFinish?: boolean;
  assignmentStartDate: string;
  assignmentStatus: StudentAssignmentResponseDtoAssignmentStatus;
  assignmentType: StudentAssignmentResponseDtoAssignmentType;
  chatIds?: number[];
  courseType: StudentAssignmentResponseDtoCourseType;
  gradingStatus?: StudentAssignmentResponseDtoGradingStatus;
  studentAssignmentStatus: StudentAssignmentResponseDtoStudentAssignmentStatus;
  studentEndDate: string;
  studentProgressInTheAssignment: number;
  studentStartDate: string;
  studentTotalPoints: number;
  totalPointsOfAssignment: number;
  totalQuestionCount: number;
}

export interface ListStudentAssignmentsResponseDto {
  data?: StudentAssignmentResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListTextLevelerResponseDto {
  data?: TextLevelerResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export type TopicListResponseDtoCourseType =
  (typeof TopicListResponseDtoCourseType)[keyof typeof TopicListResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TopicListResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface TopicListResponseDto {
  courseType?: TopicListResponseDtoCourseType;
  grade?: number;
  topics?: TopicResponseDto[];
}

export interface ListTransferActivityResponseDto {
  data?: TransferActivityResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface BaseTranslationDto {
  en?: string;
  key?: string;
  tr?: string;
}

export interface ListUbdExpertPlannerResponseDto {
  data?: UbdExpertPlannerResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListUdlChoiceBoardResponseDto {
  data?: UdlChoiceBoardResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface MinutesSavedResponseDto {
  minutesSaved?: number;
}

export interface ListVideoAvatarResponseDto {
  data?: VideoAvatarResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface ListVocabularyListResponseDto {
  data?: VocabularyListResponseDto[];
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface UpdateColumnOrderResponseDto {
  columns?: ColumnResponseDto[];
}

export interface UpdateColumnOrderRequestDto {
  columnIds: number[];
}

export interface UpdateColumnRequestDto {
  /**
   * @minLength 0
   * @maxLength 100
   */
  title: string;
}

export interface MovePostRequestDto {
  positionX?: number;
  positionY?: number;
  targetColumnId?: number;
  targetOrderIndex?: number;
}

export interface UpdatePostContentRequestDto {
  /**
   * @minLength 0
   * @maxLength 5000
   */
  content?: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  fileName?: string;
  fileUrl?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  title?: string;
}

export type UpdateBoardRequestDtoBackgroundType =
  (typeof UpdateBoardRequestDtoBackgroundType)[keyof typeof UpdateBoardRequestDtoBackgroundType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBoardRequestDtoBackgroundType = {
  UPLOAD: "UPLOAD",
  SYSTEM: "SYSTEM",
} as const;

export interface UpdateBoardRequestDto {
  backgroundType?: UpdateBoardRequestDtoBackgroundType;
  /**
   * @minLength 0
   * @maxLength 500
   */
  backgroundValue?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  sharingPermission?: boolean;
  /**
   * @minLength 0
   * @maxLength 100
   */
  title?: string;
}

export type AiAssessmentScaleCreateRequestDtoGenerationType =
  (typeof AiAssessmentScaleCreateRequestDtoGenerationType)[keyof typeof AiAssessmentScaleCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssessmentScaleCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type AiAssessmentScaleCreateRequestDtoCourseName =
  (typeof AiAssessmentScaleCreateRequestDtoCourseName)[keyof typeof AiAssessmentScaleCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssessmentScaleCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type AiAssessmentScaleCreateRequestDtoContentLanguage =
  (typeof AiAssessmentScaleCreateRequestDtoContentLanguage)[keyof typeof AiAssessmentScaleCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssessmentScaleCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface AiAssessmentScaleCreateRequestDto {
  contentLanguage?: AiAssessmentScaleCreateRequestDtoContentLanguage;
  context?: string;
  courseName: AiAssessmentScaleCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: AiAssessmentScaleCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  targetLevel?: number;
  teacherDocumentIds?: number[];
}

export type AiAssignmentCreateRequestDtoGenerationType =
  (typeof AiAssignmentCreateRequestDtoGenerationType)[keyof typeof AiAssignmentCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssignmentCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type AiAssignmentCreateRequestDtoCourseName =
  (typeof AiAssignmentCreateRequestDtoCourseName)[keyof typeof AiAssignmentCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssignmentCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type AiAssignmentCreateRequestDtoContentLanguage =
  (typeof AiAssignmentCreateRequestDtoContentLanguage)[keyof typeof AiAssignmentCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssignmentCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type AiAssignmentCreateRequestDtoAssignmentCategory =
  (typeof AiAssignmentCreateRequestDtoAssignmentCategory)[keyof typeof AiAssignmentCreateRequestDtoAssignmentCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssignmentCreateRequestDtoAssignmentCategory = {
  GREEN_LIGHT: "GREEN_LIGHT",
  RED_LIGHT_GREEN_LIGHT: "RED_LIGHT_GREEN_LIGHT",
  HUMAN_CRITIQUE_AI: "HUMAN_CRITIQUE_AI",
  AI_CRITIQUE_HUMAN: "AI_CRITIQUE_HUMAN",
  CO_CREATION: "CO_CREATION",
} as const;

export interface AiAssignmentCreateRequestDto {
  assignmentCategory?: AiAssignmentCreateRequestDtoAssignmentCategory;
  contentLanguage?: AiAssignmentCreateRequestDtoContentLanguage;
  courseName: AiAssignmentCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: AiAssignmentCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type AiResistantHomeworkCreateRequestDtoGenerationType =
  (typeof AiResistantHomeworkCreateRequestDtoGenerationType)[keyof typeof AiResistantHomeworkCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiResistantHomeworkCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type AiResistantHomeworkCreateRequestDtoCourseName =
  (typeof AiResistantHomeworkCreateRequestDtoCourseName)[keyof typeof AiResistantHomeworkCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiResistantHomeworkCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type AiResistantHomeworkCreateRequestDtoContentLanguage =
  (typeof AiResistantHomeworkCreateRequestDtoContentLanguage)[keyof typeof AiResistantHomeworkCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiResistantHomeworkCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface AiResistantHomeworkCreateRequestDto {
  contentLanguage?: AiResistantHomeworkCreateRequestDtoContentLanguage;
  courseName: AiResistantHomeworkCreateRequestDtoCourseName;
  customDuration?: string;
  difficultyLevel?: string;
  environment?: string;
  estimatedDuration?: number;
  evaluationGuidelines?: EvaluationGuidelines;
  fromSuperTool?: boolean;
  generationType?: AiResistantHomeworkCreateRequestDtoGenerationType;
  gradeLevel: number;
  homeworkPurpose?: string;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  resourcePreferences?: string[];
  teacherDocumentIds?: number[];
  workType?: string;
}

export type AiSupportedTasksCreateRequestDtoGenerationType =
  (typeof AiSupportedTasksCreateRequestDtoGenerationType)[keyof typeof AiSupportedTasksCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiSupportedTasksCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type AiSupportedTasksCreateRequestDtoCourseName =
  (typeof AiSupportedTasksCreateRequestDtoCourseName)[keyof typeof AiSupportedTasksCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiSupportedTasksCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type AiSupportedTasksCreateRequestDtoContentLanguage =
  (typeof AiSupportedTasksCreateRequestDtoContentLanguage)[keyof typeof AiSupportedTasksCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiSupportedTasksCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface AiSupportedTasksCreateRequestDto {
  contentLanguage?: AiSupportedTasksCreateRequestDtoContentLanguage;
  context?: string;
  courseName: AiSupportedTasksCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: AiSupportedTasksCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export interface SearchResult {
  iconId?: string;
  score?: number;
}

export type SearchRequestIconPack =
  (typeof SearchRequestIconPack)[keyof typeof SearchRequestIconPack];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchRequestIconPack = {
  STREAMLINE: "STREAMLINE",
  STREAMLINE_FREE: "STREAMLINE_FREE",
  LUCIDE: "LUCIDE",
} as const;

export interface SearchRequest {
  description?: string;
  iconPack?: SearchRequestIconPack;
}

export interface MergeAnonymousUserToStudentBodyDto {
  studentToken?: string;
}

export interface TemplateGenerateResponseDto {
  template_contents?: JsonNode;
}

export interface ArticleGeneratorCreateTemplateRequestDto {
  selectedText?: string;
}

export type ArticleGeneratorCreateRequestDtoGenerationType =
  (typeof ArticleGeneratorCreateRequestDtoGenerationType)[keyof typeof ArticleGeneratorCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleGeneratorCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type ArticleGeneratorCreateRequestDtoGenerationMode =
  (typeof ArticleGeneratorCreateRequestDtoGenerationMode)[keyof typeof ArticleGeneratorCreateRequestDtoGenerationMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleGeneratorCreateRequestDtoGenerationMode = {
  PROMPT: "PROMPT",
  REFORMAT: "REFORMAT",
} as const;

export type ArticleGeneratorCreateRequestDtoCourseName =
  (typeof ArticleGeneratorCreateRequestDtoCourseName)[keyof typeof ArticleGeneratorCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleGeneratorCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ArticleGeneratorCreateRequestDtoContentLanguage =
  (typeof ArticleGeneratorCreateRequestDtoContentLanguage)[keyof typeof ArticleGeneratorCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleGeneratorCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface ArticleGeneratorCreateRequestDto {
  contentLanguage?: ArticleGeneratorCreateRequestDtoContentLanguage;
  courseName?: ArticleGeneratorCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationMode: ArticleGeneratorCreateRequestDtoGenerationMode;
  generationType?: ArticleGeneratorCreateRequestDtoGenerationType;
  gradeLevel?: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  rawArticle?: string;
  teacherDocumentIds?: number[];
}

export interface CreateAuditResponseDto {
  actionName?: string;
  extraDetails?: JsonNode;
  handledAt?: string;
  id?: number;
  userId: number;
}

export interface CreateAuditRequestBodyDto {
  actionName: string;
  extraDetails?: JsonNode;
}

export interface BlogQuizFinishRequestDto {
  answers?: JsonNode;
  completionTime?: number;
  score?: number;
}

export interface CreateBlogRequestBodyDto {
  author: string;
  contentEn: string;
  contentTr: string;
  coverPhotoUrl?: string;
  tags?: string[];
  titleEn: string;
  titleTr: string;
  voiceEnUrl?: string;
  voiceTrUrl?: string;
}

export type BloomsTaxonomyActivitiesCreateRequestDtoGenerationType =
  (typeof BloomsTaxonomyActivitiesCreateRequestDtoGenerationType)[keyof typeof BloomsTaxonomyActivitiesCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BloomsTaxonomyActivitiesCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type BloomsTaxonomyActivitiesCreateRequestDtoCourseName =
  (typeof BloomsTaxonomyActivitiesCreateRequestDtoCourseName)[keyof typeof BloomsTaxonomyActivitiesCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BloomsTaxonomyActivitiesCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type BloomsTaxonomyActivitiesCreateRequestDtoContentLanguage =
  (typeof BloomsTaxonomyActivitiesCreateRequestDtoContentLanguage)[keyof typeof BloomsTaxonomyActivitiesCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BloomsTaxonomyActivitiesCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface BloomsTaxonomyActivitiesCreateRequestDto {
  contentLanguage?: BloomsTaxonomyActivitiesCreateRequestDtoContentLanguage;
  courseName: BloomsTaxonomyActivitiesCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: BloomsTaxonomyActivitiesCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type CreateChatMessageSuggestionResponseDtoCourseType =
  (typeof CreateChatMessageSuggestionResponseDtoCourseType)[keyof typeof CreateChatMessageSuggestionResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatMessageSuggestionResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateChatMessageSuggestionResponseDto {
  courseType?: CreateChatMessageSuggestionResponseDtoCourseType;
  grade?: number;
  id?: number;
  message?: string;
  title?: string;
  topic?: string;
}

export type CreateChatMessageSuggestionRequestBodyDtoCourse =
  (typeof CreateChatMessageSuggestionRequestBodyDtoCourse)[keyof typeof CreateChatMessageSuggestionRequestBodyDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatMessageSuggestionRequestBodyDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateChatMessageSuggestionRequestBodyDto {
  course?: CreateChatMessageSuggestionRequestBodyDtoCourse;
  grade: number;
  message: string;
  title: string;
  topic: string;
}

export interface CreateDidacticChatStudentRequestBodyDto {
  environment?: string;
  parentFileNodeId?: number;
  topicId?: number;
}

export type CreateExplanationStudentChatRequestBodyDtoCourse =
  (typeof CreateExplanationStudentChatRequestBodyDtoCourse)[keyof typeof CreateExplanationStudentChatRequestBodyDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExplanationStudentChatRequestBodyDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateExplanationStudentChatRequestBodyDto {
  course: CreateExplanationStudentChatRequestBodyDtoCourse;
  environment?: string;
  explanation: string;
  parentFileNodeId?: number;
  questionId?: number;
  welcomeMessage?: string;
}

export type CreateChatResponseDtoTopics = { [key: string]: number };

export type CreateChatResponseDtoCourse =
  (typeof CreateChatResponseDtoCourse)[keyof typeof CreateChatResponseDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatResponseDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type CreateChatResponseDtoChatType =
  (typeof CreateChatResponseDtoChatType)[keyof typeof CreateChatResponseDtoChatType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatResponseDtoChatType = {
  DIDACTIC: "DIDACTIC",
  CHAT: "CHAT",
} as const;

export interface CreateChatResponseDto {
  chatType?: CreateChatResponseDtoChatType;
  config?: JsonNode;
  course?: CreateChatResponseDtoCourse;
  createdAt?: string;
  description?: string;
  grade?: number;
  id?: number;
  images?: ImagesPart[];
  isFavourite?: boolean;
  isTitleGenerated?: boolean;
  messages?: BaseChatMessageDto[];
  questionSolverId?: number;
  title?: string;
  topics?: CreateChatResponseDtoTopics;
  userId?: number;
}

export type CreateChatStudentRequestBodyDtoCourse =
  (typeof CreateChatStudentRequestBodyDtoCourse)[keyof typeof CreateChatStudentRequestBodyDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatStudentRequestBodyDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateChatStudentRequestBodyDto {
  course: CreateChatStudentRequestBodyDtoCourse;
  environment?: string;
  questionId?: number;
  welcomeMessage?: string;
}

export type CreateChatMessageResponseDtoMessageContentType =
  (typeof CreateChatMessageResponseDtoMessageContentType)[keyof typeof CreateChatMessageResponseDtoMessageContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatMessageResponseDtoMessageContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export type CreateChatMessageResponseDtoCourseType =
  (typeof CreateChatMessageResponseDtoCourseType)[keyof typeof CreateChatMessageResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatMessageResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateChatMessageResponseDto {
  chatId?: number;
  chatTitle?: string;
  courseType?: CreateChatMessageResponseDtoCourseType;
  createdAt?: string;
  followups?: string[];
  id?: number;
  isFavorite?: boolean;
  isLiked?: boolean;
  mathResponses?: JsonNode;
  mediaBucketUrl?: string;
  mediaPublicUrl?: string;
  message?: string;
  messageContentType?: CreateChatMessageResponseDtoMessageContentType;
  processedMessage?: string;
  sender?: string;
}

export type ChoiceBoardCreateRequestDtoGenerationType =
  (typeof ChoiceBoardCreateRequestDtoGenerationType)[keyof typeof ChoiceBoardCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChoiceBoardCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type ChoiceBoardCreateRequestDtoCourseName =
  (typeof ChoiceBoardCreateRequestDtoCourseName)[keyof typeof ChoiceBoardCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChoiceBoardCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ChoiceBoardCreateRequestDtoContentLanguage =
  (typeof ChoiceBoardCreateRequestDtoContentLanguage)[keyof typeof ChoiceBoardCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChoiceBoardCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface ChoiceBoardCreateRequestDto {
  contentLanguage?: ChoiceBoardCreateRequestDtoContentLanguage;
  courseName: ChoiceBoardCreateRequestDtoCourseName;
  difficultyDistribution?: string;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: ChoiceBoardCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  learningOutcomesFocus?: string[];
  mindmapId?: number;
  preferredLearningStyles?: string[];
  prompt?: string;
  selectionRequirements?: string;
  teacherDocumentIds?: number[];
}

export type CircleWebhookRequestObjectData = { [key: string]: unknown };

export interface CircleWebhookRequestObject {
  data?: CircleWebhookRequestObjectData;
  type?: string;
}

export type ClassroomManagementCreateRequestDtoGenerationType =
  (typeof ClassroomManagementCreateRequestDtoGenerationType)[keyof typeof ClassroomManagementCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassroomManagementCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type ClassroomManagementCreateRequestDtoCourseName =
  (typeof ClassroomManagementCreateRequestDtoCourseName)[keyof typeof ClassroomManagementCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassroomManagementCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ClassroomManagementCreateRequestDtoContentLanguage =
  (typeof ClassroomManagementCreateRequestDtoContentLanguage)[keyof typeof ClassroomManagementCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassroomManagementCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface ClassroomManagementCreateRequestDto {
  classroomManagementGoal?: string;
  classSize?: string;
  contentLanguage?: ClassroomManagementCreateRequestDtoContentLanguage;
  courseName: ClassroomManagementCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: ClassroomManagementCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  problemCategory?: string;
  problemDescription?: string;
  problemSubcategory?: string;
  prompt?: string;
  teacherDocumentIds?: number[];
  teachingToolsUsed?: string;
}

export type CollaborativeGroupWorkCreateRequestDtoGenerationType =
  (typeof CollaborativeGroupWorkCreateRequestDtoGenerationType)[keyof typeof CollaborativeGroupWorkCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaborativeGroupWorkCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type CollaborativeGroupWorkCreateRequestDtoCourseName =
  (typeof CollaborativeGroupWorkCreateRequestDtoCourseName)[keyof typeof CollaborativeGroupWorkCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaborativeGroupWorkCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type CollaborativeGroupWorkCreateRequestDtoContentLanguage =
  (typeof CollaborativeGroupWorkCreateRequestDtoContentLanguage)[keyof typeof CollaborativeGroupWorkCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaborativeGroupWorkCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface CollaborativeGroupWorkCreateRequestDto {
  availableMaterials?: string[];
  classroomEnvironment?: string;
  contentLanguage?: CollaborativeGroupWorkCreateRequestDtoContentLanguage;
  courseName: CollaborativeGroupWorkCreateRequestDtoCourseName;
  environment?: string;
  evaluationTypes?: string[];
  fromSuperTool?: boolean;
  generationType?: CollaborativeGroupWorkCreateRequestDtoGenerationType;
  gradeLevel: number;
  interactionStyle?: string;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  physicalLayout?: string;
  previousCollaborationExperience?: string;
  prompt?: string;
  sessionDuration?: string;
  studentSocialSkills?: string;
  /**
   * @minimum 2
   * @maximum 6
   */
  studentsPerGroup: number;
  targetSkills?: string[];
  teacherDocumentIds?: number[];
  teacherRole?: string;
}

export type CommonMisconceptionCreateRequestDtoGenerationType =
  (typeof CommonMisconceptionCreateRequestDtoGenerationType)[keyof typeof CommonMisconceptionCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommonMisconceptionCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type CommonMisconceptionCreateRequestDtoCourseName =
  (typeof CommonMisconceptionCreateRequestDtoCourseName)[keyof typeof CommonMisconceptionCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommonMisconceptionCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type CommonMisconceptionCreateRequestDtoContentLanguage =
  (typeof CommonMisconceptionCreateRequestDtoContentLanguage)[keyof typeof CommonMisconceptionCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommonMisconceptionCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface CommonMisconceptionCreateRequestDto {
  contentLanguage?: CommonMisconceptionCreateRequestDtoContentLanguage;
  courseName: CommonMisconceptionCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: CommonMisconceptionCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type ConceptualUnderstandingCreateRequestDtoGenerationType =
  (typeof ConceptualUnderstandingCreateRequestDtoGenerationType)[keyof typeof ConceptualUnderstandingCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConceptualUnderstandingCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type ConceptualUnderstandingCreateRequestDtoCourseName =
  (typeof ConceptualUnderstandingCreateRequestDtoCourseName)[keyof typeof ConceptualUnderstandingCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConceptualUnderstandingCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ConceptualUnderstandingCreateRequestDtoContentLanguage =
  (typeof ConceptualUnderstandingCreateRequestDtoContentLanguage)[keyof typeof ConceptualUnderstandingCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConceptualUnderstandingCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface ConceptualUnderstandingCreateRequestDto {
  contentLanguage?: ConceptualUnderstandingCreateRequestDtoContentLanguage;
  courseName: ConceptualUnderstandingCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: ConceptualUnderstandingCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export interface DailyAssignmentFinishRequestDto {
  answers?: JsonNode;
  completionTime?: number;
  score?: number;
}

export interface TriggerChatAnalysisRequestDto {
  chatId?: number;
}

export interface TriggerTeacherChatAnalysisRequestDto {
  chatId?: number;
  teacherChatId?: number;
}

export type TriggerWeeklyAnalysisRequestDtoCourseType =
  (typeof TriggerWeeklyAnalysisRequestDtoCourseType)[keyof typeof TriggerWeeklyAnalysisRequestDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TriggerWeeklyAnalysisRequestDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface TriggerWeeklyAnalysisRequestDto {
  courseType?: TriggerWeeklyAnalysisRequestDtoCourseType;
  studentId?: number;
}

export interface RequestDemoEmailItem {
  body: string;
  email: string;
  language: string;
  name: string;
  phone_number?: string;
  subject: string;
}

export type EdlinkClassroomCloneRequestDtoCourseType =
  (typeof EdlinkClassroomCloneRequestDtoCourseType)[keyof typeof EdlinkClassroomCloneRequestDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkClassroomCloneRequestDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface EdlinkClassroomCloneRequestDto {
  courseType: EdlinkClassroomCloneRequestDtoCourseType;
  edlinkClassroomId?: string;
  grade: number;
  section?: string;
  visibleCourseType?: string;
}

export type EdlinkBulkUserImportRequestDtoRole =
  (typeof EdlinkBulkUserImportRequestDtoRole)[keyof typeof EdlinkBulkUserImportRequestDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EdlinkBulkUserImportRequestDtoRole = {
  ANONYMOUS: "ANONYMOUS",
  STUDENT: "STUDENT",
  ADMIN: "ADMIN",
  TEACHER: "TEACHER",
  PARENT: "PARENT",
  MADLEN_ADMIN: "MADLEN_ADMIN",
} as const;

export interface EdlinkBulkUserImportRequestDto {
  edlinkUserId?: string;
  email?: string;
  grade?: number;
  name?: string;
  role?: EdlinkBulkUserImportRequestDtoRole;
  surname?: string;
}

export interface EdlinkAssignmentPublishRequestDto {
  assignmentId: number;
  classroomIds: number[];
}

export interface BaseSuccessResponseDto {
  message?: string;
}

export interface SubscribeEmailItem {
  email: string;
}

export interface AssignStudentsRequestDto {
  endDate?: string;
  /**
   * @minItems 1
   * @maxItems 2147483647
   */
  items: AssignAssignmentRequestBodyNewItem[];
  startDate?: string;
}

export interface ReleaseGradesRequestDto {
  studentIds: number[];
}

export interface CreateEssayAssignmentRequestDto {
  /**
   * @minLength 0
   * @maxLength 5000
   */
  description?: string;
  dueDate?: string;
  rubricFileId: number;
  studentInstructionFileId?: number;
  /**
   * @minLength 0
   * @maxLength 10000
   */
  studentInstructionText?: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  title?: string;
  /**
   * @minimum 1
   * @maximum 5
   */
  toleranceLevel?: number;
}

export type CreateChatMessageRequestBodyDtoSender =
  (typeof CreateChatMessageRequestBodyDtoSender)[keyof typeof CreateChatMessageRequestBodyDtoSender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatMessageRequestBodyDtoSender = {
  AI: "AI",
  USER: "USER",
} as const;

export type CreateChatMessageRequestBodyDtoMessageContentType =
  (typeof CreateChatMessageRequestBodyDtoMessageContentType)[keyof typeof CreateChatMessageRequestBodyDtoMessageContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateChatMessageRequestBodyDtoMessageContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export interface CreateChatMessageRequestBodyDto {
  followups?: string[];
  isPredefined?: boolean;
  mediaBucketUrl?: string;
  mediaPublicUrl?: string;
  message: string;
  messageContentType?: CreateChatMessageRequestBodyDtoMessageContentType;
  processedMessage?: string;
  sender?: CreateChatMessageRequestBodyDtoSender;
}

export type EssayGradingResultDtoGradingStatus =
  (typeof EssayGradingResultDtoGradingStatus)[keyof typeof EssayGradingResultDtoGradingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssayGradingResultDtoGradingStatus = {
  PROCESSING_RUBRIC: "PROCESSING_RUBRIC",
  RUBRIC_FAILED: "RUBRIC_FAILED",
  PROCESSING_ESSAYS: "PROCESSING_ESSAYS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;

export type EssayGradingChatMessageResponseDtoMessageContentType =
  (typeof EssayGradingChatMessageResponseDtoMessageContentType)[keyof typeof EssayGradingChatMessageResponseDtoMessageContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssayGradingChatMessageResponseDtoMessageContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export interface EssayGradingChatMessageResponseDto {
  createdAt?: string;
  essayGradingId?: number;
  id?: number;
  isFavorite?: boolean;
  isLiked?: boolean;
  mediaBucketUrl?: string;
  mediaPublicUrl?: string;
  message?: string;
  messageContentType?: EssayGradingChatMessageResponseDtoMessageContentType;
  sender?: string;
}

export interface EssayGradingSubSingleResultDto {
  createdAt?: string;
  essayFiles?: TeacherDocumentResponseDto[];
  id?: number;
  messages?: EssayGradingChatMessageResponseDto[];
  result?: NewEssayEvaluationResult;
}

export interface EssayGradingResultDto {
  createdAt?: string;
  description?: string;
  essayFiles?: TeacherDocumentResponseDto[][];
  gradingStatus?: EssayGradingResultDtoGradingStatus;
  id?: number;
  messages?: EssayGradingChatMessageResponseDto[];
  name?: string;
  results?: EssayGradingSubSingleResultDto[];
  rubricAnalyzerResult?: EssayGraderRubricAnalyzerResult;
  rubricFile?: TeacherDocumentResponseDto;
}

export interface EssayGradingRequestBodyDto {
  description?: string;
  environment?: string;
  essayFileIds?: number[];
  instructionsFileId?: number;
  instructionsIncludedInRubric?: boolean;
  name?: string;
  rubricFileId?: number;
  toleranceLevel?: number;
}

export interface SubmitEssayRequestDto {
  essayFileIds: number[];
}

export type EssentialQuestionsCreateRequestDtoGenerationType =
  (typeof EssentialQuestionsCreateRequestDtoGenerationType)[keyof typeof EssentialQuestionsCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssentialQuestionsCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type EssentialQuestionsCreateRequestDtoCourseName =
  (typeof EssentialQuestionsCreateRequestDtoCourseName)[keyof typeof EssentialQuestionsCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssentialQuestionsCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type EssentialQuestionsCreateRequestDtoContentLanguage =
  (typeof EssentialQuestionsCreateRequestDtoContentLanguage)[keyof typeof EssentialQuestionsCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssentialQuestionsCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface EssentialQuestionsCreateRequestDto {
  additionalInfo?: string;
  contentLanguage?: EssentialQuestionsCreateRequestDtoContentLanguage;
  courseName: EssentialQuestionsCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: EssentialQuestionsCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type ExitTicketGeneratorCreateRequestDtoGenerationType =
  (typeof ExitTicketGeneratorCreateRequestDtoGenerationType)[keyof typeof ExitTicketGeneratorCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExitTicketGeneratorCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type ExitTicketGeneratorCreateRequestDtoCourseName =
  (typeof ExitTicketGeneratorCreateRequestDtoCourseName)[keyof typeof ExitTicketGeneratorCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExitTicketGeneratorCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ExitTicketGeneratorCreateRequestDtoContentLanguage =
  (typeof ExitTicketGeneratorCreateRequestDtoContentLanguage)[keyof typeof ExitTicketGeneratorCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExitTicketGeneratorCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface ExitTicketGeneratorCreateRequestDto {
  complexity?: string;
  contentLanguage?: ExitTicketGeneratorCreateRequestDtoContentLanguage;
  courseName: ExitTicketGeneratorCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: ExitTicketGeneratorCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  purpose?: string;
  teacherDocumentIds?: number[];
}

export interface FeedbackRequestDto {
  header: string;
  message: string;
}

export type BaseFileNodeDtoType =
  (typeof BaseFileNodeDtoType)[keyof typeof BaseFileNodeDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseFileNodeDtoType = {
  QUESTION: "QUESTION",
  QUESTION_FOLDER: "QUESTION_FOLDER",
  CHAT: "CHAT",
  CHAT_FOLDER: "CHAT_FOLDER",
  ROOT_FOLDER: "ROOT_FOLDER",
} as const;

export interface BaseFileNodeDto {
  children?: BaseFileNodeDto[];
  createdAt: string;
  id: number;
  name?: string;
  parentId?: number;
  type: BaseFileNodeDtoType;
  userId: number;
}

export type FileNodeCreateDtoType =
  (typeof FileNodeCreateDtoType)[keyof typeof FileNodeCreateDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileNodeCreateDtoType = {
  QUESTION: "QUESTION",
  QUESTION_FOLDER: "QUESTION_FOLDER",
  CHAT: "CHAT",
  CHAT_FOLDER: "CHAT_FOLDER",
  ROOT_FOLDER: "ROOT_FOLDER",
} as const;

export interface FileNodeCreateDto {
  name: string;
  parentId: number;
  type: FileNodeCreateDtoType;
}

export type FormativeAssessmentCreateRequestDtoGenerationType =
  (typeof FormativeAssessmentCreateRequestDtoGenerationType)[keyof typeof FormativeAssessmentCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormativeAssessmentCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type FormativeAssessmentCreateRequestDtoCourseName =
  (typeof FormativeAssessmentCreateRequestDtoCourseName)[keyof typeof FormativeAssessmentCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormativeAssessmentCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type FormativeAssessmentCreateRequestDtoContentLanguage =
  (typeof FormativeAssessmentCreateRequestDtoContentLanguage)[keyof typeof FormativeAssessmentCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormativeAssessmentCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface FormativeAssessmentCreateRequestDto {
  assessmentType?: string;
  classProfile?: string;
  classSize?: string;
  contentLanguage?: FormativeAssessmentCreateRequestDtoContentLanguage;
  courseName: FormativeAssessmentCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: FormativeAssessmentCreateRequestDtoGenerationType;
  gradeLevel: number;
  implementationDuration?: string;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export interface CloneClassroomRequestDto {
  courseId: string;
  courseType: string;
  grade: number;
  section?: string;
}

export interface CourseDto {
  courseState?: string;
  id: string;
  name?: string;
  room?: string;
  section?: string;
}

export interface GetCoursesResponseDto {
  courses: CourseDto[];
}

export interface PublishAssignmentRequestDto {
  assignmentId: number;
  classroomIds: number[];
}

export interface SyncClassroomRequestDto {
  classroomId: number;
}

export interface GoogleLoginResponseDto {
  redirectUrl: string;
}

export interface GoogleLoginRequestDto {
  redirectUrl: string;
  scopes: string[];
}

export type HomeworkIdeaCreateRequestDtoGenerationType =
  (typeof HomeworkIdeaCreateRequestDtoGenerationType)[keyof typeof HomeworkIdeaCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HomeworkIdeaCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type HomeworkIdeaCreateRequestDtoCourseName =
  (typeof HomeworkIdeaCreateRequestDtoCourseName)[keyof typeof HomeworkIdeaCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HomeworkIdeaCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type HomeworkIdeaCreateRequestDtoContentLanguage =
  (typeof HomeworkIdeaCreateRequestDtoContentLanguage)[keyof typeof HomeworkIdeaCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HomeworkIdeaCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface HomeworkIdeaCreateRequestDto {
  contentLanguage?: HomeworkIdeaCreateRequestDtoContentLanguage;
  courseName: HomeworkIdeaCreateRequestDtoCourseName;
  customDuration?: string;
  difficultyLevel?: string;
  environment?: string;
  estimatedDuration?: number;
  evaluationGuidelines?: EvaluationGuidelines;
  fromSuperTool?: boolean;
  generationType?: HomeworkIdeaCreateRequestDtoGenerationType;
  gradeLevel: number;
  homeworkPurpose?: string;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  resourcePreferences?: string[];
  teacherDocumentIds?: number[];
  workType?: string;
}

export interface Score {
  max?: number;
  min?: number;
  raw?: number;
  scaled?: number;
}

export interface Result {
  completion?: boolean;
  duration?: string;
  response?: string;
  score?: Score;
  success?: boolean;
}

export interface ObjectData {
  definition?: Definition;
  id?: string;
  objectType?: string;
}

export interface InteractiveMaterialsCaptureStudentEventRequestDto {
  object?: ObjectData;
  path?: string;
  result?: Result;
  subcontentId?: string;
  userId?: number;
}

export type DefinitionName = { [key: string]: string };

export type DefinitionExtensions = {
  [key: string]: { [key: string]: unknown };
};

export type DefinitionDescription = { [key: string]: string };

export type ChoiceDescription = { [key: string]: string };

export interface Choice {
  description?: ChoiceDescription;
  id?: string;
}

export interface Definition {
  choices?: Choice[];
  correctResponsesPattern?: string[];
  description?: DefinitionDescription;
  extensions?: DefinitionExtensions;
  interactionType?: string;
  name?: DefinitionName;
  type?: string;
}

export interface H5pExportResponseDto {
  downloadUrl?: string;
  id?: number;
}

export interface CreateInteractiveMaterialVideoIntervalRequest {
  endMs?: number;
  startMs?: number;
}

export type CreateInteractiveMaterialSubItemSpecsRequestType =
  (typeof CreateInteractiveMaterialSubItemSpecsRequestType)[keyof typeof CreateInteractiveMaterialSubItemSpecsRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInteractiveMaterialSubItemSpecsRequestType = {
  VIDEO_QUIZ_TF: "VIDEO_QUIZ_TF",
  VIDEO_QUIZ_TEST: "VIDEO_QUIZ_TEST",
  GLOSSARY: "GLOSSARY",
  FLASHCARD: "FLASHCARD",
  DRAG_DROP: "DRAG_DROP",
  QUIZ_TF: "QUIZ_TF",
  QUIZ_TEST: "QUIZ_TEST",
} as const;

export interface CreateInteractiveMaterialSubItemSpecsRequest {
  count?: number;
  type?: CreateInteractiveMaterialSubItemSpecsRequestType;
}

export type CreateInteractiveMaterialRequestGeneratorMode =
  (typeof CreateInteractiveMaterialRequestGeneratorMode)[keyof typeof CreateInteractiveMaterialRequestGeneratorMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInteractiveMaterialRequestGeneratorMode = {
  YOUTUBE: "YOUTUBE",
  PDF: "PDF",
  TEXT: "TEXT",
} as const;

export type CreateInteractiveMaterialRequestCefrLevel =
  (typeof CreateInteractiveMaterialRequestCefrLevel)[keyof typeof CreateInteractiveMaterialRequestCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInteractiveMaterialRequestCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface CreateInteractiveMaterialRequest {
  captureStudentsFirstAnswersOnly?: boolean;
  cefrLevel?: CreateInteractiveMaterialRequestCefrLevel;
  contentLanguage?: string;
  creationSpecs?: CreateInteractiveMaterialSubItemSpecsRequest[];
  driveFileId?: string;
  generatorMode?: CreateInteractiveMaterialRequestGeneratorMode;
  teacherDocumentId?: number;
  text?: string;
  title?: string;
  videoInterval?: CreateInteractiveMaterialVideoIntervalRequest;
  youtubeUrl?: string;
}

export type LessonHookCreateRequestDtoGenerationType =
  (typeof LessonHookCreateRequestDtoGenerationType)[keyof typeof LessonHookCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonHookCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type LessonHookCreateRequestDtoCourseName =
  (typeof LessonHookCreateRequestDtoCourseName)[keyof typeof LessonHookCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonHookCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type LessonHookCreateRequestDtoContentLanguage =
  (typeof LessonHookCreateRequestDtoContentLanguage)[keyof typeof LessonHookCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonHookCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface LessonHookCreateRequestDto {
  contentLanguage?: LessonHookCreateRequestDtoContentLanguage;
  courseName: LessonHookCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: LessonHookCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type CreateExtraCardRequestDtoSectionName =
  (typeof CreateExtraCardRequestDtoSectionName)[keyof typeof CreateExtraCardRequestDtoSectionName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExtraCardRequestDtoSectionName = {
  introduction: "introduction",
  presentation: "presentation",
  guidedPractice: "guidedPractice",
  independentPractice: "independentPractice",
  assessment: "assessment",
  closure: "closure",
} as const;

export interface CreateExtraCardRequestDto {
  existingActivities: SectionContentDto[];
  sectionName: CreateExtraCardRequestDtoSectionName;
}

export interface LearningOutcomeDto {
  id?: string;
  text?: string;
}

export type CreateLessonPlannerV2RequestDtoPlanType =
  (typeof CreateLessonPlannerV2RequestDtoPlanType)[keyof typeof CreateLessonPlannerV2RequestDtoPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLessonPlannerV2RequestDtoPlanType = {
  DAILY: "DAILY",
  MAARIF: "MAARIF",
  UBD_MAARIF: "UBD_MAARIF",
  TED: "TED",
  TED_YEARLY: "TED_YEARLY",
  UBD_EXPERT: "UBD_EXPERT",
} as const;

export type CreateLessonPlannerV2RequestDtoCourseType =
  (typeof CreateLessonPlannerV2RequestDtoCourseType)[keyof typeof CreateLessonPlannerV2RequestDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLessonPlannerV2RequestDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateLessonPlannerV2RequestDto {
  additionalArrangements?: AdditionalArrangementsDto;
  additionalInstructions?: string;
  /** @minimum 1 */
  classDuration: number;
  courseType: CreateLessonPlannerV2RequestDtoCourseType;
  environment?: string;
  grade: number;
  learningMethods?: LearningMethodsDto;
  learningObjectives?: string[];
  learningOutcomes?: LearningOutcomeDto[];
  name?: string;
  planType?: CreateLessonPlannerV2RequestDtoPlanType;
  preferredTeachingStyle?: string;
}

export interface SubscriptionCodeCreateRequestDto {
  code: string;
  durationInDays: number;
  maxCount: number;
}

export interface CreateColumnRequestDto {
  /**
   * @minLength 0
   * @maxLength 100
   */
  title: string;
}

export type CreatePostRequestDtoContentType =
  (typeof CreatePostRequestDtoContentType)[keyof typeof CreatePostRequestDtoContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePostRequestDtoContentType = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  LINK: "LINK",
  FILE: "FILE",
} as const;

export interface CreatePostRequestDto {
  columnId?: number;
  /**
   * @minLength 0
   * @maxLength 30000
   */
  content?: string;
  contentType: CreatePostRequestDtoContentType;
  /**
   * @minLength 0
   * @maxLength 255
   */
  fileName?: string;
  fileUrl?: string;
  positionX?: number;
  positionY?: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  title?: string;
}

export type PostResponseDtoContentType =
  (typeof PostResponseDtoContentType)[keyof typeof PostResponseDtoContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostResponseDtoContentType = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  LINK: "LINK",
  FILE: "FILE",
} as const;

export interface PostResponseDto {
  boardId?: number;
  columnId?: number;
  content?: string;
  contentType?: PostResponseDtoContentType;
  createdAt?: string;
  creatorId?: number;
  fileName?: string;
  fileUrl?: string;
  id?: number;
  likeCount?: number;
  orderIndex?: number;
  positionX?: number;
  positionY?: number;
  title?: string;
  updatedAt?: string;
}

export interface ColumnResponseDto {
  boardId?: number;
  createdAt?: string;
  id?: number;
  orderIndex?: number;
  posts?: PostResponseDto[];
  title?: string;
  updatedAt?: string;
}

export type BoardResponseDtoLayoutType =
  (typeof BoardResponseDtoLayoutType)[keyof typeof BoardResponseDtoLayoutType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BoardResponseDtoLayoutType = {
  WALL: "WALL",
  COLUMNS: "COLUMNS",
} as const;

export type BoardResponseDtoBackgroundType =
  (typeof BoardResponseDtoBackgroundType)[keyof typeof BoardResponseDtoBackgroundType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BoardResponseDtoBackgroundType = {
  UPLOAD: "UPLOAD",
  SYSTEM: "SYSTEM",
} as const;

export interface BoardResponseDto {
  backgroundType?: BoardResponseDtoBackgroundType;
  backgroundValue?: string;
  columns?: ColumnResponseDto[];
  createdAt?: string;
  description?: string;
  id?: number;
  layoutType?: BoardResponseDtoLayoutType;
  ownerId?: number;
  posts?: PostResponseDto[];
  sharingPermission?: boolean;
  title?: string;
  updatedAt?: string;
}

export type CreateBoardRequestDtoLayoutType =
  (typeof CreateBoardRequestDtoLayoutType)[keyof typeof CreateBoardRequestDtoLayoutType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBoardRequestDtoLayoutType = {
  WALL: "WALL",
  COLUMNS: "COLUMNS",
} as const;

export type CreateBoardRequestDtoBackgroundType =
  (typeof CreateBoardRequestDtoBackgroundType)[keyof typeof CreateBoardRequestDtoBackgroundType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBoardRequestDtoBackgroundType = {
  UPLOAD: "UPLOAD",
  SYSTEM: "SYSTEM",
} as const;

export interface CreateBoardRequestDto {
  backgroundType: CreateBoardRequestDtoBackgroundType;
  /**
   * @minLength 0
   * @maxLength 500
   */
  backgroundValue?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  layoutType: CreateBoardRequestDtoLayoutType;
  /**
   * @minLength 0
   * @maxLength 100
   */
  title: string;
}

export type GenerateToolFromNodeRequestDtoTargetToolType =
  (typeof GenerateToolFromNodeRequestDtoTargetToolType)[keyof typeof GenerateToolFromNodeRequestDtoTargetToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateToolFromNodeRequestDtoTargetToolType = {
  AI_ASSESSMENT_SCALE: "AI_ASSESSMENT_SCALE",
  AI_ASSIGNMENT: "AI_ASSIGNMENT",
  AI_RESISTANT_HOMEWORK: "AI_RESISTANT_HOMEWORK",
  AI_SUPPORTED_TASKS: "AI_SUPPORTED_TASKS",
  BLOOMS_TAXONOMY_ACTIVITIES: "BLOOMS_TAXONOMY_ACTIVITIES",
  CHOICE_BOARD: "CHOICE_BOARD",
  CLASSROOM_MANAGEMENT: "CLASSROOM_MANAGEMENT",
  COLLABORATIVE_GROUP_WORK: "COLLABORATIVE_GROUP_WORK",
  COMMON_MISCONCEPTION: "COMMON_MISCONCEPTION",
  CONCEPTUAL_UNDERSTANDING: "CONCEPTUAL_UNDERSTANDING",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  EXIT_TICKET_GENERATOR: "EXIT_TICKET_GENERATOR",
  FORMATIVE_ASSESSMENT: "FORMATIVE_ASSESSMENT",
  HOMEWORK_IDEA: "HOMEWORK_IDEA",
  IMAGE_GENERATOR: "IMAGE_GENERATOR",
  LESSON_HOOK: "LESSON_HOOK",
  MINDMAP_GENERATOR: "MINDMAP_GENERATOR",
  PERFORMANCE_TASK: "PERFORMANCE_TASK",
  PODCAST: "PODCAST",
  PROJECT_BASED_LEARNING: "PROJECT_BASED_LEARNING",
  REAL_WORLD_CONNECTION: "REAL_WORLD_CONNECTION",
  RUBRIC_GENERATOR: "RUBRIC_GENERATOR",
  SUMMARIZER: "SUMMARIZER",
  TEXT_LEVELER: "TEXT_LEVELER",
  TRANSFER_ACTIVITY: "TRANSFER_ACTIVITY",
  UDL_CHOICE_BOARD: "UDL_CHOICE_BOARD",
  VOCABULARY_LIST: "VOCABULARY_LIST",
  HEYGEN_AVATAR: "HEYGEN_AVATAR",
  ARTICLE_GENERATOR: "ARTICLE_GENERATOR",
  SKETCH_GENERATOR: "SKETCH_GENERATOR",
} as const;

export interface GenerateToolFromNodeRequestDto {
  nodeId: string;
  targetToolType: GenerateToolFromNodeRequestDtoTargetToolType;
}

export type MindmapGeneratorCreateRequestDtoGenerationType =
  (typeof MindmapGeneratorCreateRequestDtoGenerationType)[keyof typeof MindmapGeneratorCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MindmapGeneratorCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type MindmapGeneratorCreateRequestDtoCourseName =
  (typeof MindmapGeneratorCreateRequestDtoCourseName)[keyof typeof MindmapGeneratorCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MindmapGeneratorCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type MindmapGeneratorCreateRequestDtoContentLanguage =
  (typeof MindmapGeneratorCreateRequestDtoContentLanguage)[keyof typeof MindmapGeneratorCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MindmapGeneratorCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface MindmapGeneratorCreateRequestDto {
  contentLanguage?: MindmapGeneratorCreateRequestDtoContentLanguage;
  courseName: MindmapGeneratorCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: MindmapGeneratorCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export interface CreateOrganizationResponseDto {
  createdAt?: string;
  createdBy?: number;
  id?: number;
  logo?: string;
  name?: string;
}

export interface OrganizationCreateRequestBodyDto {
  name: string;
}

export type AddApiKeyRequestDtoSupplier =
  (typeof AddApiKeyRequestDtoSupplier)[keyof typeof AddApiKeyRequestDtoSupplier];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddApiKeyRequestDtoSupplier = {
  OPENAI: "OPENAI",
  GEMINI: "GEMINI",
  VERTEX: "VERTEX",
  AZUREOPENAICURL: "AZUREOPENAICURL",
  AZUREOPENAI: "AZUREOPENAI",
  BEDROCK: "BEDROCK",
  AZUREOPENAICURL2025: "AZUREOPENAICURL2025",
} as const;

export type AddApiKeyRequestDtoJobType =
  (typeof AddApiKeyRequestDtoJobType)[keyof typeof AddApiKeyRequestDtoJobType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddApiKeyRequestDtoJobType = {
  STUDENT_CHAT: "STUDENT_CHAT",
  STUDENT_CHAT_AGENT: "STUDENT_CHAT_AGENT",
  TEACHER_CHAT: "TEACHER_CHAT",
  TEACHER_CHAT_AGENT: "TEACHER_CHAT_AGENT",
  DIDACTIC_CHAT: "DIDACTIC_CHAT",
  STUDENT_FEEDBACK_CHAT: "STUDENT_FEEDBACK_CHAT",
  QUESTION_GENERATION: "QUESTION_GENERATION",
  QUESTION_EXPLAIN: "QUESTION_EXPLAIN",
  QUESTION_EXPLAIN_AGENT: "QUESTION_EXPLAIN_AGENT",
  QUESTION_GRADING: "QUESTION_GRADING",
  QUESTION_GRADING_AGENT: "QUESTION_GRADING_AGENT",
  CHATLY_ANALYSIS: "CHATLY_ANALYSIS",
  TOPIC_MERGER: "TOPIC_MERGER",
  WEEKLY_ANALYSIS: "WEEKLY_ANALYSIS",
  ESSAY_GRADING: "ESSAY_GRADING",
  QUESTION_SOLVER: "QUESTION_SOLVER",
  QUESTION_HELPER: "QUESTION_HELPER",
  QUESTION_SOLVER_AGENT: "QUESTION_SOLVER_AGENT",
  LESSON_PLANNER: "LESSON_PLANNER",
  QUESTION_REGEN: "QUESTION_REGEN",
  STUDENT_CHAT_MATH: "STUDENT_CHAT_MATH",
  STUDENT_CHAT_MATH_AGENT: "STUDENT_CHAT_MATH_AGENT",
  CUSTOM_GPT_CHAT: "CUSTOM_GPT_CHAT",
  UBD_PLANNER: "UBD_PLANNER",
  UBD_MAARIF_PLANNER: "UBD_MAARIF_PLANNER",
  TED_LESSON_PLANNER: "TED_LESSON_PLANNER",
  TED_YEARLY_LESSON_PLANNER: "TED_YEARLY_LESSON_PLANNER",
  SLIDE_GENERATOR: "SLIDE_GENERATOR",
  INTERACTIVE_MATERIAL: "INTERACTIVE_MATERIAL",
  TOOL_AI_ASSIGNMENT: "TOOL_AI_ASSIGNMENT",
  TOOL_AI_RESISTANT_HOMEWORK: "TOOL_AI_RESISTANT_HOMEWORK",
  TOOL_AI_SUPPORTED_TASKS: "TOOL_AI_SUPPORTED_TASKS",
  TOOL_BLOOMS_TAXONOMY_ACTIVITIES: "TOOL_BLOOMS_TAXONOMY_ACTIVITIES",
  TOOL_CHOICE_BOARD: "TOOL_CHOICE_BOARD",
  TOOL_CLASSROOM_MANAGEMENT: "TOOL_CLASSROOM_MANAGEMENT",
  TOOL_COLLABORATIVE_GROUP_WORK: "TOOL_COLLABORATIVE_GROUP_WORK",
  TOOL_COMMON_MISCONCEPTION: "TOOL_COMMON_MISCONCEPTION",
  TOOL_CONCEPTUAL_UNDERSTANDING: "TOOL_CONCEPTUAL_UNDERSTANDING",
  TOOL_ESSENTIAL_QUESTIONS: "TOOL_ESSENTIAL_QUESTIONS",
  TOOL_EXIT_TICKETS: "TOOL_EXIT_TICKETS",
  TOOL_FORMATIVE_ASSESSMENT: "TOOL_FORMATIVE_ASSESSMENT",
  TOOL_HOMEWORK_IDEA: "TOOL_HOMEWORK_IDEA",
  TOOL_IMAGE_GENERATOR: "TOOL_IMAGE_GENERATOR",
  TOOL_LESSON_HOOK: "TOOL_LESSON_HOOK",
  TOOL_MINDMAP_GENERATOR: "TOOL_MINDMAP_GENERATOR",
  TOOL_PERFORMANCE_TASK: "TOOL_PERFORMANCE_TASK",
  TOOL_PODCAST: "TOOL_PODCAST",
  TOOL_PROJECT_BASED_LEARNING: "TOOL_PROJECT_BASED_LEARNING",
  TOOL_REAL_WORLD_CONNECTION: "TOOL_REAL_WORLD_CONNECTION",
  TOOL_RUBRIC_GENERATOR: "TOOL_RUBRIC_GENERATOR",
  TOOL_SUMMARIZER: "TOOL_SUMMARIZER",
  TOOL_TEXT_LEVELER: "TOOL_TEXT_LEVELER",
  TOOL_TRANSFER_ACTIVITY: "TOOL_TRANSFER_ACTIVITY",
  TOOL_UDL_CHOICE_BOARD: "TOOL_UDL_CHOICE_BOARD",
  TOOL_VOCABULARY_LIST: "TOOL_VOCABULARY_LIST",
  TOOL_AI_ASSESSMENT_SCALE: "TOOL_AI_ASSESSMENT_SCALE",
  PROMPT_ENHANCER: "PROMPT_ENHANCER",
  TEACHER_TOOL_CHAT: "TEACHER_TOOL_CHAT",
  TOOL_HEYGEN_AVATAR: "TOOL_HEYGEN_AVATAR",
  TOOL_ARTICLE_GENERATOR: "TOOL_ARTICLE_GENERATOR",
  TOOL_SKETCH_GENERATOR: "TOOL_SKETCH_GENERATOR",
  SWANN_VISUAL_MATCHING: "SWANN_VISUAL_MATCHING",
  SWANN_PODCAST_GENERATOR: "SWANN_PODCAST_GENERATOR",
  SWANN_PRONUNCIATION_ASSIGNMENT: "SWANN_PRONUNCIATION_ASSIGNMENT",
  SWANN_SPOKEN_DIALOGUE: "SWANN_SPOKEN_DIALOGUE",
} as const;

export interface AddApiKeyRequestDto {
  coefficient?: number;
  content: string;
  environment?: string;
  jobType?: AddApiKeyRequestDtoJobType;
  modelName: string;
  supplier: AddApiKeyRequestDtoSupplier;
}

export interface AddRemoveStudentsToFromClassroomRequestBodyDto {
  studentIds: number[];
}

export type CreateClassroomRequestBodyDtoCourseType =
  (typeof CreateClassroomRequestBodyDtoCourseType)[keyof typeof CreateClassroomRequestBodyDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateClassroomRequestBodyDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateClassroomRequestBodyDto {
  courseType: CreateClassroomRequestBodyDtoCourseType;
  /**
   * @minimum -4
   * @maximum 12
   */
  grade: number;
  name: string;
  section?: string;
  teacherId: number;
}

export interface OrganizationAdminResponseDto {
  email: string;
  id: number;
  name: string;
  preferences?: UserPreferences;
  surname: string;
}

export interface CreateStudentRequestBodyDto {
  city?: string;
  email?: string;
  grade?: number;
  hobbies?: string[];
  name: string;
  password?: string;
  preferences?: UserPreferences;
  school?: string;
  surname: string;
}

export interface CreateTeacherRequestBodyDto {
  email?: string;
  name: string;
  password?: string;
  preferences?: UserPreferences;
  surname?: string;
}

export type PerformanceTaskCreateRequestDtoGenerationType =
  (typeof PerformanceTaskCreateRequestDtoGenerationType)[keyof typeof PerformanceTaskCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PerformanceTaskCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type PerformanceTaskCreateRequestDtoCourseName =
  (typeof PerformanceTaskCreateRequestDtoCourseName)[keyof typeof PerformanceTaskCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PerformanceTaskCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type PerformanceTaskCreateRequestDtoContentLanguage =
  (typeof PerformanceTaskCreateRequestDtoContentLanguage)[keyof typeof PerformanceTaskCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PerformanceTaskCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface PerformanceTaskCreateRequestDto {
  additionalInfo?: string;
  contentLanguage?: PerformanceTaskCreateRequestDtoContentLanguage;
  courseName: PerformanceTaskCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: PerformanceTaskCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type CreatePodcastFromReferenceRequestDtoGenerationType =
  (typeof CreatePodcastFromReferenceRequestDtoGenerationType)[keyof typeof CreatePodcastFromReferenceRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePodcastFromReferenceRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type CreatePodcastFromReferenceRequestDtoContentLanguage =
  (typeof CreatePodcastFromReferenceRequestDtoContentLanguage)[keyof typeof CreatePodcastFromReferenceRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePodcastFromReferenceRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface CreatePodcastFromReferenceRequestDto {
  changePrompt?: string;
  contentLanguage?: CreatePodcastFromReferenceRequestDtoContentLanguage;
  environment?: string;
  firstUserName?: string;
  fromSuperTool?: boolean;
  generationType?: CreatePodcastFromReferenceRequestDtoGenerationType;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  referencePodcastId?: number;
  secondUserName?: string;
  teacherDocumentIds?: number[];
}

export interface AssignPodcastRequestDto {
  assignedStudentsWithClassrooms?: AssignAssignmentRequestBodyNewItem[];
  endDate?: string;
  startDate?: string;
}

export type CreatePodcastRequestDtoGenerationType =
  (typeof CreatePodcastRequestDtoGenerationType)[keyof typeof CreatePodcastRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePodcastRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type CreatePodcastRequestDtoContentLanguage =
  (typeof CreatePodcastRequestDtoContentLanguage)[keyof typeof CreatePodcastRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePodcastRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type CreatePodcastRequestDtoCefrLevel =
  (typeof CreatePodcastRequestDtoCefrLevel)[keyof typeof CreatePodcastRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePodcastRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface CreatePodcastRequestDto {
  cefrLevel?: CreatePodcastRequestDtoCefrLevel;
  contentLanguage?: CreatePodcastRequestDtoContentLanguage;
  environment?: string;
  firstUserName?: string;
  fromSuperTool?: boolean;
  generationType?: CreatePodcastRequestDtoGenerationType;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  secondUserName?: string;
  teacherDocumentIds?: number[];
}

export type ProjectBasedLearningCreateRequestDtoGenerationType =
  (typeof ProjectBasedLearningCreateRequestDtoGenerationType)[keyof typeof ProjectBasedLearningCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectBasedLearningCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type ProjectBasedLearningCreateRequestDtoCourseName =
  (typeof ProjectBasedLearningCreateRequestDtoCourseName)[keyof typeof ProjectBasedLearningCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectBasedLearningCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ProjectBasedLearningCreateRequestDtoContentLanguage =
  (typeof ProjectBasedLearningCreateRequestDtoContentLanguage)[keyof typeof ProjectBasedLearningCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectBasedLearningCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface ProjectBasedLearningCreateRequestDto {
  contentLanguage?: ProjectBasedLearningCreateRequestDtoContentLanguage;
  courseName: ProjectBasedLearningCreateRequestDtoCourseName;
  environment?: string;
  expectedProductTypes?: string;
  fromSuperTool?: boolean;
  generationType?: ProjectBasedLearningCreateRequestDtoGenerationType;
  gradeLevel: number;
  illDefinedCriteria?: string;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  problemType?: string;
  projectDuration?: string;
  prompt?: string;
  skillsToDevelop?: string;
  teacherDocumentIds?: number[];
}

export interface PromptEnhancerResponseDto {
  inputPrompt?: string;
  result?: string;
}

export type PromptEnhancerCreateRequestDtoToolType =
  (typeof PromptEnhancerCreateRequestDtoToolType)[keyof typeof PromptEnhancerCreateRequestDtoToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromptEnhancerCreateRequestDtoToolType = {
  AI_ASSESSMENT_SCALE: "AI_ASSESSMENT_SCALE",
  AI_ASSIGNMENT: "AI_ASSIGNMENT",
  AI_RESISTANT_HOMEWORK: "AI_RESISTANT_HOMEWORK",
  AI_SUPPORTED_TASKS: "AI_SUPPORTED_TASKS",
  BLOOMS_TAXONOMY_ACTIVITIES: "BLOOMS_TAXONOMY_ACTIVITIES",
  CHOICE_BOARD: "CHOICE_BOARD",
  CLASSROOM_MANAGEMENT: "CLASSROOM_MANAGEMENT",
  COLLABORATIVE_GROUP_WORK: "COLLABORATIVE_GROUP_WORK",
  COMMON_MISCONCEPTION: "COMMON_MISCONCEPTION",
  CONCEPTUAL_UNDERSTANDING: "CONCEPTUAL_UNDERSTANDING",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  EXIT_TICKET_GENERATOR: "EXIT_TICKET_GENERATOR",
  FORMATIVE_ASSESSMENT: "FORMATIVE_ASSESSMENT",
  HOMEWORK_IDEA: "HOMEWORK_IDEA",
  IMAGE_GENERATOR: "IMAGE_GENERATOR",
  LESSON_HOOK: "LESSON_HOOK",
  MINDMAP_GENERATOR: "MINDMAP_GENERATOR",
  PERFORMANCE_TASK: "PERFORMANCE_TASK",
  PODCAST: "PODCAST",
  PROJECT_BASED_LEARNING: "PROJECT_BASED_LEARNING",
  REAL_WORLD_CONNECTION: "REAL_WORLD_CONNECTION",
  RUBRIC_GENERATOR: "RUBRIC_GENERATOR",
  SUMMARIZER: "SUMMARIZER",
  TEXT_LEVELER: "TEXT_LEVELER",
  TRANSFER_ACTIVITY: "TRANSFER_ACTIVITY",
  UDL_CHOICE_BOARD: "UDL_CHOICE_BOARD",
  VOCABULARY_LIST: "VOCABULARY_LIST",
  HEYGEN_AVATAR: "HEYGEN_AVATAR",
  ARTICLE_GENERATOR: "ARTICLE_GENERATOR",
  SKETCH_GENERATOR: "SKETCH_GENERATOR",
} as const;

export type PromptEnhancerCreateRequestDtoImageType =
  (typeof PromptEnhancerCreateRequestDtoImageType)[keyof typeof PromptEnhancerCreateRequestDtoImageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromptEnhancerCreateRequestDtoImageType = {
  POSTER: "POSTER",
  LOGO: "LOGO",
  INFOGRAPHIC: "INFOGRAPHIC",
  BADGE: "BADGE",
  CERTIFICATE: "CERTIFICATE",
  FLASHCARD: "FLASHCARD",
  SCENE: "SCENE",
  AVATAR: "AVATAR",
  LABEL: "LABEL",
  BANNER: "BANNER",
  DEFAULT: "DEFAULT",
} as const;

export interface PromptEnhancerCreateRequestDto {
  imageType?: PromptEnhancerCreateRequestDtoImageType;
  prompt?: string;
  toolType?: PromptEnhancerCreateRequestDtoToolType;
}

export interface CreatePublicSessionResponseDto {
  accessToken?: string;
  imageUrl?: string;
  participantIdentity?: string;
  participantName?: string;
  publicCode?: string;
  roomName?: string;
  roomSid?: string;
  spokenDialogueId?: number;
}

export interface CreatePublicSessionRequestDto {
  metadata?: string;
  participantIdentity?: string;
  participantName?: string;
}

export interface QuestionHelperCreateRequestDto {
  imageUrl: string;
  tags?: string[];
}

export interface ApplyQuestionRegenRequestDto {
  questionId: number;
  questionRegenId: number;
}

export interface CreateQuestionRegenRequestDto {
  environment?: string;
  id: number;
  prompt: string;
}

export type QuestionSolverCreateRequestDtoLevel =
  (typeof QuestionSolverCreateRequestDtoLevel)[keyof typeof QuestionSolverCreateRequestDtoLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSolverCreateRequestDtoLevel = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export type QuestionSolverCreateRequestDtoCourse =
  (typeof QuestionSolverCreateRequestDtoCourse)[keyof typeof QuestionSolverCreateRequestDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSolverCreateRequestDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface QuestionSolverCreateRequestDto {
  course: QuestionSolverCreateRequestDtoCourse;
  environment?: string;
  level?: QuestionSolverCreateRequestDtoLevel;
  name: string;
  parentFolderId?: number;
  rememberQuestionLevelChoice?: boolean;
  uri: string;
}

export type RealWorldConnectionCreateRequestDtoGenerationType =
  (typeof RealWorldConnectionCreateRequestDtoGenerationType)[keyof typeof RealWorldConnectionCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RealWorldConnectionCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type RealWorldConnectionCreateRequestDtoCourseName =
  (typeof RealWorldConnectionCreateRequestDtoCourseName)[keyof typeof RealWorldConnectionCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RealWorldConnectionCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type RealWorldConnectionCreateRequestDtoContentLanguage =
  (typeof RealWorldConnectionCreateRequestDtoContentLanguage)[keyof typeof RealWorldConnectionCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RealWorldConnectionCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface RealWorldConnectionCreateRequestDto {
  classroomImplementation?: string;
  contentLanguage?: RealWorldConnectionCreateRequestDtoContentLanguage;
  courseName: RealWorldConnectionCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: RealWorldConnectionCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  targetSkills?: string[];
  teacherDocumentIds?: number[];
  usagePurposes?: string[];
}

export type RubricGeneratorCreateRequestDtoRubricType =
  (typeof RubricGeneratorCreateRequestDtoRubricType)[keyof typeof RubricGeneratorCreateRequestDtoRubricType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RubricGeneratorCreateRequestDtoRubricType = {
  ANALYTIC: "ANALYTIC",
  HOLISTIC: "HOLISTIC",
} as const;

export type RubricGeneratorCreateRequestDtoGenerationType =
  (typeof RubricGeneratorCreateRequestDtoGenerationType)[keyof typeof RubricGeneratorCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RubricGeneratorCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type RubricGeneratorCreateRequestDtoCourseName =
  (typeof RubricGeneratorCreateRequestDtoCourseName)[keyof typeof RubricGeneratorCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RubricGeneratorCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type RubricGeneratorCreateRequestDtoContentLanguage =
  (typeof RubricGeneratorCreateRequestDtoContentLanguage)[keyof typeof RubricGeneratorCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RubricGeneratorCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type RubricGeneratorCreateRequestDtoCefrLevel =
  (typeof RubricGeneratorCreateRequestDtoCefrLevel)[keyof typeof RubricGeneratorCreateRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RubricGeneratorCreateRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface RubricGeneratorCreateRequestDto {
  additionalInfo?: string;
  assignmentInstructions?: string;
  cefrLevel?: RubricGeneratorCreateRequestDtoCefrLevel;
  contentLanguage?: RubricGeneratorCreateRequestDtoContentLanguage;
  contextOfUse?: string;
  courseName: RubricGeneratorCreateRequestDtoCourseName;
  environment?: string;
  evaluationCriteria?: string[];
  fromSuperTool?: boolean;
  generationType?: RubricGeneratorCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  /**
   * @minimum 3
   * @maximum 7
   */
  levels?: number;
  mindmapId?: number;
  performanceLevelNames?: string[];
  prompt?: string;
  rubricType: RubricGeneratorCreateRequestDtoRubricType;
  scoringDetails?: string;
  teacherDocumentIds?: number[];
  /**
   * @minimum 0
   * @maximum 100
   */
  totalScore?: number;
}

export type SketchGeneratorCreateRequestDtoGenerationType =
  (typeof SketchGeneratorCreateRequestDtoGenerationType)[keyof typeof SketchGeneratorCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SketchGeneratorCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type SketchGeneratorCreateRequestDtoCourseName =
  (typeof SketchGeneratorCreateRequestDtoCourseName)[keyof typeof SketchGeneratorCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SketchGeneratorCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type SketchGeneratorCreateRequestDtoContentLanguage =
  (typeof SketchGeneratorCreateRequestDtoContentLanguage)[keyof typeof SketchGeneratorCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SketchGeneratorCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface SketchGeneratorCreateRequestDto {
  contentLanguage?: SketchGeneratorCreateRequestDtoContentLanguage;
  courseName: SketchGeneratorCreateRequestDtoCourseName;
  durationMinutes?: number;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: SketchGeneratorCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
  ttsProvider?: string;
  visualStyle?: string;
}

export interface CreateSlideGeneratorSlidesRequestDto {
  prompt?: string;
}

export interface RegenSlideGeneratorOutlineRequestDto {
  regenPrompt?: string;
}

export type CreateSlideGeneratorOutlineRequestDtoCourseType =
  (typeof CreateSlideGeneratorOutlineRequestDtoCourseType)[keyof typeof CreateSlideGeneratorOutlineRequestDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSlideGeneratorOutlineRequestDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateSlideGeneratorOutlineRequestDto {
  courseType: CreateSlideGeneratorOutlineRequestDtoCourseType;
  environment?: string;
  /**
   * @minimum 1
   * @maximum 12
   */
  grade: number;
  name?: string;
  prompt?: string;
}

export type TrueFalseAnswerInteractiveMaterialStudentAllOf = {
  question?: TrueFalseQuestion;
  type?: string;
};

export type TrueFalseAnswerInteractiveMaterialStudent =
  InteractiveMaterialStudentBaseAnswer &
    TrueFalseAnswerInteractiveMaterialStudentAllOf;

export type TestAnswerInteractiveMaterialStudentAllOf = {
  question?: TestQuestion;
  type?: string;
};

export type TestAnswerInteractiveMaterialStudent =
  InteractiveMaterialStudentBaseAnswer &
    TestAnswerInteractiveMaterialStudentAllOf;

export type StudentInteractiveMaterialResponseDtoVideoQuizAnswersItem =
  | InteractiveMaterialStudentBaseAnswer
  | TestAnswerInteractiveMaterialStudent
  | TrueFalseAnswerInteractiveMaterialStudent;

export type StudentInteractiveMaterialResponseDtoStatus =
  (typeof StudentInteractiveMaterialResponseDtoStatus)[keyof typeof StudentInteractiveMaterialResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentInteractiveMaterialResponseDtoStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  OVERDUE: "OVERDUE",
} as const;

export type StudentInteractiveMaterialResponseDtoQuizAnswersItem =
  | InteractiveMaterialStudentBaseAnswer
  | TestAnswerInteractiveMaterialStudent
  | TrueFalseAnswerInteractiveMaterialStudent;

export interface StudentInteractiveMaterialResponseDto {
  createdDate: string;
  endDate: string;
  interactiveMaterialCaptureStudentsFirstAnswersOnly?: boolean;
  interactiveMaterialDescription?: string;
  interactiveMaterialId: number;
  interactiveMaterialThumbnail?: string;
  interactiveMaterialTitle?: string;
  progress: number;
  quizAnswers: StudentInteractiveMaterialResponseDtoQuizAnswersItem[];
  startDate: string;
  status: StudentInteractiveMaterialResponseDtoStatus;
  studentId: number;
  studentName: string;
  teacherId: number;
  videoQuizAnswers: StudentInteractiveMaterialResponseDtoVideoQuizAnswersItem[];
}

export interface InteractiveMaterialStudentBaseAnswer {
  answeredAt?: string;
  isCorrect?: boolean;
  score?: number;
  studentAnswer?: string;
  subcontentId?: string;
  type: string;
}

export type CreateQuestionAnswerRequestBodyDtoType =
  (typeof CreateQuestionAnswerRequestBodyDtoType)[keyof typeof CreateQuestionAnswerRequestBodyDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuestionAnswerRequestBodyDtoType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export type CreateQuestionAnswerRequestBodyDtoAnswer = {
  [key: string]: unknown;
};

export interface CreateQuestionAnswerRequestBodyDto {
  answer?: CreateQuestionAnswerRequestBodyDtoAnswer;
  imageUri?: string;
  type: CreateQuestionAnswerRequestBodyDtoType;
}

export interface DailyStreakResponseDto {
  dailyLoginStreakValue?: number;
  dailyStreakValue?: number;
  didChat?: boolean;
  didFinishDailyAssignment?: boolean;
  didFinishDailyBlogQuiz?: boolean;
  lastDailyStreakDay?: string;
  userId?: number;
  userName?: string;
  userSurname?: string;
}

export interface BaseStudentDailyAssignmentProgressResponseDto {
  dailyAssignmentId?: number;
  id?: number;
  score?: number;
  xp?: number;
}

export interface BaseStudentBlogPostProgressResponseDto {
  blogPostId?: number;
  id?: number;
  score?: number;
  xp?: number;
}

export type BaseClassroomResponseDtoCourseType =
  (typeof BaseClassroomResponseDtoCourseType)[keyof typeof BaseClassroomResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseClassroomResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface BaseClassroomResponseDto {
  courseType: BaseClassroomResponseDtoCourseType;
  edlinkClassId?: string;
  googleClassroom?: boolean;
  grade: number;
  id: number;
  name: string;
  organizationId: number;
  section: string;
  studentCount: number;
  uuid?: string;
  visibleCourseType?: string;
}

export interface StudentResponseDto {
  assignmentIds?: number[];
  avatarName?: string;
  blogQuizProgress: BaseStudentBlogPostProgressResponseDto[];
  classes: BaseClassroomResponseDto[];
  createdAt?: string;
  dailyAssignmentProgress: BaseStudentDailyAssignmentProgressResponseDto[];
  dailyStreak: DailyStreakResponseDto;
  edlinkPersonId?: string;
  email: string;
  grade?: number;
  hobbies?: string[];
  id: number;
  isPremium: boolean;
  name: string;
  preferences?: UserPreferences;
  premiumExpireDate?: string;
  rootFolderId?: number;
  surname: string;
  xp: number;
}

export interface EditStudentRequestBodyDto {
  avatarName?: string;
  city?: string;
  grade?: number;
  hobbies?: string[];
  name?: string;
  preferences?: UserPreferences;
  school?: string;
  surname?: string;
}

export interface EnrollClassroomWithCodeRequestBodyDto {
  classroomUuid: string;
}

export interface RegisterStudentResponseDto {
  customToken?: string;
}

export interface RegisterStudentRequestBodyDto {
  avatarName?: string;
  city?: string;
  email: string;
  grade?: number;
  hobbies?: string[];
  name: string;
  password: string;
  preferences?: UserPreferences;
  school?: string;
  surname: string;
}

export type SummarizerCreateRequestDtoGenerationType =
  (typeof SummarizerCreateRequestDtoGenerationType)[keyof typeof SummarizerCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SummarizerCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type SummarizerCreateRequestDtoContentLanguage =
  (typeof SummarizerCreateRequestDtoContentLanguage)[keyof typeof SummarizerCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SummarizerCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type SummarizerCreateRequestDtoCefrLevel =
  (typeof SummarizerCreateRequestDtoCefrLevel)[keyof typeof SummarizerCreateRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SummarizerCreateRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface SummarizerCreateRequestDto {
  cefrLevel?: SummarizerCreateRequestDtoCefrLevel;
  contentLanguage?: SummarizerCreateRequestDtoContentLanguage;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: SummarizerCreateRequestDtoGenerationType;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  originalText?: string;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export interface AssignInteractiveMaterialRequestDto {
  assignedStudentsWithClassrooms?: AssignAssignmentRequestBodyNewItem[];
  endDate?: string;
  startDate?: string;
}

export type CreatePronunciationAssignmentRequestDtoGenerationType =
  (typeof CreatePronunciationAssignmentRequestDtoGenerationType)[keyof typeof CreatePronunciationAssignmentRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePronunciationAssignmentRequestDtoGenerationType = {
  WORD: "WORD",
  SENTENCE: "SENTENCE",
} as const;

export type CreatePronunciationAssignmentRequestDtoContentLanguage =
  (typeof CreatePronunciationAssignmentRequestDtoContentLanguage)[keyof typeof CreatePronunciationAssignmentRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePronunciationAssignmentRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type CreatePronunciationAssignmentRequestDtoCefrLevel =
  (typeof CreatePronunciationAssignmentRequestDtoCefrLevel)[keyof typeof CreatePronunciationAssignmentRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePronunciationAssignmentRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type CreatePronunciationAssignmentRequestDtoAccent =
  (typeof CreatePronunciationAssignmentRequestDtoAccent)[keyof typeof CreatePronunciationAssignmentRequestDtoAccent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePronunciationAssignmentRequestDtoAccent = {
  BRITISH: "BRITISH",
  AMERICAN: "AMERICAN",
} as const;

export interface CreatePronunciationAssignmentRequestDto {
  accent: CreatePronunciationAssignmentRequestDtoAccent;
  cefrLevel: CreatePronunciationAssignmentRequestDtoCefrLevel;
  contentLanguage: CreatePronunciationAssignmentRequestDtoContentLanguage;
  /**
   * Üretilecek öğe sayısı
   * @minimum 1
   */
  generationCount?: number;
  generationType: CreatePronunciationAssignmentRequestDtoGenerationType;
  /** Visual Matching ile aynı: tek bir Teacher Document ID */
  teacherDocumentId?: number;
  topic?: string;
}

export interface PublicSubmissionResponseDto {
  results?: JsonNode;
}

export interface PublicSubmitRequestDto {
  fileUrl?: string;
  itemId: string;
  solverName: string;
}

export type SpokenDialogueResponseDtoStatus =
  (typeof SpokenDialogueResponseDtoStatus)[keyof typeof SpokenDialogueResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpokenDialogueResponseDtoStatus = {
  PROCESSING: "PROCESSING",
  REGENERATING: "REGENERATING",
  READY: "READY",
  FAILED: "FAILED",
} as const;

export type SpokenDialogueResponseDtoLanguage =
  (typeof SpokenDialogueResponseDtoLanguage)[keyof typeof SpokenDialogueResponseDtoLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpokenDialogueResponseDtoLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type SpokenDialogueResponseDtoCefrLevel =
  (typeof SpokenDialogueResponseDtoCefrLevel)[keyof typeof SpokenDialogueResponseDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpokenDialogueResponseDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface SpokenDialogueResponseDto {
  accent?: string;
  assessmentRubric?: JsonNode;
  cefrLevel?: SpokenDialogueResponseDtoCefrLevel;
  description?: string;
  dialogueScript?: JsonNode;
  duration?: number;
  id?: number;
  imageUrl?: string;
  language?: SpokenDialogueResponseDtoLanguage;
  publicCode?: string;
  scenario?: string;
  status?: SpokenDialogueResponseDtoStatus;
  title?: string;
}

export type SpokenDialogueCreateRequestDtoLanguage =
  (typeof SpokenDialogueCreateRequestDtoLanguage)[keyof typeof SpokenDialogueCreateRequestDtoLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpokenDialogueCreateRequestDtoLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type SpokenDialogueCreateRequestDtoEvaluationCriteria = {
  [key: string]: number;
};

export type SpokenDialogueCreateRequestDtoCefrLevel =
  (typeof SpokenDialogueCreateRequestDtoCefrLevel)[keyof typeof SpokenDialogueCreateRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpokenDialogueCreateRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface SpokenDialogueCreateRequestDto {
  accent?: string;
  cefr_level?: SpokenDialogueCreateRequestDtoCefrLevel;
  duration?: number;
  evaluation_criteria?: SpokenDialogueCreateRequestDtoEvaluationCriteria;
  language?: SpokenDialogueCreateRequestDtoLanguage;
  scenario?: string;
}

export type VisualMatchingCreateRequestDtoLanguage =
  (typeof VisualMatchingCreateRequestDtoLanguage)[keyof typeof VisualMatchingCreateRequestDtoLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VisualMatchingCreateRequestDtoLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type VisualMatchingCreateRequestDtoGenerationType =
  (typeof VisualMatchingCreateRequestDtoGenerationType)[keyof typeof VisualMatchingCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VisualMatchingCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type VisualMatchingCreateRequestDtoCefrLevel =
  (typeof VisualMatchingCreateRequestDtoCefrLevel)[keyof typeof VisualMatchingCreateRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VisualMatchingCreateRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface VisualMatchingCreateRequestDto {
  cefrLevel?: VisualMatchingCreateRequestDtoCefrLevel;
  generateImages?: boolean;
  generationType?: VisualMatchingCreateRequestDtoGenerationType;
  imageStyle?: string;
  language?: VisualMatchingCreateRequestDtoLanguage;
  optionCount?: number;
  questionCount?: number;
  teacherDocumentId?: number;
  topic?: string;
}

export interface ResponseBodyEmitter {
  timeout?: number;
}

export type TeacherChatSendMessageRequestDtoContentType =
  (typeof TeacherChatSendMessageRequestDtoContentType)[keyof typeof TeacherChatSendMessageRequestDtoContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherChatSendMessageRequestDtoContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export interface TeacherChatSendMessageRequestDto {
  contentType: TeacherChatSendMessageRequestDtoContentType;
  fileName?: string;
  mediaUrl?: string;
  message: string;
  web?: boolean;
}

export interface CreateTeacherChatRequestDto {
  description?: string;
  llmModel?: string;
  title?: string;
}

export interface TeacherToolChatSendMessageRequestDto {
  content: string;
}

export type TeacherToolChatResponseDtoToolType =
  (typeof TeacherToolChatResponseDtoToolType)[keyof typeof TeacherToolChatResponseDtoToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherToolChatResponseDtoToolType = {
  AI_ASSESSMENT_SCALE: "AI_ASSESSMENT_SCALE",
  AI_ASSIGNMENT: "AI_ASSIGNMENT",
  AI_RESISTANT_HOMEWORK: "AI_RESISTANT_HOMEWORK",
  AI_SUPPORTED_TASKS: "AI_SUPPORTED_TASKS",
  BLOOMS_TAXONOMY_ACTIVITIES: "BLOOMS_TAXONOMY_ACTIVITIES",
  CHOICE_BOARD: "CHOICE_BOARD",
  CLASSROOM_MANAGEMENT: "CLASSROOM_MANAGEMENT",
  COLLABORATIVE_GROUP_WORK: "COLLABORATIVE_GROUP_WORK",
  COMMON_MISCONCEPTION: "COMMON_MISCONCEPTION",
  CONCEPTUAL_UNDERSTANDING: "CONCEPTUAL_UNDERSTANDING",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  EXIT_TICKET_GENERATOR: "EXIT_TICKET_GENERATOR",
  FORMATIVE_ASSESSMENT: "FORMATIVE_ASSESSMENT",
  HOMEWORK_IDEA: "HOMEWORK_IDEA",
  IMAGE_GENERATOR: "IMAGE_GENERATOR",
  LESSON_HOOK: "LESSON_HOOK",
  MINDMAP_GENERATOR: "MINDMAP_GENERATOR",
  PERFORMANCE_TASK: "PERFORMANCE_TASK",
  PODCAST: "PODCAST",
  PROJECT_BASED_LEARNING: "PROJECT_BASED_LEARNING",
  REAL_WORLD_CONNECTION: "REAL_WORLD_CONNECTION",
  RUBRIC_GENERATOR: "RUBRIC_GENERATOR",
  SUMMARIZER: "SUMMARIZER",
  TEXT_LEVELER: "TEXT_LEVELER",
  TRANSFER_ACTIVITY: "TRANSFER_ACTIVITY",
  UDL_CHOICE_BOARD: "UDL_CHOICE_BOARD",
  VOCABULARY_LIST: "VOCABULARY_LIST",
  HEYGEN_AVATAR: "HEYGEN_AVATAR",
  ARTICLE_GENERATOR: "ARTICLE_GENERATOR",
  SKETCH_GENERATOR: "SKETCH_GENERATOR",
} as const;

export interface TeacherToolChatResponseDto {
  createdAt?: string;
  id?: number;
  messages?: TeacherToolChatMessageResponseDto[];
  teacherToolId?: number;
  toolType?: TeacherToolChatResponseDtoToolType;
}

export type TeacherToolChatMessageResponseDtoRole =
  (typeof TeacherToolChatMessageResponseDtoRole)[keyof typeof TeacherToolChatMessageResponseDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherToolChatMessageResponseDtoRole = {
  AI: "AI",
  USER: "USER",
} as const;

export type TeacherToolChatMessageResponseDtoResponseType =
  (typeof TeacherToolChatMessageResponseDtoResponseType)[keyof typeof TeacherToolChatMessageResponseDtoResponseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherToolChatMessageResponseDtoResponseType = {
  NORMAL: "NORMAL",
  REGEN_TOOL: "REGEN_TOOL",
  FAILURE: "FAILURE",
} as const;

export interface TeacherToolChatMessageResponseDto {
  content?: string;
  createdAt?: string;
  id?: number;
  responseType?: TeacherToolChatMessageResponseDtoResponseType;
  role?: TeacherToolChatMessageResponseDtoRole;
}

export type CreateTeacherToolChatRequestDtoToolType =
  (typeof CreateTeacherToolChatRequestDtoToolType)[keyof typeof CreateTeacherToolChatRequestDtoToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTeacherToolChatRequestDtoToolType = {
  AI_ASSESSMENT_SCALE: "AI_ASSESSMENT_SCALE",
  AI_ASSIGNMENT: "AI_ASSIGNMENT",
  AI_RESISTANT_HOMEWORK: "AI_RESISTANT_HOMEWORK",
  AI_SUPPORTED_TASKS: "AI_SUPPORTED_TASKS",
  BLOOMS_TAXONOMY_ACTIVITIES: "BLOOMS_TAXONOMY_ACTIVITIES",
  CHOICE_BOARD: "CHOICE_BOARD",
  CLASSROOM_MANAGEMENT: "CLASSROOM_MANAGEMENT",
  COLLABORATIVE_GROUP_WORK: "COLLABORATIVE_GROUP_WORK",
  COMMON_MISCONCEPTION: "COMMON_MISCONCEPTION",
  CONCEPTUAL_UNDERSTANDING: "CONCEPTUAL_UNDERSTANDING",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  EXIT_TICKET_GENERATOR: "EXIT_TICKET_GENERATOR",
  FORMATIVE_ASSESSMENT: "FORMATIVE_ASSESSMENT",
  HOMEWORK_IDEA: "HOMEWORK_IDEA",
  IMAGE_GENERATOR: "IMAGE_GENERATOR",
  LESSON_HOOK: "LESSON_HOOK",
  MINDMAP_GENERATOR: "MINDMAP_GENERATOR",
  PERFORMANCE_TASK: "PERFORMANCE_TASK",
  PODCAST: "PODCAST",
  PROJECT_BASED_LEARNING: "PROJECT_BASED_LEARNING",
  REAL_WORLD_CONNECTION: "REAL_WORLD_CONNECTION",
  RUBRIC_GENERATOR: "RUBRIC_GENERATOR",
  SUMMARIZER: "SUMMARIZER",
  TEXT_LEVELER: "TEXT_LEVELER",
  TRANSFER_ACTIVITY: "TRANSFER_ACTIVITY",
  UDL_CHOICE_BOARD: "UDL_CHOICE_BOARD",
  VOCABULARY_LIST: "VOCABULARY_LIST",
  HEYGEN_AVATAR: "HEYGEN_AVATAR",
  ARTICLE_GENERATOR: "ARTICLE_GENERATOR",
  SKETCH_GENERATOR: "SKETCH_GENERATOR",
} as const;

export interface CreateTeacherToolChatRequestDto {
  teacherToolId: number;
  toolType: CreateTeacherToolChatRequestDtoToolType;
}

export interface SuperToolResponseDto {
  assessmentScaleId?: number;
  bloomsTaxonomyActivitiesId?: number;
  choiceBoardId?: number;
  collaborativeGroupWorkId?: number;
  commonMisconceptionId?: number;
  conceptualUnderstandingId?: number;
  description?: string;
  essentialQuestionsId?: number;
  exitTicketGeneratorId?: number;
  formativeAssessmentId?: number;
  homeworkIdeaId?: number;
  id?: number;
  imageUrl?: string;
  isApproved?: boolean;
  isPublic?: boolean;
  language?: string;
  lessonHookId?: number;
  ownerId?: number;
  performanceTaskId?: number;
  podcastId?: number;
  projectBasedLearningId?: number;
  realWorldConnectionId?: number;
  resistantHomeworkId?: number;
  supportedTasksId?: number;
  title?: string;
  transferActivityId?: number;
  videoUrl?: string;
  vocabularyListId?: number;
}

export type SuperToolCreateRequestDtoGenerationType =
  (typeof SuperToolCreateRequestDtoGenerationType)[keyof typeof SuperToolCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperToolCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type SuperToolCreateRequestDtoCourseName =
  (typeof SuperToolCreateRequestDtoCourseName)[keyof typeof SuperToolCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperToolCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type SuperToolCreateRequestDtoContentLanguage =
  (typeof SuperToolCreateRequestDtoContentLanguage)[keyof typeof SuperToolCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuperToolCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface SuperToolCreateRequestDto {
  contentLanguage?: SuperToolCreateRequestDtoContentLanguage;
  courseName: SuperToolCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: SuperToolCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type CreateSpecialHomeworkAssignmentRequestBodyContentLanguage =
  (typeof CreateSpecialHomeworkAssignmentRequestBodyContentLanguage)[keyof typeof CreateSpecialHomeworkAssignmentRequestBodyContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSpecialHomeworkAssignmentRequestBodyContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type CreateSpecialHomeworkAssignmentRequestBodyAssignmentDifficulty =
  (typeof CreateSpecialHomeworkAssignmentRequestBodyAssignmentDifficulty)[keyof typeof CreateSpecialHomeworkAssignmentRequestBodyAssignmentDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSpecialHomeworkAssignmentRequestBodyAssignmentDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface CreateSpecialHomeworkAssignmentRequestBody {
  assignmentDifficulty: CreateSpecialHomeworkAssignmentRequestBodyAssignmentDifficulty;
  basedOnAssignmentId: number;
  basedOnStudentId?: number;
  contentLanguage?: CreateSpecialHomeworkAssignmentRequestBodyContentLanguage;
  description?: string;
  endDate?: string;
  environment?: string;
  name?: string;
  questionStyle?: string;
  questionTypes: QuestionProps[];
  startDate?: string;
}

export type CreateHomeworkAssignmentRequestBodyGenerator =
  (typeof CreateHomeworkAssignmentRequestBodyGenerator)[keyof typeof CreateHomeworkAssignmentRequestBodyGenerator];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateHomeworkAssignmentRequestBodyGenerator = {
  PROMPT: "PROMPT",
  TOPIC_LIST: "TOPIC_LIST",
  DRIVE_FILE: "DRIVE_FILE",
  SPECIAL_PROMPT: "SPECIAL_PROMPT",
  YOUTUBE_LINK: "YOUTUBE_LINK",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
} as const;

export type CreateHomeworkAssignmentRequestBodyCourseType =
  (typeof CreateHomeworkAssignmentRequestBodyCourseType)[keyof typeof CreateHomeworkAssignmentRequestBodyCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateHomeworkAssignmentRequestBodyCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type CreateHomeworkAssignmentRequestBodyContentLanguage =
  (typeof CreateHomeworkAssignmentRequestBodyContentLanguage)[keyof typeof CreateHomeworkAssignmentRequestBodyContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateHomeworkAssignmentRequestBodyContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type CreateHomeworkAssignmentRequestBodyAssignmentDifficulty =
  (typeof CreateHomeworkAssignmentRequestBodyAssignmentDifficulty)[keyof typeof CreateHomeworkAssignmentRequestBodyAssignmentDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateHomeworkAssignmentRequestBodyAssignmentDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface CreateHomeworkAssignmentRequestBody {
  assignmentDifficulty: CreateHomeworkAssignmentRequestBodyAssignmentDifficulty;
  contentLanguage?: CreateHomeworkAssignmentRequestBodyContentLanguage;
  courseType: CreateHomeworkAssignmentRequestBodyCourseType;
  description?: string;
  driveFileIds?: string[];
  endDate?: string;
  environment?: string;
  generator: CreateHomeworkAssignmentRequestBodyGenerator;
  grade: number;
  learningOutcomeIds?: number[];
  maarifLearningOutcomeIds?: number[];
  name?: string;
  prompt?: string;
  questionStyle?: string;
  questionTypes: QuestionProps[];
  shouldStudentsSeeAnswersBeforeEndDateAfterFinish?: boolean;
  startDate?: string;
  teacherDocumentIds?: number[];
  topicIds?: number[];
  youtubeLink?: string;
}

export type QuestionPropsQuestionType =
  (typeof QuestionPropsQuestionType)[keyof typeof QuestionPropsQuestionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionPropsQuestionType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export type QuestionPropsDifficulty =
  (typeof QuestionPropsDifficulty)[keyof typeof QuestionPropsDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionPropsDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface QuestionProps {
  /**
   * @minimum 0
   * @maximum 20
   */
  count?: number;
  difficulty?: QuestionPropsDifficulty;
  /**
   * @minimum 0
   * @maximum 20
   */
  point?: number;
  questionType?: QuestionPropsQuestionType;
}

export type CreateQuizAssignmentRequestBodyGenerator =
  (typeof CreateQuizAssignmentRequestBodyGenerator)[keyof typeof CreateQuizAssignmentRequestBodyGenerator];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuizAssignmentRequestBodyGenerator = {
  PROMPT: "PROMPT",
  TOPIC_LIST: "TOPIC_LIST",
  DRIVE_FILE: "DRIVE_FILE",
  SPECIAL_PROMPT: "SPECIAL_PROMPT",
  YOUTUBE_LINK: "YOUTUBE_LINK",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
} as const;

export type CreateQuizAssignmentRequestBodyCourseType =
  (typeof CreateQuizAssignmentRequestBodyCourseType)[keyof typeof CreateQuizAssignmentRequestBodyCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuizAssignmentRequestBodyCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type CreateQuizAssignmentRequestBodyContentLanguage =
  (typeof CreateQuizAssignmentRequestBodyContentLanguage)[keyof typeof CreateQuizAssignmentRequestBodyContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuizAssignmentRequestBodyContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type CreateQuizAssignmentRequestBodyAssignmentDifficulty =
  (typeof CreateQuizAssignmentRequestBodyAssignmentDifficulty)[keyof typeof CreateQuizAssignmentRequestBodyAssignmentDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuizAssignmentRequestBodyAssignmentDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface CreateQuizAssignmentRequestBody {
  assignmentDifficulty: CreateQuizAssignmentRequestBodyAssignmentDifficulty;
  canStudentsGoBackBetweenQuestions?: boolean;
  contentLanguage?: CreateQuizAssignmentRequestBodyContentLanguage;
  courseType: CreateQuizAssignmentRequestBodyCourseType;
  description?: string;
  driveFileIds?: string[];
  /** @minimum 1 */
  duration?: number;
  generator: CreateQuizAssignmentRequestBodyGenerator;
  grade: number;
  learningOutcomeIds?: number[];
  maarifLearningOutcomeIds?: number[];
  name?: string;
  prompt?: string;
  questionStyle?: string;
  questionTypes: QuestionProps[];
  shouldStudentsSeeAnswersAutomaticallyAfterFinish?: boolean;
  teacherDocumentIds?: number[];
  topicIds?: number[];
  youtubeLink?: string;
}

export interface GradeFinishedStudentsOpenEndedAnswersRequestBody {
  feedback?: string;
  questionId?: number;
  score?: number;
  studentId?: number;
}

export interface GradeQuestionAnswerRequestBodyDto {
  questionId: number;
  /** @minimum 0 */
  score: number;
}

export interface AssignAssignmentRequestBodyNew {
  endDate?: string;
  items?: AssignAssignmentRequestBodyNewItem[];
  startDate?: string;
}

export type TedLessonPlannerInputMaterialsToolType =
  (typeof TedLessonPlannerInputMaterialsToolType)[keyof typeof TedLessonPlannerInputMaterialsToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TedLessonPlannerInputMaterialsToolType = {
  AI_ASSESSMENT_SCALE: "AI_ASSESSMENT_SCALE",
  AI_ASSIGNMENT: "AI_ASSIGNMENT",
  AI_RESISTANT_HOMEWORK: "AI_RESISTANT_HOMEWORK",
  AI_SUPPORTED_TASKS: "AI_SUPPORTED_TASKS",
  BLOOMS_TAXONOMY_ACTIVITIES: "BLOOMS_TAXONOMY_ACTIVITIES",
  CHOICE_BOARD: "CHOICE_BOARD",
  CLASSROOM_MANAGEMENT: "CLASSROOM_MANAGEMENT",
  COLLABORATIVE_GROUP_WORK: "COLLABORATIVE_GROUP_WORK",
  COMMON_MISCONCEPTION: "COMMON_MISCONCEPTION",
  CONCEPTUAL_UNDERSTANDING: "CONCEPTUAL_UNDERSTANDING",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  EXIT_TICKET_GENERATOR: "EXIT_TICKET_GENERATOR",
  FORMATIVE_ASSESSMENT: "FORMATIVE_ASSESSMENT",
  HOMEWORK_IDEA: "HOMEWORK_IDEA",
  IMAGE_GENERATOR: "IMAGE_GENERATOR",
  LESSON_HOOK: "LESSON_HOOK",
  MINDMAP_GENERATOR: "MINDMAP_GENERATOR",
  PERFORMANCE_TASK: "PERFORMANCE_TASK",
  PODCAST: "PODCAST",
  PROJECT_BASED_LEARNING: "PROJECT_BASED_LEARNING",
  REAL_WORLD_CONNECTION: "REAL_WORLD_CONNECTION",
  RUBRIC_GENERATOR: "RUBRIC_GENERATOR",
  SUMMARIZER: "SUMMARIZER",
  TEXT_LEVELER: "TEXT_LEVELER",
  TRANSFER_ACTIVITY: "TRANSFER_ACTIVITY",
  UDL_CHOICE_BOARD: "UDL_CHOICE_BOARD",
  VOCABULARY_LIST: "VOCABULARY_LIST",
  HEYGEN_AVATAR: "HEYGEN_AVATAR",
  ARTICLE_GENERATOR: "ARTICLE_GENERATOR",
  SKETCH_GENERATOR: "SKETCH_GENERATOR",
} as const;

export interface TedLessonPlannerInputMaterials {
  id?: number;
  toolType?: TedLessonPlannerInputMaterialsToolType;
}

export type TedLessonPlannerCreateRequestDtoCourseName =
  (typeof TedLessonPlannerCreateRequestDtoCourseName)[keyof typeof TedLessonPlannerCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TedLessonPlannerCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface TedLessonPlannerCreateRequestDto {
  additionalMaterials?: TedLessonPlannerInputMaterials[];
  courseName?: TedLessonPlannerCreateRequestDtoCourseName;
  grade?: number;
  maarifLearningOutcomeIds?: number[];
}

export interface TedYearlyLessonPlannerWebhookRequestDto {
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  name?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
}

export type TedYearlyLessonPlannerCreateRequestDtoCourseName =
  (typeof TedYearlyLessonPlannerCreateRequestDtoCourseName)[keyof typeof TedYearlyLessonPlannerCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TedYearlyLessonPlannerCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface TedYearlyLessonPlannerCreateRequestDto {
  courseName?: TedYearlyLessonPlannerCreateRequestDtoCourseName;
  grade?: number;
  maarifLearningOutcomeIds?: number[];
}

export type TextLevelerCreateRequestDtoGenerationType =
  (typeof TextLevelerCreateRequestDtoGenerationType)[keyof typeof TextLevelerCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextLevelerCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type TextLevelerCreateRequestDtoContentLanguage =
  (typeof TextLevelerCreateRequestDtoContentLanguage)[keyof typeof TextLevelerCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextLevelerCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type TextLevelerCreateRequestDtoCefrLevel =
  (typeof TextLevelerCreateRequestDtoCefrLevel)[keyof typeof TextLevelerCreateRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextLevelerCreateRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface TextLevelerCreateRequestDto {
  cefrLevel?: TextLevelerCreateRequestDtoCefrLevel;
  contentLanguage?: TextLevelerCreateRequestDtoContentLanguage;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: TextLevelerCreateRequestDtoGenerationType;
  grade?: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type TransferActivityCreateRequestDtoGenerationType =
  (typeof TransferActivityCreateRequestDtoGenerationType)[keyof typeof TransferActivityCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferActivityCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type TransferActivityCreateRequestDtoCourseName =
  (typeof TransferActivityCreateRequestDtoCourseName)[keyof typeof TransferActivityCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferActivityCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type TransferActivityCreateRequestDtoContentLanguage =
  (typeof TransferActivityCreateRequestDtoContentLanguage)[keyof typeof TransferActivityCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferActivityCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface TransferActivityCreateRequestDto {
  additionalInfo?: string;
  contentLanguage?: TransferActivityCreateRequestDtoContentLanguage;
  courseName: TransferActivityCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: TransferActivityCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export interface SynthesizeChirpRequestBody {
  lang?: string;
  outputFormat?: string;
  text?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  voice?: string;
}

export type CreateUbdExpertPlannerRequestDtoLanguage =
  (typeof CreateUbdExpertPlannerRequestDtoLanguage)[keyof typeof CreateUbdExpertPlannerRequestDtoLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateUbdExpertPlannerRequestDtoLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type CreateUbdExpertPlannerRequestDtoCourseType =
  (typeof CreateUbdExpertPlannerRequestDtoCourseType)[keyof typeof CreateUbdExpertPlannerRequestDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateUbdExpertPlannerRequestDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface CreateUbdExpertPlannerRequestDto {
  courseType: CreateUbdExpertPlannerRequestDtoCourseType;
  grade: number;
  language?: CreateUbdExpertPlannerRequestDtoLanguage;
  standardsText?: string;
  topic?: string;
}

export type GenerateUbdGoalsRequestDtoCourseType =
  (typeof GenerateUbdGoalsRequestDtoCourseType)[keyof typeof GenerateUbdGoalsRequestDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateUbdGoalsRequestDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface GenerateUbdGoalsRequestDto {
  courseType?: GenerateUbdGoalsRequestDtoCourseType;
  duration?: number;
  environment?: string;
  grade?: number;
  learningOutcomeIds?: number[];
  /** @minimum 1 */
  lessonCount?: number;
}

export type UdlChoiceBoardCreateRequestDtoGenerationType =
  (typeof UdlChoiceBoardCreateRequestDtoGenerationType)[keyof typeof UdlChoiceBoardCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UdlChoiceBoardCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type UdlChoiceBoardCreateRequestDtoCourseName =
  (typeof UdlChoiceBoardCreateRequestDtoCourseName)[keyof typeof UdlChoiceBoardCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UdlChoiceBoardCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type UdlChoiceBoardCreateRequestDtoContentLanguage =
  (typeof UdlChoiceBoardCreateRequestDtoContentLanguage)[keyof typeof UdlChoiceBoardCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UdlChoiceBoardCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface UdlChoiceBoardCreateRequestDto {
  additionalInfo?: string;
  contentLanguage?: UdlChoiceBoardCreateRequestDtoContentLanguage;
  courseName: UdlChoiceBoardCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: UdlChoiceBoardCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export interface FirebaseLoginResponseDto {
  customToken?: string;
}

export interface AuthFirebaseLoginRequestBodyDto {
  language?: string;
  name?: string;
  organizationId?: number;
  surname?: string;
  token: string;
  userType: string;
}

export type VideoAvatarCreateRequestDtoGenerationType =
  (typeof VideoAvatarCreateRequestDtoGenerationType)[keyof typeof VideoAvatarCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoAvatarCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type VideoAvatarCreateRequestDtoCourseName =
  (typeof VideoAvatarCreateRequestDtoCourseName)[keyof typeof VideoAvatarCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoAvatarCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type VideoAvatarCreateRequestDtoContentLanguage =
  (typeof VideoAvatarCreateRequestDtoContentLanguage)[keyof typeof VideoAvatarCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoAvatarCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface VideoAvatarCreateRequestDto {
  captionEnabled?: boolean;
  contentLanguage?: VideoAvatarCreateRequestDtoContentLanguage;
  courseName: VideoAvatarCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: VideoAvatarCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  requestAvatar?: VideoAvatarAvailableFacesResponseDto;
  teacherDocumentIds?: number[];
}

export interface RegenTeacherToolRequestBody {
  changePrompt: string;
  regenChatId?: number;
}

export type VocabularyListCreateRequestDtoGenerationType =
  (typeof VocabularyListCreateRequestDtoGenerationType)[keyof typeof VocabularyListCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabularyListCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type VocabularyListCreateRequestDtoCourseName =
  (typeof VocabularyListCreateRequestDtoCourseName)[keyof typeof VocabularyListCreateRequestDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabularyListCreateRequestDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type VocabularyListCreateRequestDtoContentLanguage =
  (typeof VocabularyListCreateRequestDtoContentLanguage)[keyof typeof VocabularyListCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabularyListCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type VocabularyListCreateRequestDtoCefrLevel =
  (typeof VocabularyListCreateRequestDtoCefrLevel)[keyof typeof VocabularyListCreateRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabularyListCreateRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface VocabularyListCreateRequestDto {
  cefrLevel?: VocabularyListCreateRequestDtoCefrLevel;
  contentLanguage?: VocabularyListCreateRequestDtoContentLanguage;
  courseName: VocabularyListCreateRequestDtoCourseName;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: VocabularyListCreateRequestDtoGenerationType;
  gradeLevel: number;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt?: string;
  teacherDocumentIds?: number[];
}

export type CreateEssayGraderChatMessageRequestBodyDtoSender =
  (typeof CreateEssayGraderChatMessageRequestBodyDtoSender)[keyof typeof CreateEssayGraderChatMessageRequestBodyDtoSender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateEssayGraderChatMessageRequestBodyDtoSender = {
  AI: "AI",
  USER: "USER",
} as const;

export type CreateEssayGraderChatMessageRequestBodyDtoMessageContentType =
  (typeof CreateEssayGraderChatMessageRequestBodyDtoMessageContentType)[keyof typeof CreateEssayGraderChatMessageRequestBodyDtoMessageContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateEssayGraderChatMessageRequestBodyDtoMessageContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export interface CreateEssayGraderChatMessageRequestBodyDto {
  followups?: string[];
  isPredefined?: boolean;
  mediaBucketUrl?: string;
  mediaPublicUrl?: string;
  message: string;
  messageContentType?: CreateEssayGraderChatMessageRequestBodyDtoMessageContentType;
  processedMessage?: string;
  sender?: CreateEssayGraderChatMessageRequestBodyDtoSender;
}

export interface QuestionHelperWebhookRequestDto {
  errorMessage?: string;
  steps?: QuestionStep[];
  title?: string;
}

export type SpokenDialogueWebhookRequestDtoLanguage =
  (typeof SpokenDialogueWebhookRequestDtoLanguage)[keyof typeof SpokenDialogueWebhookRequestDtoLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpokenDialogueWebhookRequestDtoLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type SpokenDialogueWebhookRequestDtoCefrLevel =
  (typeof SpokenDialogueWebhookRequestDtoCefrLevel)[keyof typeof SpokenDialogueWebhookRequestDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpokenDialogueWebhookRequestDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface SpokenDialogueWebhookRequestDto {
  actionName?: string;
  assessment_rubric?: JsonNode;
  cefrLevel?: SpokenDialogueWebhookRequestDtoCefrLevel;
  description?: string;
  dialogue_script?: JsonNode;
  durationTurns?: number;
  imagePrompt?: string;
  imageUrl?: string;
  inputTokenCount?: number;
  lambda_input?: JsonNode;
  lambda_output?: JsonNode;
  language?: SpokenDialogueWebhookRequestDtoLanguage;
  livekitPrompt?: string;
  outputTokenCount?: number;
  public_code?: string;
  scenario?: string;
  title?: string;
}

export interface VisualMatchingWebhookRequestDto {
  actionName?: string;
  description?: string;
  inputTokenCount?: number;
  main_topic?: string;
  outputTokenCount?: number;
  questions?: VisualMatchingQuestion[];
  title?: string;
}

export type TeacherChatSendMessageWebhookRequestDtoGroundingMetadata = {
  [key: string]: ChatMessageGroundingData;
};

export interface TeacherChatSendMessageWebhookRequestDto {
  groundingMetadata?: TeacherChatSendMessageWebhookRequestDtoGroundingMetadata;
  groundingSegments?: ChatMessageGroundingSupportData[];
  message?: string;
}

export interface TeacherChatUpdateTitleWebhookRequestDto {
  title?: string;
}

export type TeacherToolChatSendMessageWebhookRequestDtoResponseType =
  (typeof TeacherToolChatSendMessageWebhookRequestDtoResponseType)[keyof typeof TeacherToolChatSendMessageWebhookRequestDtoResponseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherToolChatSendMessageWebhookRequestDtoResponseType = {
  NORMAL: "NORMAL",
  REGEN_TOOL: "REGEN_TOOL",
  FAILURE: "FAILURE",
} as const;

export interface TeacherToolChatSendMessageWebhookRequestDto {
  content?: string;
  responseType?: TeacherToolChatSendMessageWebhookRequestDtoResponseType;
}

export interface SynthesizeRequestBody {
  text?: string;
}

export interface AiAssessmentScaleUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  levels?: AssessmentLevel[];
  title?: string;
}

export interface AiAssignmentUpdateRequestDto {
  aiPromptExamples?: string[];
  description?: string;
  gradingRubric?: AiAssignmentGradingRubricItem[];
  implementationSteps?: string[];
  isPublic?: boolean;
  reflectionQuestions?: string[];
  studentInstructions?: string;
  title?: string;
}

export interface AiResistantHomeworkUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  reportIdeas?: AiResistantHomeworkReportIdea[];
  title?: string;
}

export interface AiSupportedTasksUpdateRequestDto {
  assessmentRubric?: AiSupportedTaskRubricCriteria[];
  benefits?: string[];
  description?: string;
  expectedOutput?: AiSupportedTaskExpectedOutput;
  isPublic?: boolean;
  learningObjectives?: string[];
  notes?: AiSupportedTaskNotes;
  recommendedAiPlatform?: AiSupportedTaskAiPlatform;
  researchProcessDescription?: string;
  steps?: AiSupportedTaskStep[];
  title?: string;
}

export interface AnonymousResponseDto {
  grade?: number;
  id: number;
  name: string;
  surname: string;
}

export interface UpdateAnonymousUserMeBodyDto {
  grade?: number;
  name?: string;
  preferences?: UserPreferences;
  surname?: string;
}

export interface ArticleGeneratorUpdateRequestDto {
  articleContentJson?: JsonNode;
  description?: string;
  isPublic?: boolean;
  title?: string;
}

export interface UpdateBlogRequestBodyDto {
  author?: string;
  contentEn?: string;
  contentTr?: string;
  coverPhotoUrl?: string;
  tags?: string[];
  titleEn?: string;
  titleTr?: string;
  voiceEnUrl?: string;
  voiceTrUrl?: string;
}

export interface BloomsTaxonomyActivitiesUpdateRequestDto {
  activities?: BloomsTaxonomyActivitiesActivityItem[];
  description?: string;
  implementationNotes?: string[];
  isPublic?: boolean;
  title?: string;
}

export type UpdateChatMessageSuggestionResponseDtoCourseType =
  (typeof UpdateChatMessageSuggestionResponseDtoCourseType)[keyof typeof UpdateChatMessageSuggestionResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateChatMessageSuggestionResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface UpdateChatMessageSuggestionResponseDto {
  courseType?: UpdateChatMessageSuggestionResponseDtoCourseType;
  grade?: number;
  id?: number;
  message?: string;
  title?: string;
  topic?: string;
}

export type UpdateChatMessageSuggestionRequestBodyDtoCourse =
  (typeof UpdateChatMessageSuggestionRequestBodyDtoCourse)[keyof typeof UpdateChatMessageSuggestionRequestBodyDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateChatMessageSuggestionRequestBodyDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface UpdateChatMessageSuggestionRequestBodyDto {
  course?: UpdateChatMessageSuggestionRequestBodyDtoCourse;
  grade?: number;
  message?: string;
  title?: string;
  topic?: string;
}

export type UpdateChatHistoryRequestBodyDtoImages = {
  [key: string]: ImagesPart;
};

export interface LatestChatPart {
  db_llm_response?: string;
  db_user_message?: string;
  execution_times?: JsonNode;
  input_token_count?: JsonNode;
  output_token_count?: JsonNode;
  prompt_version?: number;
  ui_llm_response?: string;
  ui_user_message?: string;
}

export interface UpdateChatHistoryRequestBodyDto {
  history?: LatestChatPart;
  images?: UpdateChatHistoryRequestBodyDtoImages;
}

export interface LikeOrDislikeMessageRequestBodyDto {
  score?: number;
}

export type UpdateChatMessageRequestBodyDtoMessageContentType =
  (typeof UpdateChatMessageRequestBodyDtoMessageContentType)[keyof typeof UpdateChatMessageRequestBodyDtoMessageContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateChatMessageRequestBodyDtoMessageContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export interface MessageChunkInfo {
  collection_name?: string;
  point_id?: string;
  topic?: string;
}

export interface UpdateChatMessageRequestBodyDto {
  chunksInfo?: MessageChunkInfo[];
  classification?: string;
  failureReason?: string;
  followups?: string[];
  mathResponses?: JsonNode;
  mediaBucketUrl?: string;
  mediaPublicUrl?: string;
  message?: string;
  messageContentType?: UpdateChatMessageRequestBodyDtoMessageContentType;
  processedMessage?: string;
  superTopics?: string[];
  topics?: string[];
}

export interface RenameChatRequestBodyDto {
  name: string;
}

export interface ChoiceBoardUpdateRequestDto {
  activities?: ActivityItem[];
  choiceBoardInstructions?: string;
  description?: string;
  isPublic?: boolean;
  title?: string;
}

export interface ClassroomManagementUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  strategies?: ClassroomManagementItem[];
  title?: string;
}

export interface CollaborativeGroupWorkUpdateRequestDto {
  description?: string;
  groupRoles?: GroupRolesItem[];
  isPublic?: boolean;
  peerEvaluationQuestions?: PeerEvaluationQuestionItem[];
  processEvaluationCriteria?: ProcessEvaluationCriteriaItem[];
  processSteps?: ProcessStepItem[];
  reflectionQuestions?: ReflectionQuestionItem[];
  teacherEvaluationQuestions?: TeacherEvaluationQuestionItem[];
  teacherRoleDescription?: string;
  title?: string;
}

export interface CommonMisconceptionUpdateRequestDto {
  assessmentStrategies?: AssessmentStrategies;
  description?: string;
  isPublic?: boolean;
  misconceptions?: MisconceptionItem[];
  title?: string;
}

export interface ConceptualUnderstandingUpdateRequestDto {
  conceptualActivities?: ConceptualActivitiesItem[];
  description?: string;
  isPublic?: boolean;
  title?: string;
}

export type EssayAssignmentResponseDtoStatus =
  (typeof EssayAssignmentResponseDtoStatus)[keyof typeof EssayAssignmentResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssayAssignmentResponseDtoStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  CLOSED: "CLOSED",
  GRADING_RELEASED: "GRADING_RELEASED",
} as const;

export type EssayAssignmentResponseDtoGradingStatus =
  (typeof EssayAssignmentResponseDtoGradingStatus)[keyof typeof EssayAssignmentResponseDtoGradingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssayAssignmentResponseDtoGradingStatus = {
  PROCESSING_RUBRIC: "PROCESSING_RUBRIC",
  RUBRIC_FAILED: "RUBRIC_FAILED",
  PROCESSING_ESSAYS: "PROCESSING_ESSAYS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;

export interface EssayAssignmentResponseDto {
  createdAt?: string;
  description?: string;
  dueDate?: string;
  gradedSubmissions?: number;
  gradingStatus?: EssayAssignmentResponseDtoGradingStatus;
  id?: number;
  ownerId?: number;
  pendingSubmissions?: number;
  rubricFile?: TeacherDocumentResponseDto;
  status?: EssayAssignmentResponseDtoStatus;
  studentInstructionFile?: TeacherDocumentResponseDto;
  studentInstructionText?: string;
  submissions?: StudentEssaySubmissionResponseDto[];
  title?: string;
  toleranceLevel?: number;
  totalSubmissions?: number;
}

export interface UpdateEssayAssignmentRequestDto {
  /**
   * @minLength 0
   * @maxLength 5000
   */
  description?: string;
  dueDate?: string;
  /**
   * @minimum 1
   * @maximum 1000
   */
  maxScore?: number;
  studentInstructionFileId?: number;
  /**
   * @minLength 0
   * @maxLength 10000
   */
  studentInstructionText?: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  title?: string;
  /**
   * @minimum 1
   * @maximum 5
   */
  toleranceLevel?: number;
}

export interface GradeUpdateItem {
  feedback?: string;
  /**
   * @minimum 0
   * @maximum 1000
   */
  score?: number;
  submissionId: number;
}

export interface BulkGradeUpdateRequestDto {
  gradeUpdates: GradeUpdateItem[];
}

export interface UpdateSubmissionRequestDto {
  essayFileIds: number[];
}

export type StudentEssaySubmissionResponseDtoStatus =
  (typeof StudentEssaySubmissionResponseDtoStatus)[keyof typeof StudentEssaySubmissionResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentEssaySubmissionResponseDtoStatus = {
  NOT_SUBMITTED: "NOT_SUBMITTED",
  SUBMITTED: "SUBMITTED",
  GRADED: "GRADED",
  GRADE_VISIBLE: "GRADE_VISIBLE",
} as const;

export interface StudentEssaySubmissionResponseDto {
  createdAt?: string;
  dueDate?: string;
  essayAssignmentId?: number;
  essayAssignmentTitle?: string;
  essayFiles?: TeacherDocumentResponseDto[];
  feedback?: string;
  gradeVisibleAt?: string;
  id?: number;
  isGradeVisible?: boolean;
  maxScore?: number;
  score?: number;
  status?: StudentEssaySubmissionResponseDtoStatus;
  studentEssayResult?: NewEssayEvaluationResult;
  studentId?: number;
  studentInstructionFile?: TeacherDocumentResponseDto;
  studentInstructionText?: string;
  studentName?: string;
  submittedAt?: string;
}

export interface UpdateGradeRequestDto {
  feedback?: string;
  /**
   * @minimum 0
   * @maximum 1000
   */
  score?: number;
}

export interface EssentialQuestionsUpdateRequestDto {
  activitySuggestions?: ActivitySuggestionItem[];
  description?: string;
  isPublic?: boolean;
  questions?: string[];
  title?: string;
}

export interface ExitTicketGeneratorUpdateRequestDto {
  complexity?: string;
  description?: string;
  exitTickets?: ExitTicketItem[];
  isPublic?: boolean;
  purpose?: string;
  title?: string;
}

export interface MoveNodesDto {
  fileNodeIds: number[];
  newParentId: number;
}

export interface FormativeAssessmentUpdateRequestDto {
  assessmentTool?: string;
  description?: string;
  isPublic?: boolean;
  process?: string;
  studentReflection?: string;
  teacherFeedback?: string;
  title?: string;
}

export interface CreateForumCommentRequestDto {
  content: string;
}

export interface ForumCommentDto {
  content: string;
  createdAt: string;
  id: number;
  ownerEmail: string;
  ownerName?: string;
  ownerSurname?: string;
}

export interface ForumPostDto {
  comments?: ForumCommentDto[];
  content: string;
  createdAt: string;
  id: number;
  imageUrl?: string;
  ownerEmail: string;
  ownerName?: string;
  ownerSurname?: string;
  tags?: string[];
  title: string;
}

export interface CreateForumPostRequestDto {
  content: string;
  imageUrl?: string;
  tags?: string[];
  title: string;
}

export interface HomeworkIdeaUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  reportIdeas?: HomeworkIdeaItem[];
  title?: string;
}

export type ImageGeneratorCreateRequestDtoImageType =
  (typeof ImageGeneratorCreateRequestDtoImageType)[keyof typeof ImageGeneratorCreateRequestDtoImageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageGeneratorCreateRequestDtoImageType = {
  POSTER: "POSTER",
  LOGO: "LOGO",
  INFOGRAPHIC: "INFOGRAPHIC",
  BADGE: "BADGE",
  CERTIFICATE: "CERTIFICATE",
  FLASHCARD: "FLASHCARD",
  SCENE: "SCENE",
  AVATAR: "AVATAR",
  LABEL: "LABEL",
  BANNER: "BANNER",
  DEFAULT: "DEFAULT",
} as const;

export type ImageGeneratorCreateRequestDtoGenerationType =
  (typeof ImageGeneratorCreateRequestDtoGenerationType)[keyof typeof ImageGeneratorCreateRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageGeneratorCreateRequestDtoGenerationType = {
  PROMPT: "PROMPT",
  TOPIC_SELECTION: "TOPIC_SELECTION",
  MAARIF_LEARNING_OUTCOME: "MAARIF_LEARNING_OUTCOME",
  LEARNING_OUTCOME: "LEARNING_OUTCOME",
  TEACHER_DOCUMENT: "TEACHER_DOCUMENT",
} as const;

export type ImageGeneratorCreateRequestDtoContentLanguage =
  (typeof ImageGeneratorCreateRequestDtoContentLanguage)[keyof typeof ImageGeneratorCreateRequestDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageGeneratorCreateRequestDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface ImageGeneratorCreateRequestDto {
  aspectRatio?: string;
  contentLanguage?: ImageGeneratorCreateRequestDtoContentLanguage;
  environment?: string;
  fromSuperTool?: boolean;
  generationType?: ImageGeneratorCreateRequestDtoGenerationType;
  imageType?: ImageGeneratorCreateRequestDtoImageType;
  isCreatedFromSuggestion?: boolean;
  isPublic?: boolean;
  learningOutcomeIds?: number[];
  mindmapId?: number;
  prompt: string;
  teacherDocumentIds?: number[];
}

export interface UpdateImageGeneratorRequestDto {
  description?: string;
  images?: GeneratedImageItem[];
  isPublic?: boolean;
  title?: string;
}

export type InteractiveMaterialResponseDtoStatus =
  (typeof InteractiveMaterialResponseDtoStatus)[keyof typeof InteractiveMaterialResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InteractiveMaterialResponseDtoStatus = {
  INITIALIZING: "INITIALIZING",
  FAILED: "FAILED",
  READY: "READY",
  EDITING: "EDITING",
} as const;

export type InteractiveMaterialResponseDtoGeneratorMode =
  (typeof InteractiveMaterialResponseDtoGeneratorMode)[keyof typeof InteractiveMaterialResponseDtoGeneratorMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InteractiveMaterialResponseDtoGeneratorMode = {
  YOUTUBE: "YOUTUBE",
  PDF: "PDF",
  TEXT: "TEXT",
} as const;

export type InteractiveMaterialResponseDtoGeneratedVideoQuestionsItem =
  | FillTheBlankQuestion
  | MatchQuestion
  | OpenEndedQuestion
  | TestQuestion
  | TrueFalseQuestion;

export type InteractiveMaterialResponseDtoGeneratedQuizQuestionsItem =
  | FillTheBlankQuestion
  | MatchQuestion
  | OpenEndedQuestion
  | TestQuestion
  | TrueFalseQuestion;

export type InteractiveMaterialResponseDtoContentLanguage =
  (typeof InteractiveMaterialResponseDtoContentLanguage)[keyof typeof InteractiveMaterialResponseDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InteractiveMaterialResponseDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type InteractiveMaterialResponseDtoCefrLevel =
  (typeof InteractiveMaterialResponseDtoCefrLevel)[keyof typeof InteractiveMaterialResponseDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InteractiveMaterialResponseDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export interface InteractiveMaterialResponseDto {
  captureStudentsFirstAnswersOnly?: boolean;
  cefrLevel?: InteractiveMaterialResponseDtoCefrLevel;
  conceptCards?: ConceptCard[];
  contentJsonS3Url?: string;
  contentLanguage?: InteractiveMaterialResponseDtoContentLanguage;
  createdAt: string;
  description?: string;
  didEdlinkPublished?: boolean;
  dragAndDropItems?: DragTextItem[];
  generatedFlashcards?: InteractiveMaterialFlashcards[];
  generatedQuizQuestions?: InteractiveMaterialResponseDtoGeneratedQuizQuestionsItem[];
  generatedVideoQuestions?: InteractiveMaterialResponseDtoGeneratedVideoQuestionsItem[];
  generatorMode?: InteractiveMaterialResponseDtoGeneratorMode;
  glossaries?: InteractiveMaterialGlossary[];
  id: number;
  pdfUrl?: string;
  slideImageItems?: SlideImageItem[];
  status: InteractiveMaterialResponseDtoStatus;
  summary?: string;
  text?: string;
  textualInfos?: InteractiveMaterialTextualInfo[];
  timestampedContent?: TimestampedContent[];
  title?: string;
  updatedAt: string;
  youtubeDescription?: string;
  youtubeLength?: number;
  youtubeThumbnailUrl?: string;
  youtubeTitle?: string;
  youtubeUrl?: string;
}

export interface EditInteractiveMaterialSpecsRequest {
  captureStudentsFirstAnswersOnly?: boolean;
}

export interface LessonHookUpdateRequestDto {
  description?: string;
  hooks?: HookItem[];
  isPublic?: boolean;
  title?: string;
}

export interface LessonPlannerV2ResponseDtoSection {
  assessment?: LessonPlannerSectionDto;
  closure?: LessonPlannerSectionDto;
  guidedPractice?: LessonPlannerSectionDto;
  independentPractice?: LessonPlannerSectionDto;
  introduction?: LessonPlannerSectionDto;
  presentation?: LessonPlannerSectionDto;
}

export interface SaveLessonPlannerResultRequestDto {
  additionalArrangements?: AdditionalArrangementsDto;
  additionalInstructions?: string;
  sections?: LessonPlannerV2ResponseDtoSection;
}

export type LessonPlannerV2ResponseDtoStatus =
  (typeof LessonPlannerV2ResponseDtoStatus)[keyof typeof LessonPlannerV2ResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonPlannerV2ResponseDtoStatus = {
  PROCESSING: "PROCESSING",
  REGENERATING: "REGENERATING",
  READY: "READY",
  FAILED: "FAILED",
} as const;

export type LessonPlannerV2ResponseDtoPlanType =
  (typeof LessonPlannerV2ResponseDtoPlanType)[keyof typeof LessonPlannerV2ResponseDtoPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonPlannerV2ResponseDtoPlanType = {
  DAILY: "DAILY",
  MAARIF: "MAARIF",
  UBD_MAARIF: "UBD_MAARIF",
  TED: "TED",
  TED_YEARLY: "TED_YEARLY",
  UBD_EXPERT: "UBD_EXPERT",
} as const;

export type LessonPlannerV2ResponseDtoCourseType =
  (typeof LessonPlannerV2ResponseDtoCourseType)[keyof typeof LessonPlannerV2ResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonPlannerV2ResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type LessonPlannerV2ResponseDtoContentLanguage =
  (typeof LessonPlannerV2ResponseDtoContentLanguage)[keyof typeof LessonPlannerV2ResponseDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonPlannerV2ResponseDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface LearningMethodsDto {
  selected?: string[];
  teachingStyle?: number;
}

export interface AdditionalArrangementsDto {
  ai?: string[];
  differentiation?: string[];
  funActivities?: string[];
  technology?: string[];
}

export interface LessonPlannerV2ResponseDto {
  additionalArrangements?: AdditionalArrangementsDto;
  additionalInstructions?: string;
  contentLanguage?: LessonPlannerV2ResponseDtoContentLanguage;
  courseType?: LessonPlannerV2ResponseDtoCourseType;
  grade?: number;
  id?: number;
  learningMethods?: LearningMethodsDto;
  name?: string;
  organizationId?: number;
  planType?: LessonPlannerV2ResponseDtoPlanType;
  result?: SaveLessonPlannerResultRequestDto;
  sections?: LessonPlannerV2ResponseDtoSection;
  status?: LessonPlannerV2ResponseDtoStatus;
  teacherId?: number;
}

export interface UpdateLessonPlannerV2RequestDto {
  name?: string;
}

export interface MindmapGeneratorUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  nodes?: MindmapNode[];
  title?: string;
}

export interface PerformanceTaskUpdateRequestDto {
  description?: string;
  estimatedTime?: string;
  imageUrl?: string;
  isPublic?: boolean;
  materialsNeeded?: string[];
  performanceCriteria?: string[];
  studentInstructions?: string;
  taskDescription?: string;
  teacherNotes?: string;
  title?: string;
}

export type StudentPodcastResponseDtoStatus =
  (typeof StudentPodcastResponseDtoStatus)[keyof typeof StudentPodcastResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentPodcastResponseDtoStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  OVERDUE: "OVERDUE",
} as const;

export interface StudentPodcastResponseDto {
  createdDate: string;
  endDate: string;
  podcastDescription?: string;
  podcastId: number;
  podcastImageUrl?: string;
  podcastSoundUrl?: string;
  podcastTitle?: string;
  podcastVideoUrl?: string;
  startDate: string;
  status: StudentPodcastResponseDtoStatus;
  studentId: number;
  studentListenedAll?: boolean;
  studentListenedDuration?: number;
  studentName: string;
  teacherId: number;
}

export interface FinishStudentPodcastRequestDto {
  listenedAll?: boolean;
  listenedDuration?: number;
}

export interface PodcastUpdateRequestDto {
  changePrompt?: string;
  description?: string;
  firstUserName?: string;
  isPublic?: boolean;
  questions?: JsonNode;
  secondUserName?: string;
  title?: string;
}

export interface ProjectBasedLearningUpdateRequestDto {
  assessment?: AssessmentItem;
  description?: string;
  feedbackPoints?: string[];
  isPublic?: boolean;
  peerSelfAssessment?: PeerSelfAssessmentItem;
  processSteps?: string[];
  projectProblem?: ProjectProblemItem;
  realLifeConnection?: string;
  title?: string;
}

export type QuestionHelperResponseDtoStatus =
  (typeof QuestionHelperResponseDtoStatus)[keyof typeof QuestionHelperResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionHelperResponseDtoStatus = {
  PROCESSING: "PROCESSING",
  REGENERATING: "REGENERATING",
  READY: "READY",
  FAILED: "FAILED",
} as const;

export interface QuestionHelperResponseDto {
  createdAt?: string;
  id?: number;
  imageUrl?: string;
  solutionSteps?: QuestionStep[];
  status?: QuestionHelperResponseDtoStatus;
  tags?: string[];
  title?: string;
  updatedAt?: string;
  userId?: number;
}

export type StepContentType =
  (typeof StepContentType)[keyof typeof StepContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StepContentType = {
  TEXT: "TEXT",
  LATEX_INLINE: "LATEX_INLINE",
  LATEX_BLOCK: "LATEX_BLOCK",
  LIST_ITEM: "LIST_ITEM",
} as const;

export interface StepContent {
  content?: string;
  type?: StepContentType;
}

export interface QuestionStep {
  content?: StepContent[];
  title?: string;
}

export interface QuestionHelperUpdateRequestDto {
  solutionSteps?: QuestionStep[];
  tags?: string[];
  title?: string;
}

export interface ImagesPart {
  alt_text?: string;
  course?: string;
  file_name?: string;
  grade?: string;
  id?: number;
  image_keywords?: string[];
  media_bucket_url?: string;
  media_public_url?: string;
  outcomes?: string;
  summary?: string;
}

export type GetQuestionSolverResponseDtoV2StepsDict = {
  [key: string]: JsonNode;
};

export type GetQuestionSolverResponseDtoV2FinalAnswerDict = {
  [key: string]: string;
};

export type GetQuestionSolverResponseDtoV2ExportUrlDict = {
  [key: string]: string;
};

export type GetQuestionSolverResponseDtoV2Course =
  (typeof GetQuestionSolverResponseDtoV2Course)[keyof typeof GetQuestionSolverResponseDtoV2Course];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetQuestionSolverResponseDtoV2Course = {
  UNKNOWN: "UNKNOWN",
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  PHILOSOPHY: "PHILOSOPHY",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetQuestionSolverResponseDtoV2AudioUrlDict = {
  [key: string]: string;
};

export interface GetQuestionSolverResponseDtoV2 {
  audioUrlDict?: GetQuestionSolverResponseDtoV2AudioUrlDict;
  chat?: GetChatResponseDto;
  config?: JsonNode;
  course?: GetQuestionSolverResponseDtoV2Course;
  createdAt?: string;
  exportUrlDict?: GetQuestionSolverResponseDtoV2ExportUrlDict;
  fileNodeId?: number;
  finalAnswerDict?: GetQuestionSolverResponseDtoV2FinalAnswerDict;
  flashcards?: FlashcardItem[];
  id?: number;
  name?: string;
  retryCount?: number;
  stepsDict?: GetQuestionSolverResponseDtoV2StepsDict;
  uri?: string;
  userId?: number;
}

export type GetChatResponseDtoTopics = { [key: string]: number };

export type GetChatResponseDtoCourse =
  (typeof GetChatResponseDtoCourse)[keyof typeof GetChatResponseDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChatResponseDtoCourse = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type GetChatResponseDtoChatType =
  (typeof GetChatResponseDtoChatType)[keyof typeof GetChatResponseDtoChatType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChatResponseDtoChatType = {
  DIDACTIC: "DIDACTIC",
  CHAT: "CHAT",
} as const;

export interface GetChatResponseDto {
  chatType?: GetChatResponseDtoChatType;
  config?: JsonNode;
  course?: GetChatResponseDtoCourse;
  createdAt?: string;
  description?: string;
  grade?: number;
  id?: number;
  images?: ImagesPart[];
  isFavourite?: boolean;
  isTitleGenerated?: boolean;
  messages?: BaseChatMessageDto[];
  questionSolverId?: number;
  title?: string;
  topics?: GetChatResponseDtoTopics;
  userId?: number;
}

export type BaseChatMessageDtoMessageContentType =
  (typeof BaseChatMessageDtoMessageContentType)[keyof typeof BaseChatMessageDtoMessageContentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatMessageDtoMessageContentType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export type BaseChatMessageDtoCourseType =
  (typeof BaseChatMessageDtoCourseType)[keyof typeof BaseChatMessageDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatMessageDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface BaseChatMessageDto {
  chatId?: number;
  chatTitle?: string;
  courseType?: BaseChatMessageDtoCourseType;
  createdAt?: string;
  followups?: string[];
  id?: number;
  isFavorite?: boolean;
  isLiked?: boolean;
  mathResponses?: JsonNode;
  mediaBucketUrl?: string;
  mediaPublicUrl?: string;
  message?: string;
  messageContentType?: BaseChatMessageDtoMessageContentType;
  processedMessage?: string;
  sender?: string;
}

export type QuestionSolverUpdateRequestDtoLevel =
  (typeof QuestionSolverUpdateRequestDtoLevel)[keyof typeof QuestionSolverUpdateRequestDtoLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSolverUpdateRequestDtoLevel = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export type QuestionSolverUpdateRequestDtoCourse =
  (typeof QuestionSolverUpdateRequestDtoCourse)[keyof typeof QuestionSolverUpdateRequestDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSolverUpdateRequestDtoCourse = {
  UNKNOWN: "UNKNOWN",
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  PHILOSOPHY: "PHILOSOPHY",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface QuestionSolverUpdateRequestDto {
  audioUrl?: string;
  compiledResponse?: string;
  course?: QuestionSolverUpdateRequestDtoCourse;
  executionTimes?: JsonNode;
  flashcards?: FlashcardItem[];
  inputTokenCount?: JsonNode;
  level?: QuestionSolverUpdateRequestDtoLevel;
  outlineOfSteps?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  queries?: JsonNode;
  title?: string;
}

export interface RealWorldConnectionUpdateRequestDto {
  connections?: ConnectionItem[];
  description?: string;
  implementationGuide?: string;
  isPublic?: boolean;
  skillFocus?: string[];
  title?: string;
  usageContext?: string;
}

export interface RubricGeneratorUpdateRequestDto {
  criteria?: CriteriaItem[];
  description?: string;
  isPublic?: boolean;
  levelDescriptions?: string[];
  scoreRanges?: ScoreRangeItem[];
  title?: string;
}

export interface UpdateSketchGeneratorRequestDto {
  description?: string;
  isPublic?: boolean;
  title?: string;
}

export type SlideGeneratorResponseDtoCourseType =
  (typeof SlideGeneratorResponseDtoCourseType)[keyof typeof SlideGeneratorResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SlideGeneratorResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface SlideGeneratorResponseDto {
  courseType: SlideGeneratorResponseDtoCourseType;
  grade: number;
  id: number;
  name?: string;
  organizationId: number;
  outline?: OutlineData;
  prompt?: string;
  regenPrompt?: string;
  slides?: SlideData;
  teacherId: number;
}

export interface UpdateSlideGeneratorRequestDto {
  name?: string;
  outline?: OutlineData;
  slides?: SlideData;
}

export interface SummarizerUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  markdownSummary?: string;
  title?: string;
}

export interface SubmissionResponseDto {
  createdAt?: string;
  id?: number;
  lastItemId?: string;
  results?: JsonNode;
  solverName?: string;
  userId?: number;
}

export type PronunciationAssignmentResponseDtoGenerationType =
  (typeof PronunciationAssignmentResponseDtoGenerationType)[keyof typeof PronunciationAssignmentResponseDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PronunciationAssignmentResponseDtoGenerationType = {
  WORD: "WORD",
  SENTENCE: "SENTENCE",
} as const;

export type PronunciationAssignmentResponseDtoContentLanguage =
  (typeof PronunciationAssignmentResponseDtoContentLanguage)[keyof typeof PronunciationAssignmentResponseDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PronunciationAssignmentResponseDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type PronunciationAssignmentResponseDtoCefrLevel =
  (typeof PronunciationAssignmentResponseDtoCefrLevel)[keyof typeof PronunciationAssignmentResponseDtoCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PronunciationAssignmentResponseDtoCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type PronunciationAssignmentResponseDtoAccent =
  (typeof PronunciationAssignmentResponseDtoAccent)[keyof typeof PronunciationAssignmentResponseDtoAccent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PronunciationAssignmentResponseDtoAccent = {
  BRITISH: "BRITISH",
  AMERICAN: "AMERICAN",
} as const;

export interface PronunciationAssignmentResponseDto {
  accent?: PronunciationAssignmentResponseDtoAccent;
  cefrLevel?: PronunciationAssignmentResponseDtoCefrLevel;
  contentLanguage?: PronunciationAssignmentResponseDtoContentLanguage;
  createdAt?: string;
  description?: string;
  generationType?: PronunciationAssignmentResponseDtoGenerationType;
  id?: number;
  items?: PronunciationItem[];
  publicCode?: string;
  submissions?: SubmissionResponseDto[];
  title?: string;
}

export type VisualMatchingResponseDtoStatus =
  (typeof VisualMatchingResponseDtoStatus)[keyof typeof VisualMatchingResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VisualMatchingResponseDtoStatus = {
  PROCESSING: "PROCESSING",
  REGENERATING: "REGENERATING",
  READY: "READY",
  FAILED: "FAILED",
} as const;

export type VisualMatchingResponseDtoContentLanguage =
  (typeof VisualMatchingResponseDtoContentLanguage)[keyof typeof VisualMatchingResponseDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VisualMatchingResponseDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface VisualMatchingOption {
  imagePrompt?: string;
  imageUrl?: string;
  name?: string;
}

export interface VisualMatchingQuestion {
  options?: VisualMatchingOption[];
  topic?: string;
}

export interface VisualMatchingResponseDto {
  contentLanguage?: VisualMatchingResponseDtoContentLanguage;
  createdAt: string;
  description?: string;
  id: number;
  mainTopic?: string;
  questions?: VisualMatchingQuestion[];
  status?: VisualMatchingResponseDtoStatus;
  teacherId: number;
  teacherName?: string;
  title?: string;
}

export interface VisualMatchingUpdateRequestDto {
  [key: string]: unknown;
}

export type TeacherChatMessageResponseDtoType =
  (typeof TeacherChatMessageResponseDtoType)[keyof typeof TeacherChatMessageResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherChatMessageResponseDtoType = {
  TEXT: "TEXT",
  RAW_URL: "RAW_URL",
  IMAGE_PNG: "IMAGE_PNG",
  IMAGE_JPEG: "IMAGE_JPEG",
  PDF: "PDF",
  VOICE_TEXT: "VOICE_TEXT",
} as const;

export type TeacherChatMessageResponseDtoRole =
  (typeof TeacherChatMessageResponseDtoRole)[keyof typeof TeacherChatMessageResponseDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherChatMessageResponseDtoRole = {
  AI: "AI",
  USER: "USER",
} as const;

export interface TeacherChatMessageResponseDto {
  createdAt?: string;
  fileName?: string;
  fileUri?: string;
  groundingMetadata?: TeacherChatMessageResponseDtoGroundingMetadata;
  groundingSegments?: ChatMessageGroundingSupportData[];
  id?: number;
  message?: string;
  role?: TeacherChatMessageResponseDtoRole;
  type?: TeacherChatMessageResponseDtoType;
}

export interface TeacherChatResponseDto {
  createdAt?: string;
  description?: string;
  id?: number;
  llmModel?: string;
  messages?: TeacherChatMessageResponseDto[];
  title?: string;
}

export interface ChatMessageSegmentData {
  endIndex?: number;
  startIndex?: number;
  text?: string;
}

export interface ChatMessageGroundingSupportData {
  groundingChunkIndices?: number[];
  segment?: ChatMessageSegmentData;
}

export interface ChatMessageGroundingData {
  domain?: string;
  url?: string;
}

export type TeacherChatMessageResponseDtoGroundingMetadata = {
  [key: string]: ChatMessageGroundingData;
};

export interface UpdateTeacherChatRequestDto {
  description?: string;
  llmModel?: string;
  title?: string;
}

export interface ExtendQuizAssignmentRequestBody {
  duration: number;
}

export type TopicResponseDtoCourseType =
  (typeof TopicResponseDtoCourseType)[keyof typeof TopicResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TopicResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface TopicResponseDto {
  chapterName: string;
  courseType: TopicResponseDtoCourseType;
  deletedOn?: string;
  grade?: number;
  id: number;
  language?: string;
  topic: string;
  updatedAt?: string;
}

export type QuestionRegenResponseDtoQuestionType =
  (typeof QuestionRegenResponseDtoQuestionType)[keyof typeof QuestionRegenResponseDtoQuestionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionRegenResponseDtoQuestionType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export interface QuestionRegenResponseDto {
  assignmentId?: number;
  createdAt?: string;
  id?: number;
  output?: JsonNode;
  ownerId?: number;
  questionId?: number;
  questionType?: QuestionRegenResponseDtoQuestionType;
}

export type LearningOutcomeUniqueResponseDtoCourseType =
  (typeof LearningOutcomeUniqueResponseDtoCourseType)[keyof typeof LearningOutcomeUniqueResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LearningOutcomeUniqueResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface LearningOutcomeUniqueResponseDto {
  courseType?: LearningOutcomeUniqueResponseDtoCourseType;
  grade?: number;
  id?: number;
  language?: string;
  outcome?: string;
  outcomeExplanationList?: string[];
  unit?: string;
}

export type BaseTrueFalseQuestionDtoAllOf = {
  answer: boolean;
};

export type BaseTrueFalseQuestionDto = BaseQuestionDto &
  BaseTrueFalseQuestionDtoAllOf;

export type BaseTestQuestionDtoAllOfOptions = { [key: string]: string };

export type BaseTestQuestionDtoAllOf = {
  answer: string;
  options: BaseTestQuestionDtoAllOfOptions;
};

export type BaseQuestionDtoType =
  (typeof BaseQuestionDtoType)[keyof typeof BaseQuestionDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseQuestionDtoType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export type BaseQuestionDtoDifficulty =
  (typeof BaseQuestionDtoDifficulty)[keyof typeof BaseQuestionDtoDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseQuestionDtoDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface BaseQuestionDto {
  assignmentId?: number;
  body: string;
  difficulty: BaseQuestionDtoDifficulty;
  dislikes?: number;
  explanation?: string;
  id: number;
  learningOutcome?: string;
  likes?: number;
  mediaUrl?: string;
  point: number;
  type: BaseQuestionDtoType;
}

export type BaseTestQuestionDto = BaseQuestionDto & BaseTestQuestionDtoAllOf;

export type BaseOpenEndedQuestionDtoAllOf = {
  answer: string;
};

export type BaseOpenEndedQuestionDto = BaseQuestionDto &
  BaseOpenEndedQuestionDtoAllOf;

export type BaseMatchQuestionDtoAllOfRightPart = { [key: string]: string };

export type BaseMatchQuestionDtoAllOfLeftPart = { [key: string]: string };

export type BaseMatchQuestionDtoAllOfAnswer = { [key: string]: string };

export type BaseMatchQuestionDtoAllOf = {
  answer: BaseMatchQuestionDtoAllOfAnswer;
  leftPart: BaseMatchQuestionDtoAllOfLeftPart;
  rightPart: BaseMatchQuestionDtoAllOfRightPart;
};

export type BaseMatchQuestionDto = BaseQuestionDto & BaseMatchQuestionDtoAllOf;

export type BaseFillTheBlankQuestionDtoAllOf = {
  answer: string[];
  possibleAnswers?: string[];
};

export type BaseFillTheBlankQuestionDto = BaseQuestionDto &
  BaseFillTheBlankQuestionDtoAllOf;

export type BaseAssignmentResponseDtoType =
  (typeof BaseAssignmentResponseDtoType)[keyof typeof BaseAssignmentResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseAssignmentResponseDtoType = {
  CHAT: "CHAT",
  QUIZ: "QUIZ",
  HOMEWORK: "HOMEWORK",
} as const;

export type BaseAssignmentResponseDtoStatus =
  (typeof BaseAssignmentResponseDtoStatus)[keyof typeof BaseAssignmentResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseAssignmentResponseDtoStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  ASSIGNED: "ASSIGNED",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
} as const;

export type BaseAssignmentResponseDtoQuestionsItem =
  | BaseQuestionDto
  | BaseFillTheBlankQuestionDto
  | BaseMatchQuestionDto
  | BaseOpenEndedQuestionDto
  | BaseTestQuestionDto
  | BaseTrueFalseQuestionDto;

export type BaseAssignmentResponseDtoDifficulty =
  (typeof BaseAssignmentResponseDtoDifficulty)[keyof typeof BaseAssignmentResponseDtoDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseAssignmentResponseDtoDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export type BaseAssignmentResponseDtoCourseType =
  (typeof BaseAssignmentResponseDtoCourseType)[keyof typeof BaseAssignmentResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseAssignmentResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface AssignAssignmentRequestBodyNewItem {
  classroomId?: number;
  studentIds?: number[];
}

export interface BaseAssignmentResponseDto {
  /** @deprecated */
  assignedClassIds?: number[];
  /** @deprecated */
  assignedStudentIds: number[];
  assignedStudentsWithClassrooms?: AssignAssignmentRequestBodyNewItem[];
  assignmentImageUrl?: string;
  courseType: BaseAssignmentResponseDtoCourseType;
  createdAt: string;
  createdBy: number;
  description?: string;
  didEdlinkPublished?: boolean;
  difficulty?: BaseAssignmentResponseDtoDifficulty;
  driveFileIds?: string[];
  duration?: number;
  endDate?: string;
  grade?: number;
  id: number;
  isAssignmentStopped?: boolean;
  lastAssignmentStopTime?: string;
  learningOutcomes?: LearningOutcomeUniqueResponseDto[];
  maarifLearningOutcomes?: MaarifLearningOutcomesPerOutcomePerExplanationLevel2ResponseDto[];
  maxScore?: number;
  name: string;
  organizationId: number;
  pendingReview?: boolean;
  prompt?: string;
  questionRegens?: QuestionRegenResponseDto[];
  questions: BaseAssignmentResponseDtoQuestionsItem[];
  shouldStudentsSeeAnswersAutomaticallyAfterFinish?: boolean;
  startDate?: string;
  status: BaseAssignmentResponseDtoStatus;
  teacherDocuments?: TeacherDocumentResponseDto[];
  teacherId: number;
  topics?: TopicResponseDto[];
  type: BaseAssignmentResponseDtoType;
  youtubeLink?: string;
}

export interface StartQuizAssignmentRequestBody {
  duration: number;
}

export interface EditQuestionRequestBody {
  teacherExplanation?: string;
}

export interface EditAssignAssignmentRequestBody {
  studentIdsToAdd?: number[];
  studentIdsToRemove?: number[];
}

export type TrueFalseQuestionCreateRequestDtoAllOf = {
  answer: boolean;
};

export type TrueFalseQuestionCreateRequestDto = QuestionCreateRequestDto &
  TrueFalseQuestionCreateRequestDtoAllOf;

export type TestQuestionCreateRequestDtoAllOfOptions = {
  [key: string]: string;
};

export type TestQuestionCreateRequestDtoAllOf = {
  answer: string;
  options: TestQuestionCreateRequestDtoAllOfOptions;
};

export type TestQuestionCreateRequestDto = QuestionCreateRequestDto &
  TestQuestionCreateRequestDtoAllOf;

export type QuestionCreateRequestDtoDifficulty =
  (typeof QuestionCreateRequestDtoDifficulty)[keyof typeof QuestionCreateRequestDtoDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionCreateRequestDtoDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface QuestionCreateRequestDto {
  body: string;
  difficulty?: QuestionCreateRequestDtoDifficulty;
  explanation: string;
  mediaUrl?: string;
  point: number;
  type: string;
}

export type OpenEndedQuestionCreateRequestDtoAllOf = {
  answer: string;
};

export type OpenEndedQuestionCreateRequestDto = QuestionCreateRequestDto &
  OpenEndedQuestionCreateRequestDtoAllOf;

export type MatchQuestionCreateRequestDto = QuestionCreateRequestDto &
  MatchQuestionCreateRequestDtoAllOf;

export type MatchQuestionCreateRequestDtoAllOfRightPart = {
  [key: string]: string;
};

export type MatchQuestionCreateRequestDtoAllOfLeftPart = {
  [key: string]: string;
};

export type MatchQuestionCreateRequestDtoAllOfAnswer = {
  [key: string]: string;
};

export type MatchQuestionCreateRequestDtoAllOf = {
  answer: MatchQuestionCreateRequestDtoAllOfAnswer;
  leftPart: MatchQuestionCreateRequestDtoAllOfLeftPart;
  rightPart: MatchQuestionCreateRequestDtoAllOfRightPart;
};

export type FillTheBlanksQuestionCreateRequestDtoAllOf = {
  answer: string[];
  possibleAnswers?: string[];
};

export type FillTheBlanksQuestionCreateRequestDto = QuestionCreateRequestDto &
  FillTheBlanksQuestionCreateRequestDtoAllOf;

export type EditAssignmentRequestBodyStatus =
  (typeof EditAssignmentRequestBodyStatus)[keyof typeof EditAssignmentRequestBodyStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EditAssignmentRequestBodyStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  ASSIGNED: "ASSIGNED",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED",
} as const;

export type EditAssignmentRequestBodyNewlyCreatedItem =
  | FillTheBlanksQuestionCreateRequestDto
  | MatchQuestionCreateRequestDto
  | OpenEndedQuestionCreateRequestDto
  | TestQuestionCreateRequestDto
  | TrueFalseQuestionCreateRequestDto;

export type EditAssignmentRequestBodyEdited = {
  [key: string]:
    | FillTheBlanksQuestionCreateRequestDto
    | MatchQuestionCreateRequestDto
    | OpenEndedQuestionCreateRequestDto
    | TestQuestionCreateRequestDto
    | TrueFalseQuestionCreateRequestDto;
};

export interface EditAssignmentRequestBody {
  canStudentsGoBackBetweenQuestions?: boolean;
  deletedIds?: number[];
  description?: string;
  duration?: number;
  edited?: EditAssignmentRequestBodyEdited;
  endDate?: string;
  imageUrl?: string;
  name?: string;
  newlyCreated?: EditAssignmentRequestBodyNewlyCreatedItem[];
  shouldStudentsSeeAnswersAutomaticallyAfterFinish?: boolean;
  shouldUpdateImage?: boolean;
  startDate?: string;
  status?: EditAssignmentRequestBodyStatus;
}

export type TeacherResponseDtoMemory = { [key: string]: string };

export type ClassroomResponseDtoCourseType =
  (typeof ClassroomResponseDtoCourseType)[keyof typeof ClassroomResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassroomResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface ClassroomResponseDto {
  courseType: ClassroomResponseDtoCourseType;
  edlinkClassId?: string;
  googleClassroom?: boolean;
  grade: number;
  id: number;
  name: string;
  organizationId: number;
  section: string;
  studentCount: number;
  teacherId?: number;
  uuid?: string;
  visibleCourseType?: string;
}

export interface TeacherResponseDto {
  city?: string;
  classes?: ClassroomResponseDto[];
  createdAt?: string;
  edlinkPersonId?: string;
  email: string;
  grade?: string[];
  hasActiveEdlinkToken?: boolean;
  hasJoinedAcademy?: boolean;
  id: number;
  memory: TeacherResponseDtoMemory;
  name: string;
  preferences?: UserPreferences;
  role?: string;
  school?: string;
  surname: string;
  teacherProDate?: string;
}

export type UserPreferencesQuestionSolverLevel =
  (typeof UserPreferencesQuestionSolverLevel)[keyof typeof UserPreferencesQuestionSolverLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPreferencesQuestionSolverLevel = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export type UserPreferencesOnboardingTasks = { [key: string]: string };

export interface UserPreferences {
  avatarName?: string;
  dashboardLayout?: JsonNode;
  didCompleteOnboarding?: boolean;
  didSendSubscriptionEmail?: boolean;
  favoriteTools?: string[];
  fontSize?: string;
  language?: string;
  lastUsedTools?: string[];
  newFeatures?: JsonNode;
  onboardingTasks?: UserPreferencesOnboardingTasks;
  pdfOptions?: JsonNode;
  preferredLanguageModel?: string;
  questionSolverLevel?: UserPreferencesQuestionSolverLevel;
  startWithPushToTalk?: boolean;
  teacherProDate?: string;
  theme?: string;
  totalToolSuggestion?: number;
  vibrationEnabled?: boolean;
}

export interface EditTeacherRequestBodyDto {
  city?: string;
  grade?: string[];
  name?: string;
  preferences?: UserPreferences;
  role?: string;
  school?: string;
  surname?: string;
}

export type TedLessonPlannerResponseDtoCourseName =
  (typeof TedLessonPlannerResponseDtoCourseName)[keyof typeof TedLessonPlannerResponseDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TedLessonPlannerResponseDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface TedLessonPlannerResponseDto {
  additionalMaterials?: TedLessonPlannerMaterials[];
  courseName?: TedLessonPlannerResponseDtoCourseName;
  createdAt?: string;
  grade?: number;
  id?: number;
  maarifLearningOutcomes?: MaarifLearningOutcomesPerOutcomePerExplanationResponseDto;
  name?: string;
  steps?: TedLessonPlannerSteps[];
  updatedAt?: string;
}

export type TedLessonPlannerMaterialsToolType =
  (typeof TedLessonPlannerMaterialsToolType)[keyof typeof TedLessonPlannerMaterialsToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TedLessonPlannerMaterialsToolType = {
  AI_ASSESSMENT_SCALE: "AI_ASSESSMENT_SCALE",
  AI_ASSIGNMENT: "AI_ASSIGNMENT",
  AI_RESISTANT_HOMEWORK: "AI_RESISTANT_HOMEWORK",
  AI_SUPPORTED_TASKS: "AI_SUPPORTED_TASKS",
  BLOOMS_TAXONOMY_ACTIVITIES: "BLOOMS_TAXONOMY_ACTIVITIES",
  CHOICE_BOARD: "CHOICE_BOARD",
  CLASSROOM_MANAGEMENT: "CLASSROOM_MANAGEMENT",
  COLLABORATIVE_GROUP_WORK: "COLLABORATIVE_GROUP_WORK",
  COMMON_MISCONCEPTION: "COMMON_MISCONCEPTION",
  CONCEPTUAL_UNDERSTANDING: "CONCEPTUAL_UNDERSTANDING",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  EXIT_TICKET_GENERATOR: "EXIT_TICKET_GENERATOR",
  FORMATIVE_ASSESSMENT: "FORMATIVE_ASSESSMENT",
  HOMEWORK_IDEA: "HOMEWORK_IDEA",
  IMAGE_GENERATOR: "IMAGE_GENERATOR",
  LESSON_HOOK: "LESSON_HOOK",
  MINDMAP_GENERATOR: "MINDMAP_GENERATOR",
  PERFORMANCE_TASK: "PERFORMANCE_TASK",
  PODCAST: "PODCAST",
  PROJECT_BASED_LEARNING: "PROJECT_BASED_LEARNING",
  REAL_WORLD_CONNECTION: "REAL_WORLD_CONNECTION",
  RUBRIC_GENERATOR: "RUBRIC_GENERATOR",
  SUMMARIZER: "SUMMARIZER",
  TEXT_LEVELER: "TEXT_LEVELER",
  TRANSFER_ACTIVITY: "TRANSFER_ACTIVITY",
  UDL_CHOICE_BOARD: "UDL_CHOICE_BOARD",
  VOCABULARY_LIST: "VOCABULARY_LIST",
  HEYGEN_AVATAR: "HEYGEN_AVATAR",
  ARTICLE_GENERATOR: "ARTICLE_GENERATOR",
  SKETCH_GENERATOR: "SKETCH_GENERATOR",
} as const;

export interface TedLessonPlannerMaterials {
  ek_id?: number;
  icerik_json?: JsonNode;
  tool_id?: number;
  toolType?: TedLessonPlannerMaterialsToolType;
}

export interface TedLessonPlannerUpdateRequestDto {
  name?: string;
  steps?: TedLessonPlannerSteps[];
}

export type TedYearlyLessonPlannerResponseDtoCourseName =
  (typeof TedYearlyLessonPlannerResponseDtoCourseName)[keyof typeof TedYearlyLessonPlannerResponseDtoCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TedYearlyLessonPlannerResponseDtoCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface TedYearlyLessonPlannerResponseDto {
  courseName?: TedYearlyLessonPlannerResponseDtoCourseName;
  createdAt?: string;
  grade?: number;
  id?: number;
  maarifLearningOutcomes?: MaarifLearningOutcomesPerOutcomePerExplanationResponseDto;
  name?: string;
  updatedAt?: string;
}

export type MaarifLearningOutcomesPerOutcomePerExplanationResponseDtoCourseType =
  (typeof MaarifLearningOutcomesPerOutcomePerExplanationResponseDtoCourseType)[keyof typeof MaarifLearningOutcomesPerOutcomePerExplanationResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaarifLearningOutcomesPerOutcomePerExplanationResponseDtoCourseType =
  {
    ENGLISH: "ENGLISH",
    SCIENCE: "SCIENCE",
    HISTORY: "HISTORY",
    GEOGRAPHY: "GEOGRAPHY",
    TURKISH: "TURKISH",
    MATHEMATICS: "MATHEMATICS",
    BIOLOGY: "BIOLOGY",
    CHEMISTRY: "CHEMISTRY",
    PHYSICS: "PHYSICS",
    PHILOSOPHY: "PHILOSOPHY",
    RELIGION: "RELIGION",
    CITIZENSHIP: "CITIZENSHIP",
    DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
    BILISIM: "BILISIM",
    TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
    AP_ASTRONOMY: "AP_ASTRONOMY",
    AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
    AP_BUSINESS: "AP_BUSINESS",
    AP_ECONOMICS: "AP_ECONOMICS",
    AP_SOCIOLOGY: "AP_SOCIOLOGY",
    AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
    AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
    AP_BIOLOGY: "AP_BIOLOGY",
    AP_CHEMISTRY: "AP_CHEMISTRY",
    AP_PHYSICS: "AP_PHYSICS",
    UNKNOWN: "UNKNOWN",
    AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
    AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
    AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
    AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
      "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
    AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
    AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
    AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
    AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
    AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
    AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
    AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
    AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
    AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
    AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
      "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
    AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
    AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
    AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
    AP_2025_STATISTICS: "AP_2025_STATISTICS",
    AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
    IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
    IGCSE_PHYSICS: "IGCSE_PHYSICS",
    IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
    IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
    IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
    IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
    IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
    IGCSE_HISTORY: "IGCSE_HISTORY",
    IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
    IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
    IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
    IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
    IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
    IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
    IB_DP_HISTORY: "IB_DP_HISTORY",
    IB_DP_PHYSICS: "IB_DP_PHYSICS",
    IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
    IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
    ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
    ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
    ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
    ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
    ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
    ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
    ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
    ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
    ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
    ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
    ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
    ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
    ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
    ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
    MONTH_36_48: "MONTH_36_48",
    MONTH_48_60: "MONTH_48_60",
  } as const;

export interface MaarifLearningOutcomesPerOutcomePerExplanationLevel2ResponseDto {
  id?: number;
  outcome?: string;
  outcomeExplanationList?: string[];
}

export interface MaarifLearningOutcomesPerOutcomePerExplanationLevel1ResponseDto {
  alanBecerileri?: string;
  anahtarKavramlar?: string;
  becerilerArasiIliskiler?: string;
  degerler?: string;
  dersSaati?: string;
  description?: string;
  destekleme?: string;
  disiplinlerArasiIliskiler?: string;
  egilimler?: string;
  icerikCercevesiList?: string[];
  kavramsalBeceriler?: string;
  kopruKurma?: string;
  ogrenmeCiktilariVeSurecBilesenleriList?: string[];
  ogrenmeKanitlariOlcmeVeDegerlendirme?: string;
  ogrenmeOgretmeUygulamalariList?: string[];
  okuryazarlikBecerileri?: string;
  onDegerlendirmeSureci?: string;
  outcomes?: MaarifLearningOutcomesPerOutcomePerExplanationLevel2ResponseDto[];
  sosyalDuygusalOgrenmeBecerileri?: string;
  temelKabuller?: string;
  unit: string;
  zenginlestirme?: string;
}

export interface MaarifLearningOutcomesPerOutcomePerExplanationResponseDto {
  courseType?: MaarifLearningOutcomesPerOutcomePerExplanationResponseDtoCourseType;
  grade?: number;
  units?: MaarifLearningOutcomesPerOutcomePerExplanationLevel1ResponseDto[];
}

export interface TedYearlyLessonPlannerUpdateRequestDto {
  name?: string;
}

export interface TextLevelerUpdateRequestDto {
  description?: string;
  gradeLevel?: number;
  isPublic?: boolean;
  leveledMarkdown?: string;
  title?: string;
}

export interface TransferActivityUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  realLifeConnection?: string;
  studentTask?: string;
  teacherRole?: string;
  title?: string;
}

export type AutoGenerateRequestDtoCurrentData = {
  [key: string]: { [key: string]: unknown };
};

export interface AutoGenerateRequestDto {
  currentData?: AutoGenerateRequestDtoCurrentData;
}

export type RefineStep1RequestDtoCurrentStep11Data = {
  [key: string]: { [key: string]: unknown };
};

export type RefineStep1RequestDtoCurrentData = {
  [key: string]: { [key: string]: unknown };
};

export interface RefineStep1RequestDto {
  currentData?: RefineStep1RequestDtoCurrentData;
  currentStep11Data: RefineStep1RequestDtoCurrentStep11Data;
  refineInstructions: string;
}

export type RefineGenericRequestDtoStep =
  (typeof RefineGenericRequestDtoStep)[keyof typeof RefineGenericRequestDtoStep];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefineGenericRequestDtoStep = {
  "11": "1.1",
  "12": "1.2",
  "13": "1.3",
  "14": "1.4",
  "15": "1.5",
  "21": "2.1",
  "22": "2.2",
  "23": "2.3",
  "31": "3.1",
  final: "final",
  "11_refine": "1.1_refine",
  "12_refine": "1.2_refine",
  "13_refine": "1.3_refine",
  "14_refine": "1.4_refine",
  "15_refine": "1.5_refine",
  "21_refine": "2.1_refine",
  "22_refine": "2.2_refine",
  "23_refine": "2.3_refine",
  "31_refine": "3.1_refine",
  final_refine: "final_refine",
} as const;

export type RefineGenericRequestDtoCurrentStepData = {
  [key: string]: { [key: string]: unknown };
};

export type RefineGenericRequestDtoCurrentData = {
  [key: string]: { [key: string]: unknown };
};

export interface RefineGenericRequestDto {
  currentData?: RefineGenericRequestDtoCurrentData;
  currentStepData?: RefineGenericRequestDtoCurrentStepData;
  refineInstructions: string;
  step: RefineGenericRequestDtoStep;
}

export type UbdExpertPlannerResponseDtoCourseType =
  (typeof UbdExpertPlannerResponseDtoCourseType)[keyof typeof UbdExpertPlannerResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UbdExpertPlannerResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface UbdExpertPlannerResponseDto {
  courseType?: UbdExpertPlannerResponseDtoCourseType;
  createdAt?: string;
  grade?: number;
  id?: number;
  name?: string;
  result?: JsonNode;
  teacherId?: number;
  tempOutputs?: JsonNode;
}

export type IndividualStepRequestDtoStep =
  (typeof IndividualStepRequestDtoStep)[keyof typeof IndividualStepRequestDtoStep];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IndividualStepRequestDtoStep = {
  "11": "1.1",
  "12": "1.2",
  "13": "1.3",
  "14": "1.4",
  "15": "1.5",
  "21": "2.1",
  "22": "2.2",
  "23": "2.3",
  "31": "3.1",
  final: "final",
  "11_refine": "1.1_refine",
  "12_refine": "1.2_refine",
  "13_refine": "1.3_refine",
  "14_refine": "1.4_refine",
  "15_refine": "1.5_refine",
  "21_refine": "2.1_refine",
  "22_refine": "2.2_refine",
  "23_refine": "2.3_refine",
  "31_refine": "3.1_refine",
  final_refine: "final_refine",
} as const;

export type IndividualStepRequestDtoCurrentData = {
  [key: string]: { [key: string]: unknown };
};

export interface IndividualStepRequestDto {
  currentData?: IndividualStepRequestDtoCurrentData;
  step: IndividualStepRequestDtoStep;
}

export type GenerateUbdGoalsSubstepWithAiRequestDtoGenerationType =
  (typeof GenerateUbdGoalsSubstepWithAiRequestDtoGenerationType)[keyof typeof GenerateUbdGoalsSubstepWithAiRequestDtoGenerationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateUbdGoalsSubstepWithAiRequestDtoGenerationType = {
  UNDERSTANDING_GOALS: "UNDERSTANDING_GOALS",
  TRANSFER_GOALS: "TRANSFER_GOALS",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  GOALS_AND_QUESTIONS: "GOALS_AND_QUESTIONS",
  PERFORMANCE_TASKS: "PERFORMANCE_TASKS",
  OTHER_EVIDENCE: "OTHER_EVIDENCE",
  ASSESSMENT_AND_EXPERIENCES: "ASSESSMENT_AND_EXPERIENCES",
  LESSON_FLOW: "LESSON_FLOW",
} as const;

export interface GenerateUbdGoalsSubstepWithAiRequestDto {
  generationType?: GenerateUbdGoalsSubstepWithAiRequestDtoGenerationType;
}

export interface GenerateUbdGoalsSubstepRequestDto {
  userExtraUbdEssentialQuestions?: string[];
  userExtraUbdOtherEvidence?: string[];
  userExtraUbdPerformanceTasks?: string[];
  userExtraUbdTransferGoals?: string[];
  userExtraUbdUnderstandingGoals?: string[];
}

export type UbdMaarifPlannerResponseDtoTempOutputs = {
  [key: string]: string[];
};

export type UbdMaarifPlannerResponseDtoCourseType =
  (typeof UbdMaarifPlannerResponseDtoCourseType)[keyof typeof UbdMaarifPlannerResponseDtoCourseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UbdMaarifPlannerResponseDtoCourseType = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type UbdMaarifPlannerResponseDtoContentLanguage =
  (typeof UbdMaarifPlannerResponseDtoContentLanguage)[keyof typeof UbdMaarifPlannerResponseDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UbdMaarifPlannerResponseDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export interface UbdMaarifPlannerResponseDto {
  contentLanguage?: UbdMaarifPlannerResponseDtoContentLanguage;
  courseType?: UbdMaarifPlannerResponseDtoCourseType;
  createdAt?: string;
  duration?: number;
  grade?: number;
  id?: number;
  lessonCount?: number;
  lessonFlow?: LessonFlow;
  name?: string;
  teacherId?: number;
  tempOutputs?: UbdMaarifPlannerResponseDtoTempOutputs;
  ubdEssentialQuestions?: string[];
  ubdOtherEvidence?: string[];
  ubdPerformanceTasks?: string[];
  ubdTransferGoals?: string[];
  ubdUnderstandingGoals?: string[];
}

export interface EditUbdMaarifPlannerRequestDto {
  name?: string;
}

export interface UdlChoiceBoardUpdateRequestDto {
  description?: string;
  engagementOptions?: EngagementOptions[];
  expressionOptions?: ExpressionOptions[];
  isPublic?: boolean;
  representationOptions?: RepresentationOptions[];
  title?: string;
}

export interface SaveFirebaseDeviceInfoRequestBodyDto {
  deviceId: string;
  deviceToken: string;
}

export interface VideoAvatarAvailableFacesResponseDto {
  avatarId?: string;
  avatarName?: string;
  language?: string;
  sampleImageUrl?: string;
  sampleVideoUrl?: string;
  voiceId?: string;
}

export interface VideoAvatarUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  requestAvatar?: VideoAvatarAvailableFacesResponseDto;
  title?: string;
}

export interface VocabularyListUpdateRequestDto {
  description?: string;
  isPublic?: boolean;
  title?: string;
  vocabulary?: VocabularyListItem[];
}

export interface AiAssessmentScaleWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  levels?: AssessmentLevel[];
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface AiAssignmentWebhookRequestDto {
  aiGeneratedDescription?: string;
  aiPromptExamples?: string[];
  description?: string;
  executionTimes?: JsonNode;
  gradingRubric?: AiAssignmentGradingRubricItem[];
  imageUrl?: string;
  implementationSteps?: string[];
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  reflectionQuestions?: string[];
  regenChatId?: number;
  studentInstructions?: string;
  title?: string;
}

export interface AiResistantHomeworkWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  report_ideas?: AiResistantHomeworkReportIdea[];
  title?: string;
}

export interface AiSupportedTasksWebhookRequestDto {
  aiGeneratedDescription?: string;
  assessmentRubric?: AiSupportedTaskRubricCriteria[];
  benefits?: string[];
  description?: string;
  executionTimes?: JsonNode;
  expectedOutput?: AiSupportedTaskExpectedOutput;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  learningObjectives?: string[];
  mindmapId?: number;
  mindmapNodeId?: string;
  notes?: AiSupportedTaskNotes;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  recommendedAiPlatform?: AiSupportedTaskAiPlatform;
  regenChatId?: number;
  researchProcessDescription?: string;
  steps?: AiSupportedTaskStep[];
  title?: string;
}

export interface FailedQuestionGenerationRequestDto {
  assignmentId?: number;
  message?: string;
  missing_questions?: JsonNode;
  userId?: number;
}

export type CompleteQuestionGenerationRequestDtoQuestionsItem =
  | FillTheBlankQuestion
  | MatchQuestion
  | OpenEndedQuestion
  | TestQuestion
  | TrueFalseQuestion;

export interface CompleteQuestionGenerationRequestDto {
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  learningOutcomeTags?: string[];
  metadata?: JsonNode;
  missingQuestions?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  questions?: CompleteQuestionGenerationRequestDtoQuestionsItem[];
  topics?: string;
}

export interface AssignmentGenerationImageUpdateDto {
  imageUrl?: string;
}

export interface AssignmentGenerationTitleUpdateDto {
  description?: string;
  title?: string;
}

export interface BloomsTaxonomyActivitiesWebhookRequestDto {
  activities?: BloomsTaxonomyActivitiesActivityItem[];
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  implementationNotes?: string[];
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface ChatAnalysisSuccessInsideRequestDto {
  all_memory?: UserMemoryItem[];
  conversation_flow?: string;
  curiosity_and_interest_areas?: string[];
  topics?: JsonNode;
}

export interface ChatAnalysisSuccessRequestDto {
  chatAnalysisSuccessInsideRequestDto?: ChatAnalysisSuccessInsideRequestDto;
  chatlyAnalysisId?: number;
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
}

export interface ChoiceBoardWebhookRequestDto {
  activities?: ActivityItem[];
  aiGeneratedDescription?: string;
  choice_board_instructions?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface ClassroomManagementWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  strategies?: ClassroomManagementItem[];
  title?: string;
}

export interface CollaborativeGroupWorkWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  group_roles?: GroupRolesItem[];
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  peer_evaluation_questions?: PeerEvaluationQuestionItem[];
  process_evaluation_criteria?: ProcessEvaluationCriteriaItem[];
  process_steps?: ProcessStepItem[];
  promptVersion?: number;
  reflection_questions?: ReflectionQuestionItem[];
  regenChatId?: number;
  teacher_evaluation_questions?: TeacherEvaluationQuestionItem[];
  teacher_role_description?: string;
  title?: string;
}

export interface CommonMisconceptionWebhookRequestDto {
  aiGeneratedDescription?: string;
  assessment_strategies?: AssessmentStrategies;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  misconceptions?: MisconceptionItem[];
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface ConceptualUnderstandingWebhookRequestDto {
  aiGeneratedDescription?: string;
  conceptual_activities?: ConceptualActivitiesItem[];
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface KeyQuote {
  explanation?: string;
  quote?: string;
}

export interface ParagraphAnalysis {
  content_and_structure_analysis?: string;
  key_quotes?: KeyQuote[];
  paragraph_number?: number;
  paragraph_type?: string;
}

export interface CriterionEvaluation {
  areas_to_improve?: string[];
  criterion_description?: string;
  criterion_name?: string;
  justification_with_evidence?: string;
  max_score?: number;
  score?: number;
  strengths?: string[];
}

export interface NewEssayEvaluationResult {
  criteria_evaluations?: CriterionEvaluation[];
  essay_language?: string;
  lang_code?: string;
  max_score?: number;
  overall_summary?: string;
  paragraph_analysis?: ParagraphAnalysis[];
  score?: number;
  student_feedback?: string;
}

export interface EssentialQuestionsWebhookRequestDto {
  activity_suggestions?: ActivitySuggestionItem[];
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  questions?: string[];
  regenChatId?: number;
  title?: string;
}

export interface ExitTicketWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  exit_tickets?: ExitTicketItem[];
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface FormativeAssessmentWebhookRequestDto {
  aiGeneratedDescription?: string;
  assessment_methodology?: string[];
  assessment_tool?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  instructional_flow?: InstructionalFlow;
  isRegenerated?: boolean;
  learning_reflection?: string[];
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  pedagogical_feedback?: string[];
  process?: string;
  promptVersion?: number;
  regenChatId?: number;
  student_reflection?: string;
  teacher_feedback?: string;
  title?: string;
}

export type InteractiveMaterialWebhookRequestAdvancedEditVideoQuestionsItem =
  | FillTheBlankQuestion
  | MatchQuestion
  | OpenEndedQuestion
  | TestQuestion
  | TrueFalseQuestion;

export type InteractiveMaterialWebhookRequestAdvancedEditQuizQuestionsItem =
  | FillTheBlankQuestion
  | MatchQuestion
  | OpenEndedQuestion
  | TestQuestion
  | TrueFalseQuestion;

export interface InteractiveMaterialWebhookRequestAdvancedEdit {
  quizQuestions?: InteractiveMaterialWebhookRequestAdvancedEditQuizQuestionsItem[];
  textualInfo?: InteractiveMaterialTextualInfo[];
  videoQuestions?: InteractiveMaterialWebhookRequestAdvancedEditVideoQuestionsItem[];
}

export interface VideoAvatarWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  language?: string;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
  transcript?: string;
}

export interface HomeworkIdeaWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  report_ideas?: HomeworkIdeaItem[];
  title?: string;
}

export interface ImageGeneratorWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  images?: GeneratedImageItem[];
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface TimestampedContent {
  duration?: number;
  start?: number;
  text?: string;
}

export interface InteractiveMaterialVideoMetadata {
  custom_thumbnail_extracted?: boolean;
  custom_thumbnail_url?: string;
  description?: string;
  length_seconds?: number;
  publish_date?: string;
  thumbnail_url?: string;
  title?: string;
  video_s3?: string;
}

export interface InteractiveMaterialVideoContentExtractionData {
  metadata?: InteractiveMaterialVideoMetadata;
  transcript?: TimestampedContent[];
}

export type TrueFalseQuestionAllOf = {
  answer?: boolean;
  body?: string;
};

export type TrueFalseQuestion = BaseQuestion & TrueFalseQuestionAllOf;

export type TestQuestionAllOfOptions = { [key: string]: string };

export type TestQuestionAllOf = {
  answer?: string;
  body?: string;
  options?: TestQuestionAllOfOptions;
};

export type TestQuestion = BaseQuestion & TestQuestionAllOf;

export interface SlideImageItem {
  mime?: string;
  pageNumber?: number;
  path?: string;
}

export type OpenEndedQuestionAllOf = {
  answer?: string;
  body?: string;
};

export type OpenEndedQuestion = BaseQuestion & OpenEndedQuestionAllOf;

export type MatchQuestion = BaseQuestion & MatchQuestionAllOf;

export type MatchQuestionAllOfRightPart = { [key: string]: string };

export type MatchQuestionAllOfLeftPart = { [key: string]: string };

export type MatchQuestionAllOfAnswer = { [key: string]: string };

export type MatchQuestionAllOf = {
  answer?: MatchQuestionAllOfAnswer;
  body?: string;
  leftPart?: MatchQuestionAllOfLeftPart;
  rightPart?: MatchQuestionAllOfRightPart;
};

export type InteractiveMaterialWebhookRequestQuizQuestionsItem =
  | FillTheBlankQuestion
  | MatchQuestion
  | OpenEndedQuestion
  | TestQuestion
  | TrueFalseQuestion;

export interface InteractiveMaterialTextualInfo {
  duration?: number;
  height?: number;
  label?: string;
  startPage?: number;
  startTime?: number;
  subcontentId?: string;
  text?: string;
  width?: number;
  x?: number;
  y?: number;
}

export interface InteractiveMaterialGlossary {
  definition?: string;
  duration?: number;
  startPage?: number;
  startTime?: number;
  term?: string;
}

export interface InteractiveMaterialFlashcards {
  back?: string;
  category?: string;
  difficulty?: string;
  duration?: number;
  front?: string;
  hint?: string;
  startPage?: number;
  startTime?: number;
}

export interface InteractiveMaterialWebhookRequest {
  conceptCards?: ConceptCard[];
  description?: string;
  dragAndDrops?: DragTextItem[];
  flashcards?: InteractiveMaterialFlashcards[];
  glossaryItems?: InteractiveMaterialGlossary[];
  quizQuestions?: InteractiveMaterialWebhookRequestQuizQuestionsItem[];
  shouldCallFinalize?: boolean;
  slideImageItems?: SlideImageItem[];
  summary?: string;
  textualInfo?: InteractiveMaterialTextualInfo[];
  title?: string;
  videoQuestions?: InteractiveMaterialWebhookRequestVideoQuestionsItem[];
}

export type FillTheBlankQuestionAllOf = {
  answer?: string[];
  body?: string;
};

export interface DragTextItem {
  definition?: string;
  term?: string;
}

export interface ConceptCard {
  definition?: string;
  term?: string;
}

export type BaseQuestionDifficulty =
  (typeof BaseQuestionDifficulty)[keyof typeof BaseQuestionDifficulty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseQuestionDifficulty = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export interface BaseQuestion {
  difficulty?: BaseQuestionDifficulty;
  explanation?: string;
  id?: number;
  startPage?: number;
  startTime?: number;
  subcontentId?: string;
  type?: string;
}

export type FillTheBlankQuestion = BaseQuestion & FillTheBlankQuestionAllOf;

export type InteractiveMaterialWebhookRequestVideoQuestionsItem =
  | FillTheBlankQuestion
  | MatchQuestion
  | OpenEndedQuestion
  | TestQuestion
  | TrueFalseQuestion;

export interface LessonHookWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  hooks?: HookItem[];
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface SectionContentDto {
  details: string;
  /** @minimum 1 */
  duration: number;
  name: string;
}

export interface LessonPlannerWebhookV2RequestBodySectionsDto {
  assessment?: LessonPlannerSectionDto;
  closure?: LessonPlannerSectionDto;
  guidedPractice?: LessonPlannerSectionDto;
  independentPractice?: LessonPlannerSectionDto;
  introduction?: LessonPlannerSectionDto;
  presentation?: LessonPlannerSectionDto;
}

export type LessonPlannerWebhookV2RequestBodyDtoSection =
  (typeof LessonPlannerWebhookV2RequestBodyDtoSection)[keyof typeof LessonPlannerWebhookV2RequestBodyDtoSection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonPlannerWebhookV2RequestBodyDtoSection = {
  introduction: "introduction",
  presentation: "presentation",
  guidedPractice: "guidedPractice",
  independentPractice: "independentPractice",
  assessment: "assessment",
  closure: "closure",
} as const;

export interface LessonPlannerWebhookV2RequestBodyDto {
  additionalActivities?: SectionContentDto[];
  description?: string;
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  section?: LessonPlannerWebhookV2RequestBodyDtoSection;
  sections?: LessonPlannerWebhookV2RequestBodySectionsDto;
  title?: string;
}

export interface LessonPlannerSectionDto {
  content: SectionContentDto[];
  duration: string;
  title: string;
}

export interface WordAlternatives {
  alternatives?: string[];
  word?: string;
}

export type VocabularyListResponseDtoAllOfCourseName =
  (typeof VocabularyListResponseDtoAllOfCourseName)[keyof typeof VocabularyListResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabularyListResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type VocabularyListResponseDtoAllOfCefrLevel =
  (typeof VocabularyListResponseDtoAllOfCefrLevel)[keyof typeof VocabularyListResponseDtoAllOfCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabularyListResponseDtoAllOfCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type VocabularyListResponseDtoAllOf = {
  cefrLevel?: VocabularyListResponseDtoAllOfCefrLevel;
  courseName?: VocabularyListResponseDtoAllOfCourseName;
  gradeLevel?: number;
  prompt?: string;
  vocabulary?: VocabularyListItem[];
};

export type VocabularyListResponseDto = BaseTeacherToolResponseDto &
  VocabularyListResponseDtoAllOf;

export type VideoAvatarResponseDtoAllOfCourseName =
  (typeof VideoAvatarResponseDtoAllOfCourseName)[keyof typeof VideoAvatarResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoAvatarResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type VideoAvatarResponseDtoAllOf = {
  avatarSampleVideoUrl?: string;
  avatarStatus?: string;
  courseName?: VideoAvatarResponseDtoAllOfCourseName;
  duration?: number;
  gradeLevel?: number;
  prompt?: string;
  transcript?: string;
  videoUrlWithCaption?: string;
};

export type VideoAvatarResponseDto = BaseTeacherToolResponseDto &
  VideoAvatarResponseDtoAllOf;

export type UdlChoiceBoardResponseDtoAllOfCourseName =
  (typeof UdlChoiceBoardResponseDtoAllOfCourseName)[keyof typeof UdlChoiceBoardResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UdlChoiceBoardResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type UdlChoiceBoardResponseDtoAllOf = {
  additionalInfo?: string;
  courseName?: UdlChoiceBoardResponseDtoAllOfCourseName;
  engagementOptions?: EngagementOptions[];
  expressionOptions?: ExpressionOptions[];
  gradeLevel?: number;
  prompt?: string;
  representationOptions?: RepresentationOptions[];
  teacherNotes?: string;
};

export type UdlChoiceBoardResponseDto = BaseTeacherToolResponseDto &
  UdlChoiceBoardResponseDtoAllOf;

export type TransferActivityResponseDtoAllOfCourseName =
  (typeof TransferActivityResponseDtoAllOfCourseName)[keyof typeof TransferActivityResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferActivityResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type TransferActivityResponseDtoAllOf = {
  additionalInfo?: string;
  courseName?: TransferActivityResponseDtoAllOfCourseName;
  gradeLevel?: number;
  prompt?: string;
  realLifeConnection?: string;
  studentTask?: string;
  teacherRole?: string;
};

export type TransferActivityResponseDto = BaseTeacherToolResponseDto &
  TransferActivityResponseDtoAllOf;

export type TextLevelerResponseDtoAllOfCefrLevel =
  (typeof TextLevelerResponseDtoAllOfCefrLevel)[keyof typeof TextLevelerResponseDtoAllOfCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextLevelerResponseDtoAllOfCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type TextLevelerResponseDtoAllOf = {
  cefrLevel?: TextLevelerResponseDtoAllOfCefrLevel;
  grade?: number;
  language?: string;
  leveledText?: string;
  originalText?: string;
};

export type TextLevelerResponseDto = BaseTeacherToolResponseDto &
  TextLevelerResponseDtoAllOf;

export interface TeacherGuidelines {
  feedback_tips?: string[];
  grading_criteria?: string[];
  time_estimation?: string;
}

export interface TeacherEvaluationQuestionItem {
  focus_area?: string;
  observation_criteria?: string;
  question?: string;
}

export type TeacherDocumentResponseDtoStatus =
  (typeof TeacherDocumentResponseDtoStatus)[keyof typeof TeacherDocumentResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeacherDocumentResponseDtoStatus = {
  PROCESSING: "PROCESSING",
  READY: "READY",
  FAILED: "FAILED",
} as const;

export interface TeacherDocumentResponseDto {
  bucketPath?: string;
  contentType?: string;
  downloadUrl?: string;
  fileName?: string;
  id?: number;
  size?: number;
  status?: TeacherDocumentResponseDtoStatus;
  uploadedAt?: string;
  uploadedBy?: number;
  url?: string;
}

export type SummarizerResponseDto = BaseTeacherToolResponseDto &
  SummarizerResponseDtoAllOf;

export type SummarizerResponseDtoAllOfCefrLevel =
  (typeof SummarizerResponseDtoAllOfCefrLevel)[keyof typeof SummarizerResponseDtoAllOfCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SummarizerResponseDtoAllOfCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type SummarizerResponseDtoAllOf = {
  cefrLevel?: SummarizerResponseDtoAllOfCefrLevel;
  markdownSummary?: string;
  originalText?: string;
};

export interface StudentCriteria {
  self_assessment_questions?: string[];
  success_indicators?: string[];
}

export type SketchGeneratorResponseDtoAllOfCourseName =
  (typeof SketchGeneratorResponseDtoAllOfCourseName)[keyof typeof SketchGeneratorResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SketchGeneratorResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type SketchGeneratorResponseDtoAllOf = {
  courseName?: SketchGeneratorResponseDtoAllOfCourseName;
  durationMinutes?: number;
  gradeLevel?: number;
  prompt?: string;
  topic?: string;
  ttsProvider?: string;
  videoOutput?: VideoGeneratorOutput;
  visualStyle?: string;
};

export type SketchGeneratorResponseDto = BaseTeacherToolResponseDto &
  SketchGeneratorResponseDtoAllOf;

export type RubricGeneratorResponseDto = BaseTeacherToolResponseDto &
  RubricGeneratorResponseDtoAllOf;

export type RubricGeneratorResponseDtoAllOfRubricType =
  (typeof RubricGeneratorResponseDtoAllOfRubricType)[keyof typeof RubricGeneratorResponseDtoAllOfRubricType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RubricGeneratorResponseDtoAllOfRubricType = {
  ANALYTIC: "ANALYTIC",
  HOLISTIC: "HOLISTIC",
} as const;

export type RubricGeneratorResponseDtoAllOfCourseName =
  (typeof RubricGeneratorResponseDtoAllOfCourseName)[keyof typeof RubricGeneratorResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RubricGeneratorResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type RubricGeneratorResponseDtoAllOfCefrLevel =
  (typeof RubricGeneratorResponseDtoAllOfCefrLevel)[keyof typeof RubricGeneratorResponseDtoAllOfCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RubricGeneratorResponseDtoAllOfCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type RubricGeneratorResponseDtoAllOf = {
  additionalInfo?: string;
  assignmentInstructions?: string;
  cefrLevel?: RubricGeneratorResponseDtoAllOfCefrLevel;
  contextOfUse?: string;
  courseName?: RubricGeneratorResponseDtoAllOfCourseName;
  criteria?: CriteriaItem[];
  evaluationCriteria?: string[];
  gradeLevel?: number;
  levelDescriptions?: string[];
  levelNames?: string[];
  levels?: number;
  performanceLevelNames?: string[];
  prompt?: string;
  rubricType?: RubricGeneratorResponseDtoAllOfRubricType;
  scoreRanges?: ScoreRangeItem[];
  scoringDetails?: string;
  totalScore?: number;
};

export interface ReflectionQuestionItem {
  purpose?: string;
  question?: string;
}

export type RealWorldConnectionResponseDtoAllOfCourseName =
  (typeof RealWorldConnectionResponseDtoAllOfCourseName)[keyof typeof RealWorldConnectionResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RealWorldConnectionResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type RealWorldConnectionResponseDtoAllOf = {
  classroomImplementation?: string;
  connections?: ConnectionItem[];
  courseName?: RealWorldConnectionResponseDtoAllOfCourseName;
  gradeLevel?: number;
  implementationGuide?: string;
  prompt?: string;
  skillFocus?: string[];
  targetSkills?: string[];
  usageContext?: string;
  usagePurposes?: string[];
};

export type RealWorldConnectionResponseDto = BaseTeacherToolResponseDto &
  RealWorldConnectionResponseDtoAllOf;

export type ProjectBasedLearningResponseDtoAllOfCourseName =
  (typeof ProjectBasedLearningResponseDtoAllOfCourseName)[keyof typeof ProjectBasedLearningResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectBasedLearningResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ProjectBasedLearningResponseDtoAllOf = {
  assessment?: AssessmentItem;
  courseName?: ProjectBasedLearningResponseDtoAllOfCourseName;
  expectedProductTypes?: string;
  feedbackPoints?: string[];
  gradeLevel?: number;
  illDefinedCriteria?: string;
  peerSelfAssessment?: PeerSelfAssessmentItem;
  problemType?: string;
  processSteps?: string[];
  projectDuration?: string;
  projectProblem?: ProjectProblemItem;
  prompt?: string;
  realLifeConnection?: string;
  skillsToDevelop?: string;
};

export type ProjectBasedLearningResponseDto = BaseTeacherToolResponseDto &
  ProjectBasedLearningResponseDtoAllOf;

export interface ProcessStepItem {
  collaborative_interactions?: string;
  deliverables?: string;
  description?: string;
  step_number?: string;
  time_estimate?: string;
  title?: string;
}

export interface ProcessEvaluationCriteriaItem {
  criteria_name?: string;
  description?: string;
  evaluation_method?: string;
}

export type PodcastResponseDtoAllOfCefrLevel =
  (typeof PodcastResponseDtoAllOfCefrLevel)[keyof typeof PodcastResponseDtoAllOfCefrLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PodcastResponseDtoAllOfCefrLevel = {
  PRE_A1: "PRE_A1",
  A1: "A1",
  A2: "A2",
  B1: "B1",
  B2: "B2",
  C1: "C1",
  C2: "C2",
} as const;

export type PodcastResponseDtoAllOf = {
  cefrLevel?: PodcastResponseDtoAllOfCefrLevel;
  firstUserName?: string;
  name?: string;
  questions?: JsonNode;
  referencedPodcastId?: number;
  secondUserName?: string;
  topic?: string;
  transcript?: PodcastTranscriptItem[];
  url?: string;
};

export type PodcastResponseDto = BaseTeacherToolResponseDto &
  PodcastResponseDtoAllOf;

export type PerformanceTaskResponseDtoAllOfCourseName =
  (typeof PerformanceTaskResponseDtoAllOfCourseName)[keyof typeof PerformanceTaskResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PerformanceTaskResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type PerformanceTaskResponseDtoAllOf = {
  additionalInfo?: string;
  courseName?: PerformanceTaskResponseDtoAllOfCourseName;
  estimatedTime?: string;
  gradeLevel?: number;
  materialsNeeded?: string[];
  performanceCriteria?: string[];
  prompt?: string;
  studentInstructions?: string;
  taskDescription?: string;
  teacherNotes?: string;
};

export type PerformanceTaskResponseDto = BaseTeacherToolResponseDto &
  PerformanceTaskResponseDtoAllOf;

export interface PeerEvaluationQuestionItem {
  criteria?: string;
  question?: string;
  scale?: string;
}

export interface MisconceptionItem {
  clarification?: string;
  fix_strategies?: string;
  misconception?: string;
  real_classroom_example?: string;
  why_misconception_occurs?: string;
}

export interface MindmapNode {
  id?: string;
  parent_id?: string;
  text?: string;
  toolInfo?: MindmapNodeToolInfo;
}

export interface MindmapGeneratorWebhookRequestDto {
  actionName?: string;
  aiGeneratedDescription?: string;
  description?: string;
  execution_times?: JsonNode;
  executionTimes?: JsonNode;
  imageUrl?: string;
  input_token_count?: JsonNode;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  nodes?: MindmapNode[];
  output_token_count?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export type MindmapGeneratorResponseDtoAllOfCourseName =
  (typeof MindmapGeneratorResponseDtoAllOfCourseName)[keyof typeof MindmapGeneratorResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MindmapGeneratorResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type MindmapGeneratorResponseDtoAllOf = {
  courseName?: MindmapGeneratorResponseDtoAllOfCourseName;
  gradeLevel?: number;
  prompt?: string;
};

export type MindmapGeneratorResponseDto = BaseTeacherToolResponseDto &
  MindmapGeneratorResponseDtoAllOf;

export type LessonHookResponseDtoAllOfCourseName =
  (typeof LessonHookResponseDtoAllOfCourseName)[keyof typeof LessonHookResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonHookResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface LearningPhase {
  duration?: string;
  instructional_narrative?: string;
  phase_name?: string;
}

export interface InstructionalFlow {
  learning_phases?: LearningPhase[];
  pedagogical_approach?: string;
}

export type ImageGeneratorResponseDtoAllOfImageType =
  (typeof ImageGeneratorResponseDtoAllOfImageType)[keyof typeof ImageGeneratorResponseDtoAllOfImageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageGeneratorResponseDtoAllOfImageType = {
  POSTER: "POSTER",
  LOGO: "LOGO",
  INFOGRAPHIC: "INFOGRAPHIC",
  BADGE: "BADGE",
  CERTIFICATE: "CERTIFICATE",
  FLASHCARD: "FLASHCARD",
  SCENE: "SCENE",
  AVATAR: "AVATAR",
  LABEL: "LABEL",
  BANNER: "BANNER",
  DEFAULT: "DEFAULT",
} as const;

export type ImageGeneratorResponseDtoAllOf = {
  images?: GeneratedImageItem[];
  imageType?: ImageGeneratorResponseDtoAllOfImageType;
  isLiked?: boolean;
  promptHistory?: string[];
  selectedImage?: GeneratedImageItem;
};

export type ImageGeneratorResponseDto = BaseTeacherToolResponseDto &
  ImageGeneratorResponseDtoAllOf;

export interface HookItem {
  description?: string;
  expected_outcome?: string;
  materials_needed?: string;
  title?: string;
}

export type LessonHookResponseDtoAllOf = {
  courseName?: LessonHookResponseDtoAllOfCourseName;
  gradeLevel?: number;
  hooks?: HookItem[];
  prompt?: string;
};

export type LessonHookResponseDto = BaseTeacherToolResponseDto &
  LessonHookResponseDtoAllOf;

export type MindmapNodeToolInfo =
  | AiAssessmentScaleResponseDto
  | AiAssignmentResponseDto
  | AiResistantHomeworkResponseDto
  | AiSupportedTasksResponseDto
  | ArticleGeneratorResponseDto
  | BloomsTaxonomyActivitiesResponseDto
  | ChoiceBoardResponseDto
  | ClassroomManagementResponseDto
  | CollaborativeGroupWorkResponseDto
  | CommonMisconceptionResponseDto
  | ConceptualUnderstandingResponseDto
  | EssentialQuestionsResponseDto
  | ExitTicketGeneratorResponseDto
  | FormativeAssessmentResponseDto
  | HomeworkIdeaResponseDto
  | ImageGeneratorResponseDto
  | LessonHookResponseDto
  | MindmapGeneratorResponseDto
  | PerformanceTaskResponseDto
  | PodcastResponseDto
  | ProjectBasedLearningResponseDto
  | RealWorldConnectionResponseDto
  | RubricGeneratorResponseDto
  | SketchGeneratorResponseDto
  | SummarizerResponseDto
  | TextLevelerResponseDto
  | TransferActivityResponseDto
  | UdlChoiceBoardResponseDto
  | VideoAvatarResponseDto
  | VocabularyListResponseDto;

export interface HomeworkResources {
  digital_resources?: string[];
  printed_materials?: string[];
  tools_and_materials?: string[];
}

export type HomeworkIdeaResponseDtoAllOfCourseName =
  (typeof HomeworkIdeaResponseDtoAllOfCourseName)[keyof typeof HomeworkIdeaResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HomeworkIdeaResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface HomeworkIdeaItem {
  complexity_level?: string;
  description?: string;
  estimated_time?: string;
  outline?: string;
  purpose_alignment?: string;
  recommended_resources?: string[];
  resources?: HomeworkResources;
  student_criteria?: StudentCriteria;
  teacher_guidelines?: TeacherGuidelines;
  title?: string;
}

export type HomeworkIdeaResponseDtoAllOf = {
  courseName?: HomeworkIdeaResponseDtoAllOfCourseName;
  customDuration?: string;
  difficultyLevel?: string;
  estimatedDuration?: number;
  evaluationGuidelines?: EvaluationGuidelines;
  gradeLevel?: number;
  homeworkPurpose?: string;
  prompt?: string;
  reportIdeas?: HomeworkIdeaItem[];
  resourcePreferences?: string[];
  workType?: string;
};

export type HomeworkIdeaResponseDto = BaseTeacherToolResponseDto &
  HomeworkIdeaResponseDtoAllOf;

export interface GroupRolesItem {
  responsibilities?: string;
  skills_developed?: string;
  title?: string;
}

export interface GeneratedImageItem {
  aspectRatio?: string;
  imageUrl?: string;
  prompt?: string;
  uuid?: string;
  wordAlternatives?: WordAlternatives[];
}

export type FormativeAssessmentResponseDtoAllOfCourseName =
  (typeof FormativeAssessmentResponseDtoAllOfCourseName)[keyof typeof FormativeAssessmentResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormativeAssessmentResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type FormativeAssessmentResponseDtoAllOf = {
  additionalInfo?: string;
  assessmentMethodology?: string[];
  assessmentTool?: string;
  assessmentType?: string;
  classProfile?: string;
  classSize?: string;
  courseName?: FormativeAssessmentResponseDtoAllOfCourseName;
  gradeLevel?: number;
  implementationDuration?: string;
  instructionalFlow?: InstructionalFlow;
  learningReflection?: string[];
  pedagogicalFeedback?: string[];
  process?: string;
  prompt?: string;
  studentReflection?: string;
  teacherFeedback?: string;
};

export type FormativeAssessmentResponseDto = BaseTeacherToolResponseDto &
  FormativeAssessmentResponseDtoAllOf;

export interface ExitTicketItem {
  possible_responses?: string[];
  recommended_format?: string;
  ticket_prompt?: string;
  ticket_title?: string;
}

export type ExitTicketGeneratorResponseDtoAllOfCourseName =
  (typeof ExitTicketGeneratorResponseDtoAllOfCourseName)[keyof typeof ExitTicketGeneratorResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExitTicketGeneratorResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ExitTicketGeneratorResponseDtoAllOf = {
  courseName?: ExitTicketGeneratorResponseDtoAllOfCourseName;
  exitTickets?: ExitTicketItem[];
  gradeLevel?: number;
  prompt?: string;
  referencedToolId?: number;
};

export type ExitTicketGeneratorResponseDto = BaseTeacherToolResponseDto &
  ExitTicketGeneratorResponseDtoAllOf;

export interface EvaluationGuidelines {
  focusAreas?: string[];
  includeStudentCriteria?: boolean;
  includeTeacherGuidelines?: boolean;
}

export type EssentialQuestionsResponseDtoAllOfCourseName =
  (typeof EssentialQuestionsResponseDtoAllOfCourseName)[keyof typeof EssentialQuestionsResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EssentialQuestionsResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type EssentialQuestionsResponseDtoAllOf = {
  activitySuggestions?: ActivitySuggestionItem[];
  additionalInfo?: string;
  courseName?: EssentialQuestionsResponseDtoAllOfCourseName;
  gradeLevel?: number;
  prompt?: string;
  questions?: string[];
};

export type EssentialQuestionsResponseDto = BaseTeacherToolResponseDto &
  EssentialQuestionsResponseDtoAllOf;

export type ConceptualUnderstandingResponseDtoAllOfCourseName =
  (typeof ConceptualUnderstandingResponseDtoAllOfCourseName)[keyof typeof ConceptualUnderstandingResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConceptualUnderstandingResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface ConceptualActivitiesItem {
  description?: string;
  title?: string;
}

export type ConceptualUnderstandingResponseDtoAllOf = {
  conceptualActivities?: ConceptualActivitiesItem[];
  courseName?: ConceptualUnderstandingResponseDtoAllOfCourseName;
  gradeLevel?: number;
  prompt?: string;
};

export type ConceptualUnderstandingResponseDto = BaseTeacherToolResponseDto &
  ConceptualUnderstandingResponseDtoAllOf;

export type CommonMisconceptionResponseDtoAllOfCourseName =
  (typeof CommonMisconceptionResponseDtoAllOfCourseName)[keyof typeof CommonMisconceptionResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommonMisconceptionResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type CommonMisconceptionResponseDtoAllOf = {
  assessmentStrategies?: AssessmentStrategies;
  courseName?: CommonMisconceptionResponseDtoAllOfCourseName;
  gradeLevel?: number;
  misconceptions?: MisconceptionItem[];
  prompt?: string;
};

export type CommonMisconceptionResponseDto = BaseTeacherToolResponseDto &
  CommonMisconceptionResponseDtoAllOf;

export type CollaborativeGroupWorkResponseDtoAllOfCourseName =
  (typeof CollaborativeGroupWorkResponseDtoAllOfCourseName)[keyof typeof CollaborativeGroupWorkResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollaborativeGroupWorkResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type CollaborativeGroupWorkResponseDtoAllOf = {
  availableMaterials?: string[];
  classroomEnvironment?: string;
  courseName?: CollaborativeGroupWorkResponseDtoAllOfCourseName;
  evaluationTypes?: string[];
  gradeLevel?: number;
  groupRoles?: GroupRolesItem[];
  interactionStyle?: string;
  peerEvaluationQuestions?: PeerEvaluationQuestionItem[];
  physicalLayout?: string;
  previousCollaborationExperience?: string;
  processEvaluationCriteria?: ProcessEvaluationCriteriaItem[];
  processSteps?: ProcessStepItem[];
  prompt?: string;
  reflectionQuestions?: ReflectionQuestionItem[];
  sessionDuration?: string;
  studentSocialSkills?: string;
  studentsPerGroup?: number;
  targetSkills?: string[];
  teacherEvaluationQuestions?: TeacherEvaluationQuestionItem[];
  teacherRole?: string;
  teacherRoleDescription?: string;
};

export type CollaborativeGroupWorkResponseDto = BaseTeacherToolResponseDto &
  CollaborativeGroupWorkResponseDtoAllOf;

export type ClassroomManagementResponseDto = BaseTeacherToolResponseDto &
  ClassroomManagementResponseDtoAllOf;

export type ClassroomManagementResponseDtoAllOfCourseName =
  (typeof ClassroomManagementResponseDtoAllOfCourseName)[keyof typeof ClassroomManagementResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassroomManagementResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface ClassroomManagementItem {
  additional_suggestions?: string[];
  description?: string;
  implementation_steps?: string[];
  parent_communication_tips?: string[];
  title?: string;
}

export type ClassroomManagementResponseDtoAllOf = {
  classroomManagementGoal?: string;
  classSize?: string;
  courseName?: ClassroomManagementResponseDtoAllOfCourseName;
  gradeLevel?: number;
  problemCategory?: string;
  problemDescription?: string;
  problemSubcategory?: string;
  prompt?: string;
  strategies?: ClassroomManagementItem[];
  teachingToolsUsed?: string;
};

export type ChoiceBoardResponseDtoAllOfCourseName =
  (typeof ChoiceBoardResponseDtoAllOfCourseName)[keyof typeof ChoiceBoardResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChoiceBoardResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type ChoiceBoardResponseDtoAllOf = {
  activities?: ActivityItem[];
  choiceBoardInstructions?: string;
  courseName?: ChoiceBoardResponseDtoAllOfCourseName;
  difficultyDistribution?: string;
  gradeLevel?: number;
  learningOutcomesFocus?: string[];
  preferredLearningStyles?: string[];
  prompt?: string;
  selectionRequirements?: string;
};

export type ChoiceBoardResponseDto = BaseTeacherToolResponseDto &
  ChoiceBoardResponseDtoAllOf;

export type BloomsTaxonomyActivitiesResponseDtoAllOfCourseName =
  (typeof BloomsTaxonomyActivitiesResponseDtoAllOfCourseName)[keyof typeof BloomsTaxonomyActivitiesResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BloomsTaxonomyActivitiesResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface BloomsTaxonomyActivitiesActivityItem {
  activity_title?: string;
  ai_integration?: string;
  assessment_criteria?: string[];
  deliverables?: string;
  description?: string;
  human_skills_focus?: string;
  instructions?: string[];
  level?: string;
}

export type BloomsTaxonomyActivitiesResponseDtoAllOf = {
  activities?: BloomsTaxonomyActivitiesActivityItem[];
  courseName?: BloomsTaxonomyActivitiesResponseDtoAllOfCourseName;
  gradeLevel?: number;
  implementationNotes?: string[];
  prompt?: string;
};

export type BloomsTaxonomyActivitiesResponseDto = BaseTeacherToolResponseDto &
  BloomsTaxonomyActivitiesResponseDtoAllOf;

export type BaseTeacherToolResponseDtoToolType =
  (typeof BaseTeacherToolResponseDtoToolType)[keyof typeof BaseTeacherToolResponseDtoToolType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseTeacherToolResponseDtoToolType = {
  AI_ASSESSMENT_SCALE: "AI_ASSESSMENT_SCALE",
  AI_ASSIGNMENT: "AI_ASSIGNMENT",
  AI_RESISTANT_HOMEWORK: "AI_RESISTANT_HOMEWORK",
  AI_SUPPORTED_TASKS: "AI_SUPPORTED_TASKS",
  BLOOMS_TAXONOMY_ACTIVITIES: "BLOOMS_TAXONOMY_ACTIVITIES",
  CHOICE_BOARD: "CHOICE_BOARD",
  CLASSROOM_MANAGEMENT: "CLASSROOM_MANAGEMENT",
  COLLABORATIVE_GROUP_WORK: "COLLABORATIVE_GROUP_WORK",
  COMMON_MISCONCEPTION: "COMMON_MISCONCEPTION",
  CONCEPTUAL_UNDERSTANDING: "CONCEPTUAL_UNDERSTANDING",
  ESSENTIAL_QUESTIONS: "ESSENTIAL_QUESTIONS",
  EXIT_TICKET_GENERATOR: "EXIT_TICKET_GENERATOR",
  FORMATIVE_ASSESSMENT: "FORMATIVE_ASSESSMENT",
  HOMEWORK_IDEA: "HOMEWORK_IDEA",
  IMAGE_GENERATOR: "IMAGE_GENERATOR",
  LESSON_HOOK: "LESSON_HOOK",
  MINDMAP_GENERATOR: "MINDMAP_GENERATOR",
  PERFORMANCE_TASK: "PERFORMANCE_TASK",
  PODCAST: "PODCAST",
  PROJECT_BASED_LEARNING: "PROJECT_BASED_LEARNING",
  REAL_WORLD_CONNECTION: "REAL_WORLD_CONNECTION",
  RUBRIC_GENERATOR: "RUBRIC_GENERATOR",
  SUMMARIZER: "SUMMARIZER",
  TEXT_LEVELER: "TEXT_LEVELER",
  TRANSFER_ACTIVITY: "TRANSFER_ACTIVITY",
  UDL_CHOICE_BOARD: "UDL_CHOICE_BOARD",
  VOCABULARY_LIST: "VOCABULARY_LIST",
  HEYGEN_AVATAR: "HEYGEN_AVATAR",
  ARTICLE_GENERATOR: "ARTICLE_GENERATOR",
  SKETCH_GENERATOR: "SKETCH_GENERATOR",
} as const;

export type BaseTeacherToolResponseDtoStatus =
  (typeof BaseTeacherToolResponseDtoStatus)[keyof typeof BaseTeacherToolResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseTeacherToolResponseDtoStatus = {
  PROCESSING: "PROCESSING",
  REGENERATING: "REGENERATING",
  READY: "READY",
  FAILED: "FAILED",
} as const;

export type BaseTeacherToolResponseDtoContentLanguage =
  (typeof BaseTeacherToolResponseDtoContentLanguage)[keyof typeof BaseTeacherToolResponseDtoContentLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseTeacherToolResponseDtoContentLanguage = {
  tr: "tr",
  en: "en",
  de: "de",
  fr: "fr",
  it: "it",
  es: "es",
} as const;

export type BaseTeacherToolResponseDtoApprovalStatus =
  (typeof BaseTeacherToolResponseDtoApprovalStatus)[keyof typeof BaseTeacherToolResponseDtoApprovalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseTeacherToolResponseDtoApprovalStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const;

export interface BaseTeacherToolResponseDto {
  approvalStatus: BaseTeacherToolResponseDtoApprovalStatus;
  authorId: number;
  authorName: string;
  contentLanguage?: BaseTeacherToolResponseDtoContentLanguage;
  createdAt: string;
  description?: string;
  didUserLiked?: boolean;
  id: number;
  imageUrl?: string;
  isPublic: boolean;
  likeCount: number;
  status?: BaseTeacherToolResponseDtoStatus;
  teacherDocuments?: TeacherDocumentResponseDto[];
  title?: string;
  toolType?: BaseTeacherToolResponseDtoToolType;
  totalToolSuggestion?: number;
  videoUrl?: string;
}

export interface AssessmentStrategies {
  detection_methods?: string[];
  re_evaluation_methods?: string[];
}

export interface AssessmentLevel {
  description?: string;
  examples?: string[];
  level_name?: string;
  level_number?: number;
}

export type ArticleGeneratorResponseDtoAllOfGenerationMode =
  (typeof ArticleGeneratorResponseDtoAllOfGenerationMode)[keyof typeof ArticleGeneratorResponseDtoAllOfGenerationMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleGeneratorResponseDtoAllOfGenerationMode = {
  PROMPT: "PROMPT",
  REFORMAT: "REFORMAT",
} as const;

export type ArticleGeneratorResponseDtoAllOf = {
  articleContentJson?: JsonNode;
  generationMode?: ArticleGeneratorResponseDtoAllOfGenerationMode;
  rawArticle?: string;
};

export type ArticleGeneratorResponseDto = BaseTeacherToolResponseDto &
  ArticleGeneratorResponseDtoAllOf;

export type AiSupportedTasksResponseDtoAllOfCourseName =
  (typeof AiSupportedTasksResponseDtoAllOfCourseName)[keyof typeof AiSupportedTasksResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiSupportedTasksResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface AiSupportedTaskStep {
  description?: string;
  examplePrompts?: string[];
  id?: number;
  instructions?: string;
  title?: string;
}

export type AiSupportedTasksResponseDtoAllOf = {
  assessmentRubric?: AiSupportedTaskRubricCriteria[];
  benefits?: string[];
  context?: string;
  courseName?: AiSupportedTasksResponseDtoAllOfCourseName;
  expectedOutput?: AiSupportedTaskExpectedOutput;
  gradeLevel?: number;
  learningObjectives?: string[];
  notes?: AiSupportedTaskNotes;
  prompt?: string;
  recommendedAiPlatform?: AiSupportedTaskAiPlatform;
  researchProcessDescription?: string;
  steps?: AiSupportedTaskStep[];
};

export type AiSupportedTasksResponseDto = BaseTeacherToolResponseDto &
  AiSupportedTasksResponseDtoAllOf;

export interface AiSupportedTaskRubricLevel {
  description?: string;
  score?: number;
}

export interface AiSupportedTaskRubricCriteria {
  description?: string;
  levels?: AiSupportedTaskRubricLevel[];
  name?: string;
}

export interface AiSupportedTaskNotes {
  forStudents?: string[];
  forTeachers?: string[];
}

export interface AiSupportedTaskExpectedOutputSection {
  description?: string;
  format?: string;
  title?: string;
  wordCount?: string;
}

export interface AiSupportedTaskExpectedOutput {
  format?: string;
  sections?: AiSupportedTaskExpectedOutputSection[];
}

export interface AiSupportedTaskAiPlatform {
  description?: string;
  link?: string;
  title?: string;
}

export type AiResistantHomeworkResponseDtoAllOfCourseName =
  (typeof AiResistantHomeworkResponseDtoAllOfCourseName)[keyof typeof AiResistantHomeworkResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiResistantHomeworkResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export interface AiResistantHomeworkReportIdea {
  complexity_level?: string;
  description?: string;
  estimated_time?: string;
  explanation?: string;
  purpose_alignment?: string;
  recommended_resources?: string[];
  resources?: HomeworkResources;
  student_criteria?: StudentCriteria;
  teacher_guidelines?: TeacherGuidelines;
  title?: string;
}

export type AiResistantHomeworkResponseDtoAllOf = {
  courseName?: AiResistantHomeworkResponseDtoAllOfCourseName;
  customDuration?: string;
  difficultyLevel?: string;
  estimatedDuration?: number;
  evaluationGuidelines?: EvaluationGuidelines;
  gradeLevel?: number;
  homeworkPurpose?: string;
  prompt?: string;
  reportIdeas?: AiResistantHomeworkReportIdea[];
  resourcePreferences?: string[];
  workType?: string;
};

export type AiResistantHomeworkResponseDto = BaseTeacherToolResponseDto &
  AiResistantHomeworkResponseDtoAllOf;

export type AiAssignmentResponseDto = BaseTeacherToolResponseDto &
  AiAssignmentResponseDtoAllOf;

export type AiAssignmentResponseDtoAllOfCourseName =
  (typeof AiAssignmentResponseDtoAllOfCourseName)[keyof typeof AiAssignmentResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssignmentResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type AiAssignmentResponseDtoAllOfAssignmentCategory =
  (typeof AiAssignmentResponseDtoAllOfAssignmentCategory)[keyof typeof AiAssignmentResponseDtoAllOfAssignmentCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssignmentResponseDtoAllOfAssignmentCategory = {
  GREEN_LIGHT: "GREEN_LIGHT",
  RED_LIGHT_GREEN_LIGHT: "RED_LIGHT_GREEN_LIGHT",
  HUMAN_CRITIQUE_AI: "HUMAN_CRITIQUE_AI",
  AI_CRITIQUE_HUMAN: "AI_CRITIQUE_HUMAN",
  CO_CREATION: "CO_CREATION",
} as const;

export interface AiAssignmentGradingRubricItem {
  criterion?: string;
  description?: string;
  levels?: string[];
  weights?: number;
}

export type AiAssignmentResponseDtoAllOf = {
  aiPromptExamples?: string[];
  assignmentCategory?: AiAssignmentResponseDtoAllOfAssignmentCategory;
  courseName?: AiAssignmentResponseDtoAllOfCourseName;
  gradeLevel?: number;
  gradingRubric?: AiAssignmentGradingRubricItem[];
  implementationSteps?: string[];
  prompt?: string;
  reflectionQuestions?: string[];
  studentInstructions?: string;
};

export type AiAssessmentScaleResponseDtoAllOfCourseName =
  (typeof AiAssessmentScaleResponseDtoAllOfCourseName)[keyof typeof AiAssessmentScaleResponseDtoAllOfCourseName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiAssessmentScaleResponseDtoAllOfCourseName = {
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  PHILOSOPHY: "PHILOSOPHY",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  UNKNOWN: "UNKNOWN",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type AiAssessmentScaleResponseDtoAllOf = {
  additionalInfo?: string;
  courseName?: AiAssessmentScaleResponseDtoAllOfCourseName;
  gradeLevel?: number;
  levels?: AssessmentLevel[];
  prompt?: string;
};

export type AiAssessmentScaleResponseDto = BaseTeacherToolResponseDto &
  AiAssessmentScaleResponseDtoAllOf;

export interface ActivitySuggestionItem {
  description?: string;
  title?: string;
}

export interface ActivityItem {
  detail?: string;
  difficulty_level?: string;
  learning_outcomes?: string[];
  learning_style?: string;
  skills_developed?: string[];
  title?: string;
}

export interface PerformanceTaskWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  estimated_time?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  materials_needed?: string[];
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  performance_criteria?: string[];
  promptVersion?: number;
  regenChatId?: number;
  student_instructions?: string;
  task_description?: string;
  teacher_notes?: string;
  title?: string;
}

export interface PodcastTranscriptItem {
  displayName?: string;
  id?: number;
  message?: string;
  name?: string;
  startTimeSeconds?: number;
}

export interface PodcastWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  questions?: JsonNode;
  regenChatId?: number;
  title?: string;
  transcript?: PodcastTranscriptItem[];
}

export interface RubricItem {
  criterion?: string;
  levels?: string[];
}

export interface ProjectProblemItem {
  questions?: string[];
}

export interface PeerSelfAssessmentItem {
  peer_review_questions?: string[];
  self_reflection_questions?: string[];
}

export interface AssessmentItem {
  criteria?: string[];
  rubric?: RubricItem[];
}

export interface ProjectBasedLearningWebhookRequestDto {
  aiGeneratedDescription?: string;
  assessment?: AssessmentItem;
  description?: string;
  executionTimes?: JsonNode;
  feedback_points?: string[];
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  peer_self_assessment?: PeerSelfAssessmentItem;
  process_steps?: string[];
  project_problem?: ProjectProblemItem;
  promptVersion?: number;
  real_life_connection?: string;
  regenChatId?: number;
  title?: string;
}

export type PronunciationItemTtsAlignment = { [key: string]: unknown };

export interface PronunciationItem {
  id: number;
  image_url?: string;
  text: string;
  tts_alignment?: PronunciationItemTtsAlignment;
  ttsUrl?: string;
}

export interface UpdateItemsRequestDto {
  items: PronunciationItem[];
  title?: string;
}

export interface QuestionExplanationSuccessRequestDto {
  answerExplanation?: string;
  answerScore?: number;
  assignmentId?: number;
  executionTimes?: JsonNode;
  explanation?: string;
  feedback?: string;
  inputTokenCount?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  questionId?: number;
  studentAnswerExplanation?: string;
  userId?: number;
}

export type UpdateQuestionRegenRequestDtoNewQuestionType =
  (typeof UpdateQuestionRegenRequestDtoNewQuestionType)[keyof typeof UpdateQuestionRegenRequestDtoNewQuestionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuestionRegenRequestDtoNewQuestionType = {
  TF: "TF",
  TEST: "TEST",
  OE: "OE",
  FB: "FB",
  MATCH: "MATCH",
} as const;

export interface UpdateQuestionRegenRequestDto {
  newQuestionType?: UpdateQuestionRegenRequestDtoNewQuestionType;
  questionJson?: JsonNode;
}

export type QuestionSolverWebhookRequestBodyDtoLevel =
  (typeof QuestionSolverWebhookRequestBodyDtoLevel)[keyof typeof QuestionSolverWebhookRequestBodyDtoLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSolverWebhookRequestBodyDtoLevel = {
  EASY: "EASY",
  MEDIUM: "MEDIUM",
  HARD: "HARD",
} as const;

export type QuestionSolverWebhookRequestBodyDtoCourse =
  (typeof QuestionSolverWebhookRequestBodyDtoCourse)[keyof typeof QuestionSolverWebhookRequestBodyDtoCourse];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSolverWebhookRequestBodyDtoCourse = {
  UNKNOWN: "UNKNOWN",
  ENGLISH: "ENGLISH",
  SCIENCE: "SCIENCE",
  HISTORY: "HISTORY",
  GEOGRAPHY: "GEOGRAPHY",
  TURKISH: "TURKISH",
  MATHEMATICS: "MATHEMATICS",
  BIOLOGY: "BIOLOGY",
  CHEMISTRY: "CHEMISTRY",
  PHYSICS: "PHYSICS",
  RELIGION: "RELIGION",
  CITIZENSHIP: "CITIZENSHIP",
  PHILOSOPHY: "PHILOSOPHY",
  DIGITAL_CITIZENSHIP: "DIGITAL_CITIZENSHIP",
  BILISIM: "BILISIM",
  TEKNOLOJI_TASARIM: "TEKNOLOJI_TASARIM",
  AP_ASTRONOMY: "AP_ASTRONOMY",
  AP_PSYCHOLOGY: "AP_PSYCHOLOGY",
  AP_BUSINESS: "AP_BUSINESS",
  AP_ECONOMICS: "AP_ECONOMICS",
  AP_SOCIOLOGY: "AP_SOCIOLOGY",
  AP_WORLD_HISTORY_1: "AP_WORLD_HISTORY_1",
  AP_WORLD_HISTORY_2: "AP_WORLD_HISTORY_2",
  AP_BIOLOGY: "AP_BIOLOGY",
  AP_CHEMISTRY: "AP_CHEMISTRY",
  AP_PHYSICS: "AP_PHYSICS",
  AP_2025_BIOLOGY: "AP_2025_BIOLOGY",
  AP_2025_CALCULUS_AB_AND_BC: "AP_2025_CALCULUS_AB_AND_BC",
  AP_2025_CHEMISTRY: "AP_2025_CHEMISTRY",
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS:
    "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
  AP_2025_COMPUTER_SCIENCE_A: "AP_2025_COMPUTER_SCIENCE_A",
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
  AP_2025_ENVIRONMENTAL_SCIENCE: "AP_2025_ENVIRONMENTAL_SCIENCE",
  AP_2025_EUROPEAN_HISTORY: "AP_2025_EUROPEAN_HISTORY",
  AP_2025_HUMAN_GEOGRAPHY: "AP_2025_HUMAN_GEOGRAPHY",
  AP_2025_MACROECONOMICS: "AP_2025_MACROECONOMICS",
  AP_2025_MICROECONOMICS: "AP_2025_MICROECONOMICS",
  AP_2025_PHYSICS_1: "AP_2025_PHYSICS_1",
  AP_2025_PHYSICS_2: "AP_2025_PHYSICS_2",
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM:
    "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
  AP_2025_PHYSICS_C_MECHANICS: "AP_2025_PHYSICS_C_MECHANICS",
  AP_2025_PRECALCULUS: "AP_2025_PRECALCULUS",
  AP_2025_PSYCHOLOGY: "AP_2025_PSYCHOLOGY",
  AP_2025_STATISTICS: "AP_2025_STATISTICS",
  AP_2025_WORLD_HISTORY_MODERN: "AP_2025_WORLD_HISTORY_MODERN",
  IGCSE_BIOLOGY: "IGCSE_BIOLOGY",
  IGCSE_PHYSICS: "IGCSE_PHYSICS",
  IGCSE_CHEMISTRY: "IGCSE_CHEMISTRY",
  IGCSE_BUSINESS_STUDIES: "IGCSE_BUSINESS_STUDIES",
  IGCSE_ECONOMICS: "IGCSE_ECONOMICS",
  IGCSE_COMPUTER_SCIENCE: "IGCSE_COMPUTER_SCIENCE",
  IGCSE_GEOGRAPHY: "IGCSE_GEOGRAPHY",
  IGCSE_HISTORY: "IGCSE_HISTORY",
  IGCSE_MATHEMATICS: "IGCSE_MATHEMATICS",
  IB_DP_GEOGRAPHY: "IB_DP_GEOGRAPHY",
  IB_DP_CHEMISTRY: "IB_DP_CHEMISTRY",
  IB_DP_BUSINESS_MANAGEMENT: "IB_DP_BUSINESS_MANAGEMENT",
  IB_DP_ECONOMICS: "IB_DP_ECONOMICS",
  IB_DP_BIOLOGY: "IB_DP_BIOLOGY",
  IB_DP_HISTORY: "IB_DP_HISTORY",
  IB_DP_PHYSICS: "IB_DP_PHYSICS",
  IB_DP_MATHEMATICS: "IB_DP_MATHEMATICS",
  IB_DP_COMPUTER_SCIENCE: "IB_DP_COMPUTER_SCIENCE",
  ALEVEL_BIOLOGY: "ALEVEL_BIOLOGY",
  ALEVEL_BUSSINESS: "ALEVEL_BUSSINESS",
  ALEVEL_CHEMISTRY: "ALEVEL_CHEMISTRY",
  ALEVEL_COMPUTER_SCIENCE: "ALEVEL_COMPUTER_SCIENCE",
  ALEVEL_ECONOMICS: "ALEVEL_ECONOMICS",
  ALEVEL_EUROPEAN_HISTORY: "ALEVEL_EUROPEAN_HISTORY",
  ALEVEL_FURTHER_MATHEMATICS: "ALEVEL_FURTHER_MATHEMATICS",
  ALEVEL_GEOGRAPHY: "ALEVEL_GEOGRAPHY",
  ALEVEL_INTERNATIONAL_HISTORY: "ALEVEL_INTERNATIONAL_HISTORY",
  ALEVEL_MATHEMATICS: "ALEVEL_MATHEMATICS",
  ALEVEL_PHYSICS: "ALEVEL_PHYSICS",
  ALEVEL_SOCIOLOGY: "ALEVEL_SOCIOLOGY",
  ALEVEL_US_HISTORY_SINCE_1877: "ALEVEL_US_HISTORY_SINCE_1877",
  ALEVEL_US_HISTORY_TO_1877: "ALEVEL_US_HISTORY_TO_1877",
  MONTH_36_48: "MONTH_36_48",
  MONTH_48_60: "MONTH_48_60",
} as const;

export type QuestionSolverWebhookRequestBodyDtoAction =
  (typeof QuestionSolverWebhookRequestBodyDtoAction)[keyof typeof QuestionSolverWebhookRequestBodyDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionSolverWebhookRequestBodyDtoAction = {
  FAILURE: "FAILURE",
  FLASHCARD_SUCCESS: "FLASHCARD_SUCCESS",
  IDENTIFY_LESSON_SUCCESS: "IDENTIFY_LESSON_SUCCESS",
  IDENTIFY_LESSON_FAILURE: "IDENTIFY_LESSON_FAILURE",
  OUTLINE_OF_STEPS_SUCCESS: "OUTLINE_OF_STEPS_SUCCESS",
  COMPILED_RESULT_SUCCESS: "COMPILED_RESULT_SUCCESS",
} as const;

export interface FlashcardItem {
  back?: string;
  front?: string;
}

export interface QuestionSolverWebhookRequestBodyDto {
  action?: QuestionSolverWebhookRequestBodyDtoAction;
  audioUrl?: string;
  compiledResponse?: string;
  course?: QuestionSolverWebhookRequestBodyDtoCourse;
  executionTimes?: JsonNode;
  flashcards?: FlashcardItem[];
  inputTokenCount?: JsonNode;
  level?: QuestionSolverWebhookRequestBodyDtoLevel;
  outlineOfSteps?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  queries?: JsonNode;
  title?: string;
}

export type ConnectionItemProfessionDetails = { [key: string]: string };

export interface ConnectionItem {
  classroom_activities?: string[];
  context_description?: string;
  profession_details?: ConnectionItemProfessionDetails;
  professions?: string[];
  real_world_application?: string;
  skill_development?: string[];
  title?: string;
}

export interface RealWorldConnectionWebhookRequestDto {
  aiGeneratedDescription?: string;
  connections?: ConnectionItem[];
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  implementation_guide?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  skill_focus?: string[];
  title?: string;
  usage_context?: string;
}

export interface RubricMetadata {
  has_scores?: boolean;
  max_score_per_criterion?: number;
  title?: string;
  type?: string;
}

export interface Level {
  description?: string;
  score?: number;
}

export interface Criterion {
  description?: string;
  levels?: Level[];
  max_score?: number;
  name?: string;
}

export interface EssayGraderRubricAnalyzerResult {
  criteria?: Criterion[];
  instructions_assignment_details?: string;
  instructions_evaluation_focus?: string;
  instructions_topic?: string;
  is_rubric?: boolean;
  language?: string;
  rubric_metadata?: RubricMetadata;
}

export interface ScoreRangeItem {
  max?: number;
  min?: number;
}

export interface CriteriaItem {
  criterion?: string;
  level_descriptors?: string[];
  level_scores?: number[];
  weight?: number;
}

export interface RubricGeneratorWebhookRequestDto {
  aiGeneratedDescription?: string;
  criteria?: CriteriaItem[];
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  level_descriptions?: string[];
  level_names?: string[];
  levels?: number;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  rubric_type?: string;
  score_ranges?: ScoreRangeItem[];
  title?: string;
  total_score?: number;
}

export interface VideoGeneratorOutput {
  fileSizeMb?: number;
  language?: string;
  timingMetadata?: JsonNode;
  videoUrl?: string;
}

export interface SketchGeneratorWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  output?: VideoGeneratorOutput;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface SlideGeneratorOutlineWebhookRequestBodyDto {
  actionName?: string;
  outline?: OutlineData;
}

export interface SectionContent {
  key_points?: string[];
  title?: string;
}

export type OutlineDataOutline = { [key: string]: SectionContent };

export interface OutlineData {
  course?: string;
  grade?: string;
  outline?: OutlineDataOutline;
  topic?: string;
}

export interface TimelineEvent {
  description?: string;
  title?: string;
  year?: string;
}

export interface StatItem {
  description?: string;
  label?: string;
  value?: string;
}

export interface Slide {
  content?: SlideContent;
  id?: string;
}

export interface SlideData {
  primaryColor?: string;
  slides?: Slide[];
}

export interface SlideGeneratorSlidesWebhookRequestBodyDto {
  actionName?: string;
  data?: SlideData;
}

export interface SideContent {
  points?: string[];
  title?: string;
}

export interface ContentSection {
  heading?: string;
  icon?: string;
  paragraphs?: string[];
  text?: string;
  title?: string;
}

export interface CaseStudyPoint {
  text?: string;
  title?: string;
}

export interface SlideContent {
  author?: string;
  conclusion?: string;
  conclusionTitle?: string;
  content?: string;
  context?: string;
  events?: TimelineEvent[];
  items?: string[];
  keyPoints?: string[];
  leftSide?: SideContent;
  mainEmoji?: string;
  points?: CaseStudyPoint[];
  quote?: string;
  rightSide?: SideContent;
  sections?: ContentSection[];
  stats?: StatItem[];
  subtitle?: string;
  title?: string;
}

export interface SummarizerWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  markdown_summary?: string;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface TeacherChatAnalysisSuccessRequestDto {
  chatAnalysisSuccessInsideRequestDto?: TeacherChatAnalysisSuccessInsideRequestDto;
  chatlyAnalysisId?: number;
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
}

export interface TedLessonPlannerSteps {
  ders_no?: number;
  icerik?: string;
  id?: number;
  sure_dakika?: number;
  yontem_teknik?: string;
  zaman_dilimi?: string;
}

export interface TedLessonPlannerWebhookRequestDto {
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  name?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  steps?: TedLessonPlannerSteps[];
}

export interface TextLevelerWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  grade_level?: number;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  leveled_markdown?: string;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface ArticleGeneratorWebhookRequestDto {
  aiGeneratedDescription?: string;
  article_content_json?: JsonNode[];
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  mode?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
}

export interface UserMemoryItem {
  date?: string;
  id?: string;
  memory_item?: string;
}

export interface TeacherChatAnalysisSuccessInsideRequestDto {
  all_memory?: UserMemoryItem[];
}

export interface TopicMergerSuccessSingleItemRequestDto {
  all_memory?: UserMemoryItem[];
  chatly_analysis_id?: number;
  conversation_flow?: string;
  curiosity_and_interest_areas?: string[];
  topics?: JsonNode;
}

export interface TopicMergerSuccessRequestDto {
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  topicMergerResult?: TopicMergerSuccessSingleItemRequestDto[];
}

export interface TransferActivityWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  real_life_connection?: string;
  regenChatId?: number;
  student_task?: string;
  teacher_role?: string;
  title?: string;
}

export type UbdExpertWebhookRequestDtoStep =
  (typeof UbdExpertWebhookRequestDtoStep)[keyof typeof UbdExpertWebhookRequestDtoStep];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UbdExpertWebhookRequestDtoStep = {
  "11": "1.1",
  "12": "1.2",
  "13": "1.3",
  "14": "1.4",
  "15": "1.5",
  "21": "2.1",
  "22": "2.2",
  "23": "2.3",
  "31": "3.1",
  final: "final",
  "11_refine": "1.1_refine",
  "12_refine": "1.2_refine",
  "13_refine": "1.3_refine",
  "14_refine": "1.4_refine",
  "15_refine": "1.5_refine",
  "21_refine": "2.1_refine",
  "22_refine": "2.2_refine",
  "23_refine": "2.3_refine",
  "31_refine": "3.1_refine",
  final_refine: "final_refine",
} as const;

export type UbdExpertWebhookRequestDtoData = {
  [key: string]: { [key: string]: unknown };
};

export interface UbdExpertWebhookRequestDto {
  data?: UbdExpertWebhookRequestDtoData;
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  outputTokenCount?: JsonNode;
  plannerType?: string;
  promptVersion?: number;
  step?: UbdExpertWebhookRequestDtoStep;
  stepName?: string;
}

export interface ZamanRehberi {
  baslik?: string;
  dikkatNoktasi?: string;
  emoji?: string;
  ipucu?: string;
  ogrenciAksiyonlari?: string[];
  ogretmenAksiyonlari?: string[];
  zaman?: string;
}

export interface UbdOdak {
  aciklama?: string;
  baslik?: string;
  uygulama?: string;
}

export interface UbdMaarifWebhookRequestDto {
  anlamaHedefi?: string[];
  dersAkisi?: LessonFlow;
  digerKanitlar?: string[];
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  onemliSorular?: string[];
  outputTokenCount?: JsonNode;
  performansGorevleri?: string[];
  promptVersion?: string;
  transferHedefi?: string[];
}

export interface Soru {
  beklenenCevap?: string;
  kategori?: string;
  soru?: string;
  zorluk?: string;
}

export interface Senaryo {
  baslik?: string;
  durum?: string;
  emoji?: string;
  malzemeler?: string[];
  odak?: string;
  soru?: string;
  zorlukSeviyesi?: string;
}

export type LessonFlowTemplateTipi =
  (typeof LessonFlowTemplateTipi)[keyof typeof LessonFlowTemplateTipi];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonFlowTemplateTipi = {
  KLASIK_OGRETIM: "KLASIK_OGRETIM",
  OYUNLASTIRILMIS: "OYUNLASTIRILMIS",
  DENEYIM_ODAKLI: "DENEYIM_ODAKLI",
  ISBIRLIKLI: "ISBIRLIKLI",
} as const;

export interface EtkinlikDetay {
  aciklama?: string;
  adimlar?: string[];
  baslik?: string;
  emoji?: string;
  ipuclari?: string[];
  malzemeler?: string[];
  sure?: string;
  zorlukSeviyesi?: string;
}

export interface Etkinlik {
  aciklama?: string;
  baslik?: string;
  emoji?: string;
  etkinlikDetaylari?: EtkinlikDetay[];
  etkinlikId?: string;
  gerekliMalzemeler?: string[];
  senaryolar?: Senaryo[];
  soruBankası?: Soru[];
  sure?: number;
  tip?: string;
  ubdOdak?: UbdOdak;
  zamanRehberi?: ZamanRehberi[];
  zorlukSeviyesi?: string;
}

export interface LessonFlow {
  etkinlikler?: Etkinlik[];
  konu?: string;
  sinifSeviyesi?: number;
  templateTipi?: LessonFlowTemplateTipi;
  title?: string;
  toplamSure?: number;
}

export interface RepresentationOptions {
  description?: string;
  title?: string;
}

export interface ExpressionOptions {
  description?: string;
  title?: string;
}

export interface EngagementOptions {
  description?: string;
  title?: string;
}

export interface UdlChoiceBoardWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  engagement_options?: EngagementOptions[];
  executionTimes?: JsonNode;
  expression_options?: ExpressionOptions[];
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  representation_options?: RepresentationOptions[];
  title?: string;
}

export interface DocumentExtractorResponse {
  message?: string;
  s3_bucket?: string;
  s3_key?: string;
}

export interface VocabularyListItem {
  explanation?: string;
  id?: number;
  imageUrl?: string;
  usage?: string;
  word?: string;
}

export interface VocabularyImageItem {
  imageUrl?: string;
  vocabId?: number;
}

export interface WeeklyAnalysisSuccessInsideRequestDto {
  areas_for_improvement?: string;
  creative_insights?: string;
  cumulative_progress?: string;
  frequently_misunderstood_concepts?: FrequentlyMisunderstoodConcepts[];
  most_engaged_topics?: string[];
  notable_improvements?: string;
  persistent_struggles?: string;
  topics_requiring_further_review?: string[];
  weekly_feedback_from_engaged_topics?: string;
}

export interface JsonNode {
  [key: string]: unknown;
}

export interface VocabularyListWebhookRequestDto {
  aiGeneratedDescription?: string;
  description?: string;
  executionTimes?: JsonNode;
  imageUrl?: string;
  inputTokenCount?: JsonNode;
  isRegenerated?: boolean;
  mindmapId?: number;
  mindmapNodeId?: string;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  regenChatId?: number;
  title?: string;
  vocabulary?: VocabularyListItem[];
  vocabularyImage?: VocabularyImageItem;
}

export interface WeeklyAnalysisSuccessRequestDto {
  executionTimes?: JsonNode;
  inputTokenCount?: JsonNode;
  outputTokenCount?: JsonNode;
  promptVersion?: number;
  weeklyAnalysisId?: number;
  weeklyAnalysisSuccessInsideRequestDto?: WeeklyAnalysisSuccessInsideRequestDto;
}

export interface FrequentlyMisunderstoodConcepts {
  feedback?: string;
  topic?: string;
}

export interface BaseErrorResponseDto {
  message?: string;
}
